import axios from "axios";
import ToastDialog from "components/Common/ToastDialog";
import withRouter from "components/Common/withRouter";
import { useFormik, FieldArray, FormikProvider } from "formik";
import PropTypes from "prop-types";
import React, { useEffect, useState, useCallback } from "react";
import { confirmAlert } from "react-confirm-alert";
import { useNavigate } from "react-router-dom";
import Loader from "react-spinner-loader";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format, parse } from 'date-fns';
import * as Yup from "yup";
import "./main.scss";
import API_SERVICES from "constants/app.constants";
import {
  callGetCity,
  callGetState,
  getCpAnchor
} from "../../http/fundLync/entityAndAddress.helper";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  FormGroup,
  Button,
  Table,
  Modal,
  ModalHeader,
} from "reactstrap";
import { useAsyncDebounce } from "react-table";
import Select from "react-select";
//Import Breadcrumb
import Breadcrumbs from "components/Common/BreadcrumbTitle";

import {
  addDeal,
  addDealDraft,
  allEntity,
} from "../../http/fundLync/deal.helper";
import { getDropDownList } from "../../http/fundLync/dropdown.helper";
//redux
import { decryptedValue, isPermission, uId } from "common/utility";
import { callBankList, callFinancierList, callReferredFinancierList } from "http/fundLync/common.helper";
import { useDropzone } from "react-dropzone";
import { API_URL } from "../../http/url.helper";
import { callGetCIUser } from "http/fundLync/dealFinancier";
import {
  addShareholding,
  editShareholding,
  getShareholdingList,
} from "http/fundLync/entityAndAddress.helper";
import { formatDateString, formatDateString1 } from "../EntityDashboard/borrowingProfile";

const AddDeal = (props) => {
  document.title = "Add Deal | FundLync";
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const currentDate = new Date().toISOString().split("T")[0];

  const encodedId = urlParams.get("id");
  const decodedId = encodedId ? atob(encodedId) : null;

  const nonFinancierType = urlParams.get("nonFinancierType");
  const decodedNonFinancierType = nonFinancierType ? atob(nonFinancierType) : null;
  
  const selectedEntity = urlParams.get("entityName");
  const decodedSelectedEntityName = selectedEntity ? atob(selectedEntity) : null;

  const user = decryptedValue(localStorage.getItem("user"));
  const [toastInfo, setToastInfo] = useState({ showToast: false });

  const [isAdmin, setIsAdmin] = useState(false);
  const entity = null;
  const [entityList, setEntityList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [tenureList, setTenureList] = useState([]);
  const [loanTypeList, setLoanTypeList] = useState([]);
  const [securityCoverList, setSecurityCoverList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [loaderDraft, setLoaderDraft] = useState(false);

  const [guaranteeList, setGuaranteeList] = useState([]);
  const [entityArrangeList, setEntityArrangeList] = useState([]);
  const [entityGuaranteeList, setEntityGuaranteeList] = useState([]);
  const [entityArrangeListForVendor, setEntityArrangeListForVendor] = useState(
    []
  );
  const [endUseList, setEndUseList] = useState([]);
  const [productTypeList, setProductTypeList] = useState([]);
  const [primarySecurityList, setPrimarySecurityList] = useState([]);
  const [typeOfChargeList, setTypeOfChargeList] = useState([]);
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [isSelectedDpo, setIsSelectedDpo] = useState(false);
  const [selectedMulti1, setSelectedMulti1] = useState([]);
  const [selectedMulti2, setSelectedMulti2] = useState([]);
  const [selectedMulti3, setSelectedMulti3] = useState([]);
  const [selectedMulti4, setSelectedMulti4] = useState([]);
  const [selectedMulti5, setSelectedMulti5] = useState([]);
  const [selectedMulti6, setSelectedMulti6] = useState([]);
  const [selectedMulti7, setSelectedMulti7] = useState([]);
  const [selectedMulti8, setSelectedMulti8] = useState([]);
  const [selectedPrefFinancierMulti1, setSelectedPrefFinancierMulti1] = useState([]);
  const [selectedPrefFinancierMulti2, setSelectedPrefFinancierMulti2] = useState([]);
  const [selectedPrefFinancierMulti3, setSelectedPrefFinancierMulti3] = useState([]);
  const [selectedPrefFinancierMulti4, setSelectedPrefFinancierMulti4] = useState([]);
  const [selectedPrefFinancierMulti5, setSelectedPrefFinancierMulti5] = useState([]);
  const [selectedPrefFinancierMulti6, setSelectedPrefFinancierMulti6] = useState([]);
  const [selectedPrefFinancierMulti7, setSelectedPrefFinancierMulti7] = useState([]);
  const [selectedPrefFinancierMulti8, setSelectedPrefFinancierMulti8] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedEntityName, setSelectedEntityName] = useState("");
  const [selectedAnchorName, setSelectedAnchorName] = useState("");
  const [selectedBankName, setSelectedBankName] = useState("");
  const [selectedIsSecured, setSelectedIsSecured] = useState("");
  const [selectedFldg, setSelectedFldg] = useState("");
  const [selectedGuarantee, setSelectedGuarantee] = useState("");
  const [dealerfinancingArrangement, setDealerfinancingArrangement] =
    useState("");
  const [vendorfinancingArrangement, setVendorfinancingArrangement] =
    useState("");
  const [cashDiscount, setCashDiscount] = useState("");
  const [vendorPays, setVendorPays] = useState("");
  const [selectedBusinessRequirement, setSelectedBusinessRequirement] =
    useState("");
  const [error, setError] = useState("");
  const [errorSecured, setErrorSecured] = useState("");
  const [errorBusiness, setErrorBusiness] = useState("");
  const [errorfinancing, setErrorfinancing] = useState("");
  const [errorfinancingVendor, setErrorfinancingVendor] = useState("");
  const [errorCashDiscount, setErrorCashDiscount] = useState("");
  const [errorFldg, setErrorFldg] = useState("");
  const [errorGuarantee, setErrorGuarantee] = useState("");
  const [errorvendorPays, setErrorvendorPays] = useState("");
  const entityValue = "";
  const [selectedFinType, setSelectedFinType] = useState("");
  const [selectedPrefFinType, setSelectedPrefFinType] = useState("");
  const [errorSelectedFinancier, setErrorSelectedFinancier] = useState("");
  const [bankList, setBankList] = useState([]);
  const [publicSectorBankList, setPublicSectorBankList] = useState([]);
  const [privateSectorBankList, setPrivateSectorBankList] = useState([]);
  const [NBFCList, setNBFCList] = useState([]);

  const [publicFinancier, setPublicFinancier] = useState([]);
  const [privateFinancier, setPrivateFinancier] = useState([]);
  const [nbfcFinancier, setNbfcFinancier] = useState([])
  const [preferredPublicFinancier, setPreferredPublicFinancier] = useState([]);
  const [preferredPrivateFinancier, setPreferredPrivateFinancier] = useState([]);
  const [preferredNbfcFinancier, setPreferredNbfcFinancier] = useState([]);

  const [isApprovePermission, setIsApprovePermission] = useState(false);
  const [isfullAccess, setIsfullAccess] = useState(false);
  const [isLoanAgainstProperty, setIsLoanAgainstProperty] = useState(false);
  const [isPasswordBankStatement, setIsPasswordBankStatement] = useState("");
  const [isOtherIncomeSource, setIsOtherIncomeSource] = useState("");
  const [isPasswordError, setIsPasswordError] = useState("");
  const [isIncomeError, setIsIncomeError] = useState("");
  const [isCoBorrower, setIsCoBorrower] = useState("");
  const [isCoBorrowerError, setIsCoBorrowerError] = useState("");
  const [coBorrowerIncomeType, setCoBorrowerIncomeType] = useState("");
  const [incomeCoBorrowerError, setIncomeCoBorrowerError] = useState("");
  const [coBorrowerOfPropList, setCoBorrowerOfPropList] = useState([]);
  const [isEquipmentFinance, setIsEquipmentFinance] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState("");
  const [equipmentError, setEquipmentError] = useState("");
  const [selectedSubEquipment, setSelectedSubEquipment] = useState("");
  const [subEquipmentError, setSubEquipmentError] = useState("");
  const [selectedEquipmentType, setSelectedEquipmentType] = useState("");
  const [equipmentTypeError, setEquipmentTypeError] = useState("");
  const [isShowSubProduct, setIsShowSubProduct] = useState(false);
  const [subProductList, setSubProductList] = useState([]);
  const [uploadProgressCma, setUploadProgressCma] = useState(0);
  const [uploadProgressBankStat, setUploadProgressBankStat] = useState(0);
  const [uploadProgressCoBoPan, setUploadProgressCoBoPan] = useState(0);
  const [uploadProgressCoBoItr, setUploadProgressCoBoItr] = useState(0);
  const [errorMessageCma, setErrorMessageCma] = useState(null);
  const [errorMessageBankStat, setErrorMessageBankStat] = useState(null);
  const [errorMessageCoBoPan, setErrorMessageCoBoPan] = useState(null);
  const [errorMessageCoBoItr, setErrorMessageCoBoItr] = useState(null);
  const [hasOpenedBefore, setHasOpenedBefore] = useState(true);
  const [hasOpenedBeforeDealAuthor, setHasOpenedBeforeDealAuthor] = useState(true);
  const [dealStatusBucket, setDealStatusBucket] = useState([]);
  const [isDealStatusBucketSelected, setIsDealStatusBucketSelected] = useState(false);
  const [selectedDealType, setDealType] = useState("");
  const [anchorList, setAnchorList] = useState([]);
  const [isDisableEntity, setIsDisableEntity] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedProductsType, setSelectedProductsType] = useState([]);
  const [dealAuthorList, setDealAuthorList] = useState([]);
  const [selectedDealAuthor, setSelectedDealAuthor] = useState("");
  const [selectedDealFIRM, setSelectedDealFIRM] = useState("");
  const [selectedDealProgramRM, setSelectedDealProgramRM] = useState("");
  
  const [valuationDone, setValuationDone] = useState("");
  const [selectEquityType, setSelectEquityType] = useState("");
  const [selectFreshOrDiluted, setSelectFreshOrDiluted] = useState("");
  const [selectdebenturesSecuredOrUnsecured, setSelectdebenturesSecuredOrUnsecured] = useState("");
  const [selectdebenturesRatedOrUnrated, setSelectdebenturesRatedOrUnrated] = useState("");
  const [selectCommercialRatedOrUnrated, setSelectCommercialRatedOrUnrated] = useState("");
  const [selectPoolPSLorNonPSL, setSelectpoolPSLorNonPSL] = useState("");
  const [selectPoolRatedOrUnrated, setSelectpoolRatedOrUnrated] = useState("");

  const [valuationDoneError, setValuationDoneError] = useState("");
  const [selectEquityTypeError, setSelectEquityTypeError] = useState("");
  const [selectFreshOrDilutedError, setSelectFreshOrDilutedError] = useState("");
  const [selectdebenturesSecuredOrUnsecuredError, setSelectdebenturesSecuredOrUnsecuredError] = useState("");
  const [selectdebenturesRatedOrUnratedError, setSelectdebenturesRatedOrUnratedError] = useState("");
  const [selectCommercialRatedOrUnratedError, setSelectCommercialRatedOrUnratedError] = useState("");
  const [selectPoolPSLorNonPSLError, setSelectpoolPSLorNonPSLError] = useState("");
  const [selectPoolRatedOrUnratedError, setSelectpoolRatedOrUnratedError] = useState("");

  const [shareholdingList, setShareholdingList] = useState([]);
  const [percentageholdingValue, setPercentageholdingValue] = useState(0);
  const [referredFinancierList, setReferredFinancierList] = useState([]);
  const [refferedFinModal, setRefferedFinModal] = useState(false);
  const [preferredFinModal, setPreferredFinModal] = useState(false);
  const [isShowRecommendFinancier, setIsShowRecommendFinancier] = useState(false);
  const [prospectiveProductList, setProspectiveProductList] = useState([]);
  const [prosposalTypeList, setProsposalTypeList] = useState([]);
  const [partnerProgramList, setPartnerProgramList] = useState([]);
  const [isTradeeasySelected, setIsTradeeasySelected] = useState(false);

  const [productSettingObj, setProductSettingObj] = useState(
    {
      "requested_loan_amount": false,
      "vendor_payment_schedule": false,
      "business_requirement": false,
      "business_requirement2": false,
      "existing_vendor_financing": false,
      "guarantee_offer_to_lender": false,
      "monthly_purchases_value": false,
      "dealer_credit_period": false,
      "existing_dealer_financing": false,
      "geographical_sales_distribution": false,
      "dealer_cash_discounts": false,
      "default_guarantee_offer_fldg": false,
      "monthly_sales": false,
      "interest_rate": false,
      "loan_tenure": false,
      "loan_type": false,
      "guarantee": false,
      "is_loan_secured": false,
      "security_cover": false,
      "end_use": false,
      "primary_security": false,
      "charge_type": false,
      "cma_documents": false,
      "equipment_category": false,
      "equipment_sub_category": false,
      "equipment_type": false,
      "bank_name": false,
      "bank_statement": false,
      "statement_password": false,
      "other_income_source": false,
      "income_tax_returns_contribution": false,
      "co_borrower": false,
      "property_list": false,
      "isValuationDone": false,
      "investorsType": false,
      "equityType": false,
      "purposeOfRaisingEquity": false,
      "freshOrDiluted": false,
      "dilutedEquityHolder": false,
      "capexEquipmentImported": false,
      "bankAvalizingBill": false,
      "debenturesSecuredOrUnsecured": false,
      "debenturesRatedOrUnrated": false,
      "purposeOfIssuingDebentures": false,
      "purposeOfIssuingCommercial": false,
      "commercialRatedOrUnrated": false,
      "coupon": false,
      "poolPSLorNonPSL": false,
      "poolRatedOrUnrated": false,
      "desiredCoupon": false,
      "poolAgeing": false,
      "shareHoldingPattern":false
    }
  )

  let productSetting = {
    "Payable Financing": {
      "requested_loan_amount": true,
      "vendor_payment_schedule": true,
      "business_requirement": true,
      "existing_vendor_financing": true,
      "guarantee_offer_to_lender": true,
      "monthly_purchases_value": true,
    },
    "Receivable Financing": {
      "requested_loan_amount": true,
      "dealer_credit_period": true,
      "business_requirement2": true,
      "existing_dealer_financing": true,
      "geographical_sales_distribution": true,
      "dealer_cash_discounts": true,
      "default_guarantee_offer_fldg": true,
      "monthly_sales": true,
    },
    "WCDL": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "guarantee": true,
      "is_loan_secured": true
    },
    "CC/OD": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "guarantee": true,
      "is_loan_secured": true
    },
    "Operating lease": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "guarantee": true,
      "is_loan_secured": true
    },
    "Finance lease": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "guarantee": true,
      "is_loan_secured": true
    },
    "Equipment Finance": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "guarantee": true,
      "is_loan_secured": true,
      "security_cover": true,
      "end_use": true,
      "primary_security": true,
      "charge_type": true,
      "cma_documents": true,
      "equipment_category": true,
      "equipment_sub_category": true,
      "equipment_type": true,
    },
    "Loan against Property": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "end_use": true,
      "bank_name": true,
      "bank_statement": true,
      "statement_password": true,
      "other_income_source": true,
      "income_tax_returns_contribution": true,
      "co_borrower": true,
      "property_list": true,
    },
    "Term loan": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "guarantee": true,
      "is_loan_secured": true,
      "security_cover": true,
      "end_use": true,
      "primary_security": true,
      "charge_type": true,
      "cma_documents": true,
    },
    "Infrastructure finance": {
      "requested_loan_amount": true,
      "interest_rate": true,
      "loan_tenure": true,
      "loan_type": true,
      "guarantee": true,
      "is_loan_secured": true,
      "security_cover": true,
      "end_use": true,
      "primary_security": true,
      "charge_type": true,
      "cma_documents": true,
    },
    "Equity": {
      "requested_loan_amount": true,
      "percentageOfEquityDiluted": true,
      "isValuationDone": true,
      "investorsType": true,
      "equityType": true,
      "purposeOfRaisingEquity": true,
      "freshOrDiluted": true,
      "dilutedEquityHolder": true,
      "shareHoldingPattern":true
    },
    "Forfaiting": {
      "requested_loan_amount": true,
      "vendor_payment_schedule": true,
      "business_requirement": true,
      "existing_vendor_financing": true,
      "guarantee_offer_to_lender": true,
      "monthly_purchases_value": true,
      "capexEquipmentImported": true,
      "bankAvalizingBill": true,
      "loan_tenure": true
    },
    "Debetures": {
      "requested_loan_amount": true,
      "loan_tenure": true,
      "debenturesSecuredOrUnsecured": true,
      "debenturesRatedOrUnrated": true,
      "purposeOfIssuingDebentures": true
    },
    "Commercial paper": {
      "requested_loan_amount": true,
      "loan_tenure": true,
      "purposeOfIssuingCommercial": true,
      "commercialRatedOrUnrated": true,
      "coupon": true
    },
    "Securitisation": {
      "requested_loan_amount": true,
      "loan_tenure": true,
      "poolPSLorNonPSL": true,
      "poolRatedOrUnrated": true,
      "desiredCoupon": true,
      "poolAgeing": true
    },
    "Buyers Credit": {
      "requested_loan_amount": true,
      "vendor_payment_schedule": true,
      "business_requirement": true,
      "existing_vendor_financing": true,
      "guarantee_offer_to_lender": true,
      "monthly_purchases_value": true
    },
    "Suppliers Credit": {
      "requested_loan_amount": true,
      "vendor_payment_schedule": true,
      "business_requirement": true,
      "existing_vendor_financing": true,
      "guarantee_offer_to_lender": true,
      "monthly_purchases_value": true
    },
    "Inventory funding": {
      "requested_loan_amount": true,
      "dealer_credit_period": true,
      "business_requirement2": true,
      "existing_dealer_financing": true,
      "geographical_sales_distribution": true,
      "dealer_cash_discounts": true,
      "default_guarantee_offer_fldg": true,
      "monthly_sales": true,
    },
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    validation.validateForm().then((errors) => {
      if (Object.keys(errors).length > 0) {
        // If there are validation errors, do not proceed
        return;
      }
    if (isAdmin && validation.values.financier.length === 0) {
      setErrorSelectedFinancier("Please select at least one financier.");
      return;
  }
    if (selectedOption == "" && isOpen) {
      setError("Please select an option");
    }

    if (selectedBusinessRequirement == "" && (productSettingObj.business_requirement2 || productSettingObj.business_requirement)) {
      setErrorBusiness("Please select an option");
    }

    if (dealerfinancingArrangement == "" && productSettingObj.existing_dealer_financing) {
      setErrorfinancing("Please select an option");
    }

    if (vendorfinancingArrangement == "" && productSettingObj.existing_vendor_financing) {
      setErrorfinancingVendor("Please select an option");
    }

    if (cashDiscount == "" && productSettingObj.dealer_cash_discounts) {
      setErrorCashDiscount("Please select an option");
    }

    if (selectedFldg == "" && productSettingObj.default_guarantee_offer_fldg) {
      setErrorFldg("Please select an option");
    }

    if (selectedGuarantee == "" && productSettingObj.guarantee_offer_to_lender) {
      setErrorGuarantee("Please select an option");
    }

    if (vendorPays == "" && productSettingObj.vendor_payment_schedule) {
      setErrorvendorPays("Please select an option");
    }

    if (selectedIsSecured == "" && productSettingObj.is_loan_secured) {
      setErrorSecured("Please select an option");
    }

    if (selectedFinType == "") {
      setErrorSelectedFinancier("Please select an option");
    }

    if (selectedPrefFinType == "") {
      setErrorSelectedFinancier("Please select an option");
    }

    if (isPasswordBankStatement == "" && productSettingObj.statement_password) {
      setIsPasswordError("Please select an option");
    }

    if (isOtherIncomeSource == "" && productSettingObj.other_income_source) {
      setIsIncomeError("Please select an option");
    }

    if (isCoBorrower == "" && productSettingObj.co_borrower) {
      setIsCoBorrower("Please select an option");
    }

    if (coBorrowerIncomeType == "" && productSettingObj.property_list) {
      setIncomeCoBorrowerError("Please select an option");
    }

    if (selectedEquipment == "" && productSettingObj.equipment_category) {
      setEquipmentError("Please select an option");
    }

    if (selectedSubEquipment == "" && productSettingObj.equipment_sub_category) {
      setSubEquipmentError("Please select an option");
    }

    if (selectedEquipmentType == "" && productSettingObj.equipment_type) {
      setEquipmentTypeError("Please select an option");
    }

    if (valuationDone == "" && productSettingObj.isValuationDone) {
      setValuationDoneError("Please select an option");
    }

    if (selectEquityType == "" && productSettingObj.equityType) {
      setSelectEquityTypeError("Please select an option");
    }

    if (selectFreshOrDiluted == "" && productSettingObj.freshOrDiluted) {
      setSelectFreshOrDilutedError("Please select an option");
    }

    if (selectdebenturesSecuredOrUnsecured == "" && productSettingObj.debenturesSecuredOrUnsecured) {
      setSelectdebenturesSecuredOrUnsecuredError("Please select an option");
    }

    if (selectdebenturesRatedOrUnrated == "" && productSettingObj.debenturesRatedOrUnrated) {
      setSelectdebenturesRatedOrUnratedError("Please select an option");
    }

    if (selectCommercialRatedOrUnrated == "" && productSettingObj.commercialRatedOrUnrated) {
      setSelectCommercialRatedOrUnratedError("Please select an option");
    }

    if (selectPoolPSLorNonPSL == "" && productSettingObj.poolPSLorNonPSL) {
      setSelectpoolPSLorNonPSLError("Please select an option");
    }

    if (selectPoolRatedOrUnrated == "" && productSettingObj.poolRatedOrUnrated) {
      setSelectpoolRatedOrUnratedError("Please select an option");
    }
  });
  };

  const handleOptionChange = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isCreditPeriod = true;
    } else {
      validation.values.isCreditPeriod = false;
    }
    setSelectedOption(event.target.value);
    setIsPasswordError("");
  };

  const handleSubEquipmetChange = (event) => {
    setSelectedSubEquipment(event.target.value);
    validation.setFieldValue("equipmentSubCategory", event.target.value);
    setSubEquipmentError("");
  };

  const handleEquipmetTypeChange = (event) => {
    setSelectedEquipmentType(event.target.value);
    validation.setFieldValue("equipmentType", event.target.value);
    setEquipmentTypeError("");
  };

  const handleEquipmetChange = (event) => {
    setSelectedEquipment(event.target.value);
    validation.setFieldValue("equipmentCategory", event.target.value);
    setEquipmentError("");
  };

  const handlePasswordChange = (event) => {
    if (event.target.value == "Yes") {
      validation.setFieldValue("isPasswordBankStatement", true);
    } else {
      validation.setFieldValue("isPasswordBankStatement", false);
    }
    setIsPasswordBankStatement(event.target.value);
    setIsPasswordError("");
  };

  const handleIncomeChange = (event) => {
    if (event.target.value == "Yes") {
      validation.setFieldValue("isOtherIncomeSource", true);
    } else {
      validation.setFieldValue("isOtherIncomeSource", false);
    }
    setIsOtherIncomeSource(event.target.value);
    setIsIncomeError("");
  };

  const handleCoBorrowerChange = (event) => {
    if (event.target.value == "Yes") {
      validation.setFieldValue("isCoBorrower", true);
    } else {
      validation.setFieldValue("isCoBorrower", false);
    }
    setIsCoBorrower(event.target.value);
    setIsCoBorrowerError("");
  };

  const handleIncomeTypeChange = (event) => {
    validation.setFieldValue("coBorrowerIncomeType", event.target.value);
    setCoBorrowerIncomeType(event.target.value);
    setIncomeCoBorrowerError("");
  };

  const handleSecureChange = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isSecured = true;
      getDropDownList({ dropdownName: "Security Cover" })
        .then((response) => {
          const dropdownValues =
            response.data?.rows?.find(
              (dv) => dv.dropdownName == "Security Cover"
            )?.dropdownValues || [];
          setSecurityCoverList(dropdownValues);
        })
        .catch((error) => {});
    } else {
      validation.values.isSecured = false;
    }
    setSelectedIsSecured(event.target.value);
    setErrorSecured("");
  };

  const handlevendorPays = (event) => {
    validation.values.vendorPay = event.target.value;
    setVendorPays(event.target.value);
    setErrorvendorPays("");
  };

  const handleFldgChange = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isFldg = true;
    } else {
      validation.values.isFldg = false;
    }
    setSelectedFldg(event.target.value);
    setErrorFldg("");
  };

  const handleGuaranteeChange = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isGuaranteeLender = true;
    } else {
      validation.values.isGuaranteeLender = false;
    }
    if (event.target.value == "Yes") {
      getDropDownList({ dropdownName: "Guarantee Types For Lender" }).then(
        (response) => {
          const dropdownValues =
            response.data?.rows?.find(
              (dv) => dv.dropdownName == "Guarantee Types For Lender"
            )?.dropdownValues || [];
          const formattedOptions = dropdownValues.map((option) => ({
            label: option.displayName,
            value: option.dropdownValue,
          }));
          setEntityGuaranteeList(formattedOptions);
        }
      );
    }
    setSelectedGuarantee(event.target.value);
    setErrorGuarantee("");
  };

  const handleBusinessRequirement = (event) => {
    validation.values.businessRequirement = event.target.value;
    setSelectedBusinessRequirement(event.target.value);
    if (event.target.value == "Extend Days Payable Outstanding(DPO)") {
      setIsSelectedDpo(true);
    } else {
      setIsSelectedDpo(false);
    }
    setErrorBusiness("");
  };

  const handleCashDiscount = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isCashDiscount = true;
    } else {
      validation.values.isCashDiscount = false;
    }
    setCashDiscount(event.target.value);
    setErrorCashDiscount("");
  };

  const handledealerfinancingArrangement = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isDealerArrangement = true;
    } else {
      validation.values.isDealerArrangement = false;
    }
    setDealerfinancingArrangement(event.target.value);
    if (event.target.value == "Yes") {
      getDropDownList({ dropdownName: "Financing Arrangement" }).then(
        (response) => {
          const dropdownValues =
            response.data?.rows?.find(
              (dv) => dv.dropdownName == "Financing Arrangement"
            )?.dropdownValues || [];
          const formattedOptions = dropdownValues.map((option) => ({
            label: option.displayName,
            value: option.dropdownValue,
          }));
          setEntityArrangeList(formattedOptions);
        }
      );
    }
    setErrorfinancing("");
  };

  const handlevendorfinancingArrangement = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isVendorArrangement = true;
    } else {
      validation.values.isVendorArrangement = false;
    }
    setVendorfinancingArrangement(event.target.value);
    if (event.target.value == "Yes") {
      getDropDownList({
        dropdownName: "Financing Arrangenment for vendor",
      }).then((response) => {
        const dropdownValues =
          response.data?.rows?.find(
            (dv) => dv.dropdownName == "Financing Arrangenment for vendor"
          )?.dropdownValues || [];
        const formattedOptions = dropdownValues.map((option) => ({
          label: option.displayName,
          value: option.dropdownValue,
        }));
        setEntityArrangeListForVendor(formattedOptions);
      });
    }
    setErrorfinancingVendor("");
  };

  const handleFinancierSelect = (event) => {
    setSelectedFinType(event.target.value);
    if (event.target.value == "All") {
      callFinancierList({ financierType: "public_sector" })
        .then((response) => {
          const newData = [];
          const formattedOptions = response?.data.map((option) => ({
            label: option.entityName,
            value: option.id,
          }));
          formattedOptions.forEach((ele) => {
            newData.push(ele.value);
          });
          if (newData.length > 0) {
            validation.values.financier = newData;
          }
          setPublicFinancier(newData);
          setSelectedMulti6(formattedOptions);
        })
        .catch((error) => {
          console.log(error);
        });
      callFinancierList({ financierType: "private_sector" })
        .then((response) => {
          const newData = [];
          const formattedOptions = response?.data.map((option) => ({
            label: option.entityName,
            value: option.id,
          }));
          formattedOptions.forEach((ele) => {
            newData.push(ele.value);
          });
          if (newData.length > 0) {
            validation.values.financier = newData;
          }
          setPrivateFinancier(newData);
          setSelectedMulti7(formattedOptions);
        })
        .catch((error) => {
          console.log(error);
        });

      callFinancierList({ financierType: "NBFC" })
        .then((response) => {
          const newData = [];
          const formattedOptions = response?.data.map((option) => ({
            label: option.entityName,
            value: option.id,
          }));
          formattedOptions.forEach((ele) => {
            newData.push(ele.value);
          });
          if (newData.length > 0) {
            validation.values.financier = newData;
          }
          setNbfcFinancier(newData);
          setSelectedMulti8(formattedOptions);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setSelectedMulti6([]);
      setSelectedMulti7([]);
      setSelectedMulti8([]);
      setPrivateFinancier([]);
      setPublicFinancier([]);
      setNbfcFinancier([]);
      validation.setFieldValue("financier", []);
    }
    setErrorSelectedFinancier("");
    
  };
  const handlePrefFinancierSelect = (event) => {
    setSelectedPrefFinType(event.target.value);
    if (event.target.value == "All") {
      callFinancierList({ financierType: "public_sector" })
        .then((response) => {
          const newData = [];
          const formattedOptions = response?.data.map((option) => ({
            label: option.entityName,
            value: option.id,
          }));
          formattedOptions.forEach((ele) => {
            newData.push(ele.value);
          });
          if (newData.length > 0) {
            validation.values.preferredFinancier  = newData;
          }
          setPreferredPublicFinancier(newData);
          setSelectedPrefFinancierMulti6(formattedOptions);
        })
        .catch((error) => {
          console.log(error);
        });
      callFinancierList({ financierType: "private_sector" })
        .then((response) => {
          const newData = [];
          const formattedOptions = response?.data.map((option) => ({
            label: option.entityName,
            value: option.id,
          }));
          formattedOptions.forEach((ele) => {
            newData.push(ele.value);
          });
          if (newData.length > 0) {
            validation.values.preferredFinancier  = newData;
          }
          setPreferredPrivateFinancier(newData);
          setSelectedPrefFinancierMulti7(formattedOptions);
        })
        .catch((error) => {
          console.log(error);
        });

      callFinancierList({ financierType: "NBFC" })
        .then((response) => {
          const newData = [];
          const formattedOptions = response?.data.map((option) => ({
            label: option.entityName,
            value: option.id,
          }));
          formattedOptions.forEach((ele) => {
            newData.push(ele.value);
          });
          if (newData.length > 0) {
            validation.values.financier = newData;
          }
          setPreferredNbfcFinancier(newData);
          setSelectedPrefFinancierMulti8(formattedOptions);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setSelectedPrefFinancierMulti6([]);
      setSelectedPrefFinancierMulti7([]);
      setSelectedPrefFinancierMulti8([]);
      setPreferredPublicFinancier([]);
      setPreferredPrivateFinancier([]);
      setPreferredNbfcFinancier([]);

      validation.values.preferredFinancier  = [];
    }
    setErrorSelectedFinancier("");
  };
  const handleAnchorSelect = (event) => {
      getCpAnchor({ entityId: event })
        .then((response) => {
          setAnchorList(response.data)
        })
        .catch((error) => {
          console.log(error);
        });
  };

  const loadBankList = (search) => {
    callBankList({ page: 1, limit: 200, searchKey: search })
      .then((response) => {
        const formattedOptions = response.data?.data.map((option) => ({
          label: option.bankName,
          value: option.id,
        }));
        setBankList(formattedOptions);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadPublicSectorBankList = (search) => {
    callFinancierList({ financierType: "public_sector" })
      .then((response) => {
        const formattedOptions = response?.data.map((option) => ({
          label: option.entityName,
          value: option.id,
        }));
        setPublicSectorBankList(formattedOptions);
        return formattedOptions;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadPrivateSectorBankList = (search) => {
    callFinancierList({ financierType: "private_sector" })
      .then((response) => {
        const formattedOptions = response?.data.map((option) => ({
          label: option.entityName,
          value: option.id,
        }));
        setPrivateSectorBankList(formattedOptions);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadNBFCList = (search) => {
    callFinancierList({ financierType: "NBFC" })
      .then((response) => {
        const formattedOptions = response?.data.map((option) => ({
          label: option.entityName,
          value: option.id,
        }));
        setNBFCList(formattedOptions);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    loadBankList();
    loadPublicSectorBankList();
    loadNBFCList();
    loadPrivateSectorBankList();
    checkPermissions();
    if (decodedNonFinancierType == 'Counterparty') {
      handleAnchorSelect(decodedId)
    }
    if (user.entityType == "Owner" || user.entityType == "Partner") {
      setIsAdmin(true);
    }
    getDropDownList({ dropdownName: "Tenure" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Tenure")
            ?.dropdownValues || [];
        setTenureList(dropdownValues);
      })
      .catch((error) => {});
    getDropDownList({ dropdownName: "Loan Type" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Loan Type")
            ?.dropdownValues || [];
        setLoanTypeList(dropdownValues);
      })
      .catch((error) => {});
    getDropDownList({ dropdownName: "Guarantee" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Guarantee")
            ?.dropdownValues || [];
        const formattedOptions = dropdownValues.map((option) => ({
          label: option.displayName,
          value: option.dropdownValue,
        }));
        setGuaranteeList(formattedOptions);
      })
      .catch((error) => {});
    getDropDownList({ dropdownName: "Product type" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Product type")
            ?.dropdownValues || [];
        setProductTypeList(dropdownValues);
      })
      .catch((error) => {});
    getDropDownList({ dropdownName: "Security type" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Security type")
            ?.dropdownValues || [];
        setPrimarySecurityList(dropdownValues);
      })
      .catch((error) => {});
    getDropDownList({ dropdownName: "Type of Charge" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Type of Charge")
            ?.dropdownValues || [];
        setTypeOfChargeList(dropdownValues);
      })
      .catch((error) => {});
    getDropDownList({ dropdownName: "Deal Status Buckets" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Deal Status Buckets")
            ?.dropdownValues || [];
        setDealStatusBucket(dropdownValues);
      })
      .catch((error) => {});
      callGetCIUser()
      .then((res) => {
        setDealAuthorList(res.data.rows)
      })
      .catch((error) => {})
    getDropDownList({ dropdownName: "Prospective products" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Prospective products")
            ?.dropdownValues || [];
        setProspectiveProductList(dropdownValues);
      })
      .catch((error) => { });
      getDropDownList({ dropdownName: "Partner program" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Partner program")
            ?.dropdownValues || [];
            setPartnerProgramList(dropdownValues);
      })
      .catch((error) => { });
    if (decodedId && decodedNonFinancierType !== undefined && decodedSelectedEntityName) {
      setDealType(decodedNonFinancierType)
      validation.setFieldValue("dealType", decodedNonFinancierType);
    }

    validation.setFieldValue("productInfoList", [
      {
        id: uId(),
        product: '',
        productType: '',
        subProduct: [],
        integrationFeesType: '',
        integrationFeesFrequency: '',
        integrationFeesOccurrence: '',
        integrationFeesValue: '',
        syndicationFeesType: '',
        syndicationFeesFrequency: '',
        syndicationFeesOccurrence: '',
        syndicationFeesValue: '',
      },
    ]);
  }, []);

  useEffect(() => {
    setSelectedEntityName("")
    allEntity({ searchKey: "", nonFinancierType: '',sortingOrder: "asc" })
      .then((response) => {
        if (response?.data) {
          setEntityList(response.data);
          if (decodedId && decodedNonFinancierType && decodedSelectedEntityName) {
            setSelectedEntityName({ label: decodedSelectedEntityName, value: decodedId })
            validation.setFieldValue("entityId", decodedId);
            setIsDisableEntity(true)
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [selectedDealType])

  const commercialValidationSchema = commercialFieldsData.reduce(
    (acc, field) => {
      // if (!(isReceivableFinancing == 'Receivable Financing' && field.fieldName == 'selfFinanaces')) {
      acc[`${field.fieldName}Type`] = Yup.string();
      acc[`${field.fieldName}Frequency`] = Yup.string();
      acc[`${field.fieldName}Occurrence`] = Yup.string();

      acc[`${field.fieldName}Value`] = Yup.number()
        .typeError("Value must be a number")
        .when(`${field.fieldName}Type`, {
          is: "Percentage",
          then: Yup.number()
            .typeError("Value must be a number")
            .max(
              100,
              `${field.fieldLabel} value must be less than or equal to 100`
            ),
        })
        .min(0, `${field.fieldLabel} value must not be negative.`);

      if (field.fieldName == 'platformCharges') {
        acc[`${field.fieldName}Value`] = Yup.number()
          .typeError("Value must be a number")
          .when(`${field.fieldName}Type`, {
            is: "Throughput",
            then: Yup.number()
              .typeError("Value must be a number")
              .max(
                100,
                `${field.fieldLabel} value must be less than or equal to 100`
              ),
          })
          .min(0, `${field.fieldLabel} value must not be negative.`);
      }

      acc[`${field.fieldName}BenchmarkRate`] = Yup.number()
        .typeError("Benchmark rate  must be a number")
        .when(`${field.fieldName}Type`, {
          is: "NVG",
          then: Yup.number()
            .typeError("Benchmark rate must be a number")
            .max(
              100,
              `Benchmark rate value must be less than or equal to 100`
            ),
        })
        .min(0, `Benchmark rate value must not be negative.`);

      acc[`${field.fieldName}MarkupOverBenchmark`] = Yup.number()
        .typeError("Markup over benchmark must be a number")
        .when(`${field.fieldName}Type`, {
          is: "NVG",
          then: Yup.number()
            .typeError("Markup over benchmark must be a number")
            .max(
              100,
              `Markup over benchmark value must be less than or equal to 100`
            ),
        })
        .min(0, `Markup over benchmark value must not be negative.`);

      acc[`${field.fieldName}NVG`] = Yup.number()
        .typeError("NVG must be a number")
        .when(`${field.fieldName}Type`, {
          is: "NVG",
          then: Yup.number()
            .typeError("NVG must be a number")
            .max(
              100,
              `NVG value must be less than or equal to 100`
            ),
        })
        .min(0, `NVG value must not be negative.`);
       if(isAdmin){
      if (field.fieldName === "syndicationFees" || field.fieldName === "integrationFees") {
        acc[`${field.fieldName}Type`] = Yup.string()
          .when('product', {
            is: 'Inventory funding',
            then: Yup.string().required(`Enter Type`),
            otherwise: Yup.string(),
          });
        acc[`${field.fieldName}Frequency`] = Yup.string()
          .when('product', {
            is: 'Inventory funding',
            then: Yup.string().required(`Enter Frequency`),
            otherwise: Yup.string(),
          });
          acc[`${field.fieldName}Occurrence`] = Yup.string()
          .when(['product', `${field.fieldName}Frequency`], {
            is: (product, frequency) => product === 'Inventory funding' && frequency !== 'One time',
            then: Yup.string().required(`Enter Occurrence`),
            otherwise: Yup.string().nullable(),
          });
        acc[`${field.fieldName}Value`] = Yup.number()
          .typeError("Value must be a number")
          .when('product', {
            is: 'Inventory funding',
            then: Yup.number()
              .typeError("Value must be a number")
              .required(`Enter Value`)
              .min(0, `${field.fieldLabel} value must not be negative.`),
            otherwise: Yup.number(),
          });
      }
    }

      return acc;
    },

    {}
  );

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      entityId: entity?.entityId || "",
      loanRequirement: entity?.loanRequirement || "",
      percentageCovered: entity?.percentageCovered || "",
      north: entity?.north || "",
      south: entity?.south || "",
      east: entity?.east || "",
      west: entity?.west || "",
      creditPeriod: entity?.creditPeriod || "",
      fldg: entity?.fldg || "",
      monthlySales: entity?.monthlySales || "",
      monthlyPurchases: entity?.monthlyPurchases || "",
      rateOfInterest: entity?.rateOfInterest || "",
      tenure: entity?.tenure || "",
      loanType: entity?.loanType || "",
      // productType: entity?.productType || "",
      // product: entity?.product || "",
      facility: entity?.facility || "",
      primarySecurity: entity?.primarySecurity || "",
      typeOfCharge: entity?.typeOfCharge || "",
      vendorDiscount: entity?.vendorDiscount || "",
      extendDpoDays: entity?.extendDpoDays || "",
      securityCover: entity?.securityCover || "",
      expectedClosureDate: entity?.expectedClosureDate || "",
      vendorPay: "",
      isFldg: "",
      isSecured: "",
      isCreditPeriod: "",
      businessRequirement: "",
      isCashDiscount: "",
      isDealerArrangement: "",
      isVendorArrangement: "",
      isGuaranteeLender: "",
      vendorsArrangement: "",
      guaranteeTypesLender: "",
      dealerArrangement: "",
      endUse: "",
      guarantee: "",
      financier: [],
      cmaDoc: "",
      propertyInfoList: [],
      bankName: entity?.bankName || "",
      bankStatement: "",
      isPasswordBankStatement: "",
      bankStatementPassword: entity?.bankStatementPassword || "",
      otherIncomeAmount: entity?.otherIncomeAmount || "",
      isOtherIncomeSource: entity?.isOtherIncomeSource || "",
      isCoBorrower: "",
      coBorrowerIncomeType: entity?.otherIncomeAmount || "",
      coBorrowerName: entity?.coBorrowerName || "",
      coBorrowerDob: entity?.coBorrowerDob || "",
      coBorrowerRelation: entity?.coBorrowerRelation || "",
      coBorrowerPanNumber: entity?.coBorrowerPanNumber || "",
      coBorrowerPan: entity?.coBorrowerPan || "",
      coBorrowerItr: entity?.coBorrowerItr || "",
      equipmentCategory: "",
      equipmentSubCategory: "",
      equipmentType: "",
      // subProduct: entity?.subProduct || "",
      dealStatus: entity?.dealStatus || "",
      dealType: entity?.dealType || "",
      anchor: entity?.anchor || "",
      counterpartyId: entity?.counterpartyId || "",
      productInfoList: [],
      dealNotes: entity?.dealNotes || "",
      assignedTo: entity?.assignedTo || "",
      assignedToFirm: entity?.assignedToFirm || "",
      assignedToProgramRm: entity?.assignedToProgramRm || "",
      percentageOfEquityDiluted: entity?.percentageOfEquityDiluted || "",
      isValuationDone: entity?.isValuationDone || "",
      investorsType: entity?.investorsType || "",
      equityType: entity?.equityType || "",
      purposeOfRaisingEquity: entity?.purposeOfRaisingEquity || "",
      freshOrDiluted: entity?.freshOrDiluted || "",
      dilutedEquityHolder: entity?.dilutedEquityHolder || "",

      capexEquipmentImported: entity?.capexEquipmentImported || "",
      bankAvalizingBill: entity?.bankAvalizingBill || "",

      debenturesSecuredOrUnsecured: entity?.debenturesSecuredOrUnsecured || "",
      debenturesRatedOrUnrated: entity?.debenturesRatedOrUnrated || "",
      purposeOfIssuingDebentures: entity?.purposeOfIssuingDebentures || "",

      purposeOfIssuingCommercial: entity?.purposeOfIssuingCommercial || "",
      commercialRatedOrUnrated: entity?.commercialRatedOrUnrated || "",
      coupon: entity?.coupon || "",

      poolPSLorNonPSL: entity?.poolPSLorNonPSL || "",
      poolRatedOrUnrated: entity?.poolRatedOrUnrated || "",
      desiredCoupon: entity?.desiredCoupon || "",
      poolAgeing: entity?.poolAgeing || "",
      prospectiveProduct: entity?.prospectiveProduct || "",
      proposalType: entity?.proposalType || "",
      partnerProgram: entity?.partnerProgram || "",
      shareholdingAsOf: "",
      shareholderList:  [
        {
          shareholderName: "",
          shareholderType: "",
          percentageHolding: "",
        },
      ],
      preferredFinancier: [],
    },
    validationSchema: Yup.object({
      entityId:
        isAdmin && entityValue == ""
          ? Yup.number().required("Please Select Entity")
          : Yup.number(),
      loanRequirement: Yup.number()
        .typeError("Loan Requirement Amount must be a number")
        // .required("Loan Requirement is required")
        .min(0, "Loan Requirement cannot be negative")
        .max(99999999999999, "Loan Requirement cannot more than 14 digits"),
      expectedClosureDate: isAdmin ? Yup.string().required("Please Select Closure Date"):Yup.string(),
      rateOfInterest: productSettingObj.interest_rate
        ? Yup.number()
          .typeError("Rate Of Interest must be a number")
          // .required("Rate Of Interest is required")
          .min(0, "Rate Of Interest cannot be negative")
          .max(100, "Rate Of Interest cannot be more than 100")
        : Yup.number(),
      tenure: productSettingObj.loan_tenure
        ? Yup.string()
        : Yup.string(),
      loanType: productSettingObj.loan_type
        ? Yup.string()
        : Yup.string(),
      isSecured: productSettingObj.is_loan_secured
        ? Yup.boolean()
        : Yup.boolean(),
      // productType: Yup.string().required("Please Select Product Type"),
      primarySecurity: productSettingObj.primary_security
        ? Yup.string()
        : Yup.string(),
      typeOfCharge: productSettingObj.charge_type
        ? Yup.string()
        : Yup.string(),
      // product: Yup.string().required("Please Select Product"),
      facility: isOpen
        ? Yup.string()
        : Yup.string(),
      securityCover:
        selectedIsSecured == "Yes" && productSettingObj.security_cover
          ? Yup.string()
          : Yup.string(),
      creditPeriod:
        selectedOption == "Yes" && productSettingObj.dealer_credit_period
          ? Yup.number()
            .typeError("Credit Period must be a number")
            // .required("Please Enter Credit Period")
            .min(0, "Credit Period cannot be negative")
          : Yup.number(),
      percentageCovered:
        dealerfinancingArrangement == "Yes" && productSettingObj.existing_dealer_financing
          ? Yup.number()
            .typeError("Percentage Covered must be a number")
            // .required("Please Enter Percentage Covered")
            .min(0, "Percentage Covered cannot be negative")
            .max(100, "Percentage Covered cannot be more than 100")
          : Yup.number(),
      north: productSettingObj.geographical_sales_distribution
        ? Yup.number()
          .typeError("North Sales must be a number")
          // .required("Please Enter North Percentage")
          .min(0, "percentage cannot be negative")
          .max(100, "Percentage cannot be more than 100")
        : Yup.number(),
      south: productSettingObj.geographical_sales_distribution
        ? Yup.number()
          .typeError("South Sales must be a number")
          // .required("Please Enter South Percentage")
          .min(0, "percentage cannot be negative")
          .max(100, "Percentage cannot be more than 100")
        : Yup.number(),
      east: productSettingObj.geographical_sales_distribution
        ? Yup.number()
          .typeError("East sales must be a number")
          // .required("Please Enter east percentage")
          .min(0, "percentage cannot be negative")
          .max(100, "Percentage cannot be more than 100")
        : Yup.number(),
      west: productSettingObj.geographical_sales_distribution
        ? Yup.number()
          .typeError("West Sales must be a number")
          // .required("Please Enter West Percentage")
          .min(0, "Percentage cannot be negative")
          .max(100, "Percentage cannot be more than 100")
        : Yup.number(),
      fldg:
        selectedFldg == "Yes" && productSettingObj.default_guarantee_offer_fldg
          ? Yup.number()
            .typeError("FLDG must be a number")
            // .required("Please Enter FLDG")
            .min(0, "Percentage cannot be negative")
            .max(100, "Percentage cannot be more than 100")
          : Yup.number(),
      monthlySales: productSettingObj.monthly_sales
        ? Yup.number()
          .typeError("Monthly Sales Amount must be a number")
          // .required("Please Enter Monthly Sales")
          .min(0, "Monthly Sales cannot be negative")
        : Yup.number(),
      isFldg: productSettingObj.default_guarantee_offer_fldg ? Yup.boolean() : Yup.boolean(),
      isCreditPeriod: productSettingObj.dealer_credit_period ? Yup.boolean() : Yup.boolean(),
      businessRequirement:
        productSettingObj.business_requirement || productSettingObj.business_requirement2
          ? Yup.string()
          : Yup.string(),
      isCashDiscount: productSettingObj.dealer_cash_discounts ? Yup.boolean() : Yup.boolean(),
      isDealerArrangement: productSettingObj.existing_dealer_financing
        ? Yup.boolean()
        : Yup.boolean(),
      vendorPay: productSettingObj.vendor_payment_schedule ? Yup.string() : Yup.string(),
      vendorDiscount: isSelectedDpo && productSettingObj.business_requirement
        ? Yup.number()
          .typeError("Vendor Discount must be a number")
          // .required("Please Enter Discount you get from Vendors")
          .min(0, "Vendor Discount cannot be negative")
          .max(100, "Vendor Discount cannot be more than 100")
        : Yup.number(),
      extendDpoDays: isSelectedDpo && productSettingObj.business_requirement
        ? Yup.number()
          .typeError("DPO days must be a number")
          // .required(
          //   "Please Enter how many days would you want to extend DPO?"
          // )
          .min(0, "DPO days cannot be negative")
        : Yup.number(),
      isVendorArrangement: productSettingObj.existing_vendor_financing
        ? Yup.boolean()
        : Yup.boolean(),
      isGuaranteeLender: productSettingObj.guarantee_offer_to_lender
        ? Yup.boolean()
        : Yup.boolean(),
      monthlyPurchases: productSettingObj.monthly_purchases_value
        ? Yup.number()
          .typeError("Monthly Purchases Amount must be a number")
          // .required("Please Enter Monthly Purchases")
          .min(0, "Monthly Purchases cannot be negative")
        : Yup.number(),
      vendorsArrangement:
        vendorfinancingArrangement == "Yes" && productSettingObj.existing_vendor_financing
          ? Yup.string()
          : Yup.string(),
      guaranteeTypesLender:
        selectedGuarantee == "Yes" && productSettingObj.guarantee_offer_to_lender
          ? Yup.string()
          : Yup.string(),
      dealerArrangement:
        dealerfinancingArrangement == "Yes" && productSettingObj.existing_dealer_financing
          ? Yup.string()
          : Yup.string(),
      endUse: productSettingObj.end_use
        ? Yup.string()
        : Yup.string(),
      guarantee:
        productSettingObj.guarantee
          ? Yup.string()
          : Yup.string(),
      cmaDoc:
        productSettingObj.cma_documents
          ? Yup.string()
          : Yup.string(),
      // financier:isAdmin
      // ? Yup.array().min(1, "Please Select at least one Financier").required("Please Select Finacier") : Yup.array(),
      total: Yup.number().test(
        "totalPercentage",
        "The Total Percentage should be 100",
        function (value) {
          if (productSettingObj.geographical_sales_distribution) {
            const { north, south, east, west } = this.parent;
            const values = [north, south, east, west].filter(val => val !== undefined && val !== null);
            if (values.length > 0) {
              const total = values.reduce((acc, curr) => acc + curr, 0);
              return total === 100;
            }
          }
          return true;
        }
      ),
      propertyInfoList: productSettingObj.property_list
        ? Yup.array().of(
          Yup.object({
            propertyNature: Yup.string(),
            propertyAge: Yup.number()
              .typeError("Property Age Amount must be a number")
              // .required("Please Enter Age of Property (Year)")
              .min(0, "Property Age cannot be negative"),
            city: Yup.string(),
            propertyOwner: Yup.string(),
            propertyStatus: Yup.string(),
            propertyValue: Yup.number()
              .typeError("Property Value Amount must be a number")
              .test(
                "propertyValue",
                "Value of Property Should Be Greater Than Loan Amount",
                function (value) {
                  if (isLoanAgainstProperty) {
                    const { propertyValue } = this.parent;
                    return validation.values.loanRequirement < propertyValue;
                  }
                  return true;
                }
              ),
            address: Yup.string(),
            pincode: Yup.number()
              // .required("Please Enter Pincode")
              .typeError("Pincode Must be a Number")
              .positive("Pincode must be a positive number")
              .integer("Pincode must be an integer")
              .test(
                "len",
                "Pincode must be exactly 6 digits",
                (val) => !val || val.toString().length === 6
              ),
            state: Yup.string(),
            parentDeed: Yup.string(),
            saleDeed: Yup.string(),
            utilityBills: Yup.string(),
            propertyTax: Yup.string(),
          })
        )
        : Yup.array(),
      bankName: productSettingObj.bank_name
        ? Yup.string()
        : Yup.string(),
      bankStatement: productSettingObj.bank_statement
        ? Yup.string()
        : Yup.string(),
      isPasswordBankStatement: productSettingObj.statement_password
        ? Yup.boolean()
        : Yup.boolean(),
      bankStatementPassword:
        isPasswordBankStatement == "Yes" && productSettingObj.statement_password
          ? Yup.string()
          : Yup.string(),
      isOtherIncomeSource: productSettingObj.other_income_source
        ? Yup.boolean()
        : Yup.boolean(),
      otherIncomeAmount:
        isOtherIncomeSource == "Yes" && productSettingObj.other_income_source
          ? Yup.number()
            // .required("Please Enter Income Amount")
            .typeError("Income Amount Must Be Number")
            .min(0, "Income Cannot Be Negative")
          : Yup.number(),
      isCoBorrower: productSettingObj.co_borrower
        ? Yup.boolean()
        : Yup.boolean(),
      coBorrowerIncomeType:
        isCoBorrower == "Yes" && productSettingObj.co_borrower
          ? Yup.string()
          : Yup.string(),
      coBorrowerName:
        isCoBorrower == "Yes" && productSettingObj.co_borrower
          ? Yup.string()
          : Yup.string(),
      coBorrowerDob:
        isCoBorrower == "Yes" && productSettingObj.co_borrower
          ? Yup.string()
          : Yup.string(),
      coBorrowerPanNumber:
        isCoBorrower == "Yes" && productSettingObj.co_borrower
          ? Yup.string()
            // .required("Enter Co-borrower`s PAN Number")
            .matches(API_SERVICES.PAN_PATTERN, "Enter a valid PAN number")
          : Yup.string(),
      coBorrowerItr:
        isCoBorrower == "Yes" && productSettingObj.co_borrower
          ? Yup.string()
          : Yup.string(),
      coBorrowerPan:
        isCoBorrower == "Yes" && productSettingObj.co_borrower
          ? Yup.string()
          : Yup.string(),
      coBorrowerRelation:
        isCoBorrower == "Yes" && productSettingObj.co_borrower
          ? Yup.string()
          : Yup.string(),
      equipmentCategory: productSettingObj.equipment_category
        ? Yup.string()
        : Yup.string(),
      equipmentSubCategory: productSettingObj.equipment_sub_category
        ? Yup.string()
        : Yup.string(),
      equipmentType: productSettingObj.equipment_type
        ? Yup.string()
        : Yup.string(),
      // subProduct: isShowSubProduct
      //   ? Yup.string().required("Please Select Sub Product")
      //   : Yup.string(),
      dealStatus: isAdmin
        ? Yup.string()
        : Yup.string(),
      dealType: Yup.string(),
      anchor: Yup.string().when("dealType", {
        is: "Counterparty",
        then: Yup.string().required("Anchor is required"), 
        otherwise: Yup.string(),
      }),
      dealNotes: Yup.string(),
      assignedTo: isApprovePermission
        ? Yup.string()
        : Yup.string(),
      // assignedTo: Yup.number().required("Please Assign RM"),
      productInfoList: Yup.array().of(
        Yup.object({
          product: Yup.string().required("Please Select product"),
          productType: Yup.string().required("Please Select Product Type"),
          subProduct: Yup.array()
            .when('product', {
              is: (product) =>
                product === 'Payable Financing' ||
                product === 'Receivable Financing' || product === 'CC/OD'
                || product === 'Debetures' || product === 'Inventory funding',
              then: Yup.array()
                .min(1, "Please Select at least one Sub Product")
                .required("Please Select Sub Product"),
              otherwise: Yup.array().nullable(),
            }),
          ...commercialValidationSchema
        }),
      ),

      percentageOfEquityDiluted: productSettingObj.percentageOfEquityDiluted
        ? Yup.number()
          .typeError("Percentage equity diluted must be a number")
          // .required("Percentage equity diluted is required")
          .min(0, "Percentage equity diluted cannot be negative")
          .max(100, "Percentage equity diluted cannot be more than 100")
        : Yup.number(),
      isValuationDone: productSettingObj.isValuationDone
        ? Yup.boolean()
        : Yup.string(),
      investorsType: productSettingObj.investorsType
        ? Yup.string()
        : Yup.string(),
      equityType: productSettingObj.equityType
        ? Yup.string()
        : Yup.string(),
      purposeOfRaisingEquity: productSettingObj.purposeOfRaisingEquity
        ? Yup.string()
        : Yup.string(),
      freshOrDiluted: productSettingObj.freshOrDiluted
        ? Yup.string()
        : Yup.string(),
      dilutedEquityHolder: productSettingObj.dilutedEquityHolder
        ? Yup.string()
        : Yup.string(),

      capexEquipmentImported: productSettingObj.capexEquipmentImported
        ? Yup.string()
        : Yup.string(),
      bankAvalizingBill: productSettingObj.bankAvalizingBill
        ? Yup.string()
        : Yup.string(),

      debenturesSecuredOrUnsecured: productSettingObj.debenturesSecuredOrUnsecured
        ? Yup.string()
        : Yup.string(),
      debenturesRatedOrUnrated: productSettingObj.debenturesRatedOrUnrated
        ? Yup.string()
        : Yup.string(),
      purposeOfIssuingDebentures: productSettingObj.purposeOfIssuingDebentures
        ? Yup.string()
        : Yup.string(),

      purposeOfIssuingCommercial: productSettingObj.purposeOfIssuingCommercial
        ? Yup.string()
        : Yup.string(),
      commercialRatedOrUnrated: productSettingObj.commercialRatedOrUnrated
        ? Yup.string()
        : Yup.string(),
      coupon: productSettingObj.coupon
        ? Yup.string()
        : Yup.string(),

      poolPSLorNonPSL: productSettingObj.poolPSLorNonPSL
        ? Yup.string()
        : Yup.string(),
      poolRatedOrUnrated: productSettingObj.poolRatedOrUnrated
        ? Yup.string()
        : Yup.string(),
      desiredCoupon: productSettingObj.desiredCoupon
        ? Yup.string()
        : Yup.string(),
      poolAgeing: productSettingObj.poolAgeing
        ? Yup.string()
        : Yup.string(),
      shareholdingAsOf: productSettingObj.shareHoldingPattern
        ? Yup.date()
        : Yup.date(),
      shareholderList: productSettingObj.shareHoldingPattern
        ? Yup.array().of(
          Yup.object({
            shareholderType: Yup.string(),
            percentageHolding: Yup.number()
              // .required("Percentage Holding is required")
              .min(0, "Percentage Holding cannot be less than 0")
              .max(100, "Percentage Holding cannot be greater than 100").nullable(),
          })
        )
        : Yup.array(),
      prospectiveProduct: isAdmin ? Yup.string().required("Please Select Prospective Product")
        : Yup.string(),
        proposalType:isAdmin? Yup.string().required("Please select a proposal type"): Yup.string(),
      partnerProgram:Yup.string(),
    }),
    onSubmit: (values) => {
     if (selectedFinType !== "All" && selectedFinType !== "AllExcept" && (selectedMulti6.length === 0 && selectedMulti7.length === 0 && selectedMulti8.length === 0)) {
            setErrorSelectedFinancier("Please select at least one financier.");
            return; 
        }
      values.productInfoList.forEach((product, productIndex) => {
        const commercialEntry = {};
        commercialFieldsData.forEach((field) => {
          const typeField = `${field.fieldName}Type`;
          const valueField = `${field.fieldName}Value`;
          const timeField = `${field.fieldName}Frequency`;
          const cycleField = `${field.fieldName}Occurrence`;
          const benchmarkRate = `${field.fieldName}BenchmarkRate`;
          const markupOverBenchmark = `${field.fieldName}MarkupOverBenchmark`;
          const benchmark = `${field.fieldName}Benchmark`;
          const NVG = `${field.fieldName}NVG`;

          commercialEntry[`${field.fieldName}`] = {
            Type: product[typeField],
            Value: product[valueField],
            Frequency: product[timeField],
            Occurrence: product[cycleField],
            Benchmark: product[benchmark],
            BenchmarkRate: product[benchmarkRate],
            MarkupOverBenchmark: product[markupOverBenchmark],
            NVG: product[NVG]
          };
        });
        product.commercials = [commercialEntry];
      });

      const entity = {
        productList: values.productInfoList,
        loanRequirement: values.loanRequirement,
        productType: values.productType,
        product: values.product,
        rateOfInterest: values.rateOfInterest || 0,
        dealStatus: values.dealStatus || "",
        dealType: values.dealType || "",
        dealNotes: values.dealNotes || "",
        assignedTo: values.assignedTo || "",
        assignedToFirm: values.assignedToFirm || "",
        assignedToProgramRm: values.assignedToProgramRm || "",
        prospectiveProduct: values.prospectiveProduct || "",
        proposalType: values.proposalType || "",
        partnerProgram:values.partnerProgram||"",
        preferredFinancier: values.preferredFinancier || [],
      };

      if (selectedDealType == "Counterparty") {
        entity.anchorId = values.anchor
        entity.counterpartyId = values.entityId
      }
      //  else {
      //   entity.anchorId = values.entityId
      // }

      if (values.subProduct) {
        entity.subProduct = values.subProduct;
      }

      if (isApprovePermission) {
        entity.status = "Submit";
        // entity.assignedTo = user.id;
      } else if (user.roleName == "partner") {
        entity.status = "partner";
      } else {
        entity.status = "create";
      }

      if (isAdmin) {
        entity.entityId = values.entityId;
      } else {
        entity.entityId = user.entityId;
      }

      if (selectedFinType == "AllExcept") {
        let allFinancierArray = [
          ...privateSectorBankList,
          ...publicSectorBankList,
          ...NBFCList,
        ];
        let selectedValue = [
          ...selectedMulti6,
          ...selectedMulti7,
          ...selectedMulti8,
        ];
        const firstArrayValues = selectedValue?.map((item) => item.value);
        const exceptFinancierArray = allFinancierArray
          .filter((item) => !firstArrayValues.includes(item.value))
          .map((item) => item.value);
        entity.financier = exceptFinancierArray;
      } else {
        entity.financier = [
          ...publicFinancier,
          ...privateFinancier,
          ...nbfcFinancier,
        ];
      }

      if (selectedPrefFinType == "AllExcept") {
        let allPreferredFinancierArray  = [
          ...privateSectorBankList,
          ...publicSectorBankList,
          ...NBFCList,
        ];
        let selectedPrefValue = [
          ...selectedPrefFinancierMulti6,
          ...selectedPrefFinancierMulti7,
          ...selectedPrefFinancierMulti8,
        ];
        const firstPrefArrayValues  = selectedPrefValue?.map((item) => item.value);
        const exceptPreferredFinancierArray  = allPreferredFinancierArray
          .filter((item) => !firstPrefArrayValues.includes(item.value))
          .map((item) => item.value);
        entity.preferredFinancier  = exceptPreferredFinancierArray;
      } else {
        entity.preferredFinancier = [
          ...preferredPublicFinancier,
          ...preferredPrivateFinancier,
          ...preferredNbfcFinancier,
        ];
      }

      if (selectedIsSecured == "Yes") {
        entity.securityCover = values.securityCover;
      }

      if (values.facility) {
        entity.facility = values.facility;
      }

      entity.tenure = productSettingObj.loan_tenure ? String(values.tenure) : null;
      entity.loanType = productSettingObj.loan_type ? values.loanType : null;
      entity.rateOfInterest = productSettingObj.interest_rate ? values.rateOfInterest : null;
      entity.primarySecurity = productSettingObj.primary_security ? values.primarySecurity : null;
      entity.typeOfCharge = productSettingObj.charge_type ? values.typeOfCharge : null;
      entity.cmaDoc = productSettingObj.cma_documents ? values.cmaDoc : null;
      entity.businessRequirement = (productSettingObj.business_requirement || productSettingObj.business_requirement2) ? selectedBusinessRequirement : null;
      entity.northSales = productSettingObj.geographical_sales_distribution ? values.north : null;
      entity.southSales = productSettingObj.geographical_sales_distribution ? values.south : null;
      entity.eastSales = productSettingObj.geographical_sales_distribution ? values.east : null;
      entity.westSales = productSettingObj.geographical_sales_distribution ? values.west : null;
      entity.monthlySales = productSettingObj.monthly_sales ? values.monthlySales : null;
      entity.vendorPay = productSettingObj.vendor_payment_schedule ? vendorPays : null;
      entity.businessRequirement = (productSettingObj.business_requirement || productSettingObj.business_requirement2) ? selectedBusinessRequirement : null;
      entity.monthlyPurchases = productSettingObj.monthly_purchases_value ? values.monthlyPurchases : null;

     
      if (valuationDone == "Yes" && productSettingObj.isValuationDone) {
        entity.isValuationDone = true;
      } else if (productSettingObj.isValuationDone && valuationDone == "No") {
        entity.isValuationDone = false;
      }

      if (productSettingObj.shareHoldingPattern) {
        let totalShareholding = 0;
        values.shareholderList.forEach((elem) => {
          totalShareholding += +elem.percentageHolding;
          totalShareholding = Math.round(totalShareholding * 100) / 100;
        });
        if (totalShareholding > 100) {
          setToastInfo({
            message: "%Holding Shouldn't be greater than 100",
            showToast: true,
            role: "error",
          });
          return;
        }
        if (totalShareholding < 100) {
          setToastInfo({
            message: "%Holding Shouldn't be less than 100",
            showToast: true,
            role: "error",
          });
          return;
        }
        handleSubmitForShareHolding(values,totalShareholding)
      }

      entity.percentageOfEquityDiluted = productSettingObj.percentageOfEquityDiluted ? values.percentageOfEquityDiluted : '';
      entity.investorsType = productSettingObj.investorsType ? values.investorsType : '';
      entity.equityType = productSettingObj.equityType ? values.equityType : '';
      entity.purposeOfRaisingEquity = productSettingObj.purposeOfRaisingEquity ? values.purposeOfRaisingEquity : '';
      entity.freshOrDiluted = productSettingObj.freshOrDiluted ? values.freshOrDiluted : '';
      entity.dilutedEquityHolder = productSettingObj.dilutedEquityHolder ? values.dilutedEquityHolder : '';
      entity.capexEquipmentImported = productSettingObj.capexEquipmentImported ? values.capexEquipmentImported : '';
      entity.bankAvalizingBill = productSettingObj.bankAvalizingBill ? values.bankAvalizingBill : '';
      entity.debenturesSecuredOrUnsecured = productSettingObj.debenturesSecuredOrUnsecured ? values.debenturesSecuredOrUnsecured : '';
      entity.debenturesRatedOrUnrated = productSettingObj.debenturesRatedOrUnrated ? values.debenturesRatedOrUnrated : '';
      entity.purposeOfIssuingDebentures = productSettingObj.purposeOfIssuingDebentures ? values.purposeOfIssuingDebentures : '';
      entity.purposeOfIssuingCommercial = productSettingObj.purposeOfIssuingCommercial ? values.purposeOfIssuingCommercial : '';
      entity.commercialRatedOrUnrated = productSettingObj.commercialRatedOrUnrated ? values.commercialRatedOrUnrated : '';
      entity.coupon = productSettingObj.coupon ? values.coupon : '';
      entity.poolPSLorNonPSL = productSettingObj.poolPSLorNonPSL ? values.poolPSLorNonPSL : '';
      entity.poolRatedOrUnrated = productSettingObj.poolRatedOrUnrated ? values.poolRatedOrUnrated : '';
      entity.desiredCoupon = productSettingObj.desiredCoupon ? values.desiredCoupon : '';
      entity.poolAgeing = productSettingObj.poolAgeing ? values.poolAgeing : '';


      if (selectedIsSecured == "Yes" && productSettingObj.is_loan_secured) {
        entity.isSecured = true;
      } else if (productSettingObj.is_loan_secured && selectedIsSecured == 'No') {
        entity.isSecured = false;
      }
    
      if (productSettingObj.end_use) {
        const newData = [];
        selectedMulti2.forEach((ele) => {
          newData.push(ele.value);
        });
        entity.endUse = newData.join(",");
      }

      if (productSettingObj.guarantee) {
        const newData2 = [];
        selectedMulti1.forEach((ele) => {
          newData2.push(ele.value);
        });
        entity.guarantee = newData2.join(",");
      }

      if (cashDiscount == "No" && productSettingObj.dealer_cash_discounts) {
        entity.isCashDiscount = false;
      } else if (productSettingObj.dealer_cash_discounts) {
        entity.isCashDiscount = true;
      }

      if (selectedFldg == "Yes" && productSettingObj.default_guarantee_offer_fldg) {
        entity.fldg = values.fldg;
        entity.isFldg = true;
      } else if (productSettingObj.default_guarantee_offer_fldg && selectedFldg == 'No') {
        entity.isFldg = false;
      }

      if (selectedOption == "No" && productSettingObj.dealer_credit_period) {
        entity.isCreditPeriod = false;
        entity.creditPeriod = 0;
      } else if (productSettingObj.dealer_credit_period) {
        entity.isCreditPeriod = true;
        entity.creditPeriod = values.creditPeriod;
      }

      if (dealerfinancingArrangement == "No" && productSettingObj.existing_dealer_financing) {
        entity.isDealerArrangement = false;
      } else if (productSettingObj.existing_dealer_financing) {
        entity.isDealerArrangement = true;
        const newData = [];
        selectedMulti3.forEach((ele) => {
          newData.push(ele.value);
        });
        entity.dealerArrangement = newData.join(",");
        entity.percentageCovered = values.percentageCovered;
      }

      if (vendorfinancingArrangement == "No" && productSettingObj.existing_vendor_financing) {
        entity.isVendorArrangement = false;
      } else if (productSettingObj.existing_vendor_financing) {
        entity.isVendorArrangement = true;
        const newData = [];
        selectedMulti4.forEach((ele) => {
          newData.push(ele.value);
        });
        entity.vendorsArrangement = newData.join(",");
      }

      if (selectedGuarantee == "No" && productSettingObj.guarantee_offer_to_lender) {
        entity.isGuaranteeLender = false;
      } else if (productSettingObj.guarantee_offer_to_lender) {
        entity.isGuaranteeLender = true;
        const newData = [];
        selectedMulti5.forEach((ele) => {
          newData.push(ele.value);
        });
        entity.guaranteeTypesLender = newData.join(",");
      }

      if (isSelectedDpo && productSettingObj.business_requirement) {
        entity.vendorDiscount = values.vendorDiscount;
        entity.extendDpoDays = values.extendDpoDays;
      }

      if (productSettingObj.guarantee) {
        const newData2 = [];
        selectedMulti1.forEach((ele) => {
          newData2.push(ele.value);
        });
        entity.guarantee = newData2.join(",");
      }

      if (productSettingObj.property_list) {
        entity.propertyInfo = values.propertyInfoList;
        entity.bankName = values.bankName;
        entity.bankStatement = values.bankStatement;
        entity.isPasswordBankStatement = values.isPasswordBankStatement;
        entity.isCoBorrower = values.isCoBorrower;
        entity.isSecured = false;
      }

      if (productSettingObj.co_borrower) {
        entity.coBorrowerIncomeType = values.coBorrowerIncomeType;
        entity.coBorrowerName = values.coBorrowerName;
        entity.coBorrowerDob = values.coBorrowerDob;
        entity.coBorrowerRelation = values.coBorrowerRelation;
        entity.coBorrowerPanNumber = values.coBorrowerPanNumber;
        entity.coBorrowerPan = values.coBorrowerPan;
        entity.coBorrowerItr = values.coBorrowerItr;
      }

      if (productSettingObj.statement_password) {
        entity.bankStatementPassword = values.bankStatementPassword;
      }

      if (productSettingObj.other_income_source) {
        entity.isOtherIncomeSource = values.isOtherIncomeSource;
        entity.otherIncomeAmount = +values.otherIncomeAmount || '';
      }

      if (productSettingObj.equipment_category) {
        entity.equipmentCategory = values.equipmentCategory;
        entity.equipmentSubCategory = values.equipmentSubCategory;
        entity.equipmentType = values.equipmentType;
        entity.isSecured = true;
      }
      Object.keys(entity).forEach(key => {
        if (entity[key] === null || entity[key] === "") {
          delete entity[key];
        }
      });
      confirmAlert({
        title: "Confirm",
        message:
          "Please note that once you submit this deal, it cannot be edited. Are you sure you want to proceed with the submission?",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              setLoader(true);
              addDeal(entity)
                .then((response) => {
                  if (response.code == "201") {
                    setLoader(false);
                    if (isfullAccess) {
                      const encryptedId = btoa(response.message.id.toString());
                      // navigate(`/${user.roleName}/emandate?id=${encodeURIComponent(encryptedId)}`);
                      navigate(`/${user.roleName}/listDeal`);
                    } else {
                      window.history.back();
                    }
                  }
                })
                .catch((error) => {
                  setLoader(false);
                })
                .finally((f) => {
                  setLoader(false);
                });
              // validation.resetForm();
            },
          },
          {
            label: "No",
            onClick: () => {
              setLoader(false);
              // validation.resetForm()
            },
          },
        ],
      });
    },
  });
  const onHandleSaveAsDraft = (status) => {
    const { productInfoList, entityId, dealStatus, dealType } = validation.values;
    const missingFields = validateProductInfoList(productInfoList, isShowSubProduct);
    if (!entityId) missingFields.push("Entity");
    if (!dealType) missingFields.push("Deal Type");
    // if (!expectedClosureDate) missingFields.push("Deal Type");
    if (missingFields.length > 0) {
      const message = `Please Select ${missingFields.join(", ")}`;
      validation.handleSubmit()
      // setToastInfo({
      //   message,
      //   showToast: true,
      //   role: "error",
      // });
      
      return;
    } else {
      if (validation.errors && Object.keys(validation.errors).length > 0) {
        validation.handleSubmit()
        return;
      }
      validation.values.productInfoList.forEach((product, productIndex) => {
        const commercialEntry = {};
        commercialFieldsData.forEach((field) => {
          const typeField = `${field.fieldName}Type`;
          const valueField = `${field.fieldName}Value`;
          const timeField = `${field.fieldName}Frequency`;
          const cycleField = `${field.fieldName}Occurrence`;
          const benchmarkRate = `${field.fieldName}BenchmarkRate`;
          const markupOverBenchmark = `${field.fieldName}MarkupOverBenchmark`;
          const benchmark = `${field.fieldName}Benchmark`;
          const NVG = `${field.fieldName}NVG`;

          commercialEntry[`${field.fieldName}`] = {
            Type: product[typeField],
            Value: product[valueField],
            Frequency: product[timeField],
            Occurrence: product[cycleField],
            Benchmark: product[benchmark],
            BenchmarkRate: product[benchmarkRate],
            MarkupOverBenchmark: product[markupOverBenchmark],
            NVG: product[NVG]
          };
        });
        product.commercials = [commercialEntry];
      });
      const entity = {
        productList: validation.values.productInfoList,
        prospectiveProduct: validation.values.prospectiveProduct || "",
        proposalType: validation.values.proposalType || "",
        partnerProgram:validation.values.partnerProgram||""
      };
      entity.status = status;

      if (validation.values.rateOfInterest) {
        entity.rateOfInterest = validation.values.rateOfInterest || null;
      }

      if (validation.values.loanRequirement) {
        entity.loanRequirement = validation.values.loanRequirement || null;
      }

      if (validation.values.subProduct) {
        entity.subProduct = validation.values.subProduct || null;
      }


      if (isAdmin) {
        entity.entityId = validation.values.entityId || null;
      } else {
        entity.entityId = user.entityId || null;
      }

      if (selectedFinType == "AllExcept") {
        let allFinancierArray = [
          ...privateSectorBankList,
          ...publicSectorBankList,
          ...NBFCList,
        ];
        let selectedValue = [
          ...selectedMulti6,
          ...selectedMulti7,
          ...selectedMulti8,
        ];
        const firstArrayValues = selectedValue?.map((item) => item.value);
        const exceptFinancierArray = allFinancierArray
          .filter((item) => !firstArrayValues.includes(item.value))
          .map((item) => item.value);
        entity.financier = exceptFinancierArray;
      } else {
        entity.financier = [
          ...publicFinancier,
          ...privateFinancier,
          ...nbfcFinancier,
        ];
      }

      if (selectedPrefFinType == "AllExcept") {
        let allPreferredFinancierArray = [
          ...privateSectorBankList,
          ...publicSectorBankList,
          ...NBFCList,
        ];
        let selectedPrefValue = [
          ...selectedPrefFinancierMulti6,
          ...selectedPrefFinancierMulti7,
          ...selectedPrefFinancierMulti8,
        ];
        const firstPrefArrayValues = selectedPrefValue?.map((item) => item.value);
        const exceptPreferredFinancierArray = allPreferredFinancierArray
          .filter((item) => !firstPrefArrayValues.includes(item.value))
          .map((item) => item.value);
        entity.preferredFinancier = exceptPreferredFinancierArray;
      } else {
        entity.preferredFinancier = [
          ...preferredPublicFinancier,
          ...preferredPrivateFinancier,
          ...preferredNbfcFinancier,
        ];
      } 
      if (selectedIsSecured == "Yes") {
        entity.securityCover = validation.values.securityCover || null;
      }

      if (validation.values.facility) {
        entity.facility = validation.values.facility || null;
      }

      entity.tenure = productSettingObj.loan_tenure ? String(validation.values.tenure) : null;
      entity.loanType = productSettingObj.loan_type ? validation.values.loanType : null;
      entity.rateOfInterest = productSettingObj.interest_rate ? validation.values.rateOfInterest : null;
      entity.primarySecurity = productSettingObj.primary_security ? validation.values.primarySecurity : null;
      entity.typeOfCharge = productSettingObj.charge_type ? validation.values.typeOfCharge : null;
      entity.cmaDoc = productSettingObj.cma_documents ? validation.values.cmaDoc : null;
      entity.businessRequirement = (productSettingObj.business_requirement || productSettingObj.business_requirement2) ? selectedBusinessRequirement : null;
      entity.northSales = productSettingObj.geographical_sales_distribution ? validation.values.north : null;
      entity.southSales = productSettingObj.geographical_sales_distribution ? validation.values.south : null;
      entity.eastSales = productSettingObj.geographical_sales_distribution ? validation.values.east : null;
      entity.westSales = productSettingObj.geographical_sales_distribution ? validation.values.west : null;
      entity.monthlySales = productSettingObj.monthly_sales ? validation.values.monthlySales : null;
      entity.vendorPay = productSettingObj.vendor_payment_schedule ? vendorPays : null;
      entity.businessRequirement = (productSettingObj.business_requirement || productSettingObj.business_requirement2) ? selectedBusinessRequirement : null;
      entity.monthlyPurchases = productSettingObj.monthly_purchases_value ? validation.values.monthlyPurchases : null;

      if (valuationDone == "Yes" && productSettingObj.isValuationDone) {
        entity.isValuationDone = true;
      } else if (productSettingObj.isValuationDone && valuationDone == "No") {
        entity.isValuationDone = false;
      }

      if (productSettingObj.shareHoldingPattern) {
        let totalShareholding = 0;
        validation.values.shareholderList.forEach((elem) => {
          totalShareholding += +elem.percentageHolding;
          totalShareholding = Math.round(totalShareholding * 100) / 100;
        });
        if (totalShareholding > 100 && totalShareholding !== 0) {
          setToastInfo({
            message: "%Holding Shouldn't be greater than 100",
            showToast: true,
            role: "error",
          });
          return;
        }
        if (totalShareholding < 100 && totalShareholding !== 0) {
          setToastInfo({
            message: "%Holding Shouldn't be less than 100",
            showToast: true,
            role: "error",
          });
          return;
        }
        handleSubmitForShareHolding(validation.values,totalShareholding)
      }

      entity.percentageOfEquityDiluted = productSettingObj.percentageOfEquityDiluted ? validation.values.percentageOfEquityDiluted : '';
      entity.investorsType = productSettingObj.investorsType ? validation.values.investorsType : '';
      entity.equityType = productSettingObj.equityType ? validation.values.equityType : '';
      entity.purposeOfRaisingEquity = productSettingObj.purposeOfRaisingEquity ? validation.values.purposeOfRaisingEquity : '';
      entity.freshOrDiluted = productSettingObj.freshOrDiluted ? validation.values.freshOrDiluted : '';
      entity.dilutedEquityHolder = productSettingObj.dilutedEquityHolder ? validation.values.dilutedEquityHolder : '';
      entity.capexEquipmentImported = productSettingObj.capexEquipmentImported ? validation.values.capexEquipmentImported : '';
      entity.bankAvalizingBill = productSettingObj.bankAvalizingBill ? validation.values.bankAvalizingBill : '';
      entity.debenturesSecuredOrUnsecured = productSettingObj.debenturesSecuredOrUnsecured ? validation.values.debenturesSecuredOrUnsecured : '';
      entity.debenturesRatedOrUnrated = productSettingObj.debenturesRatedOrUnrated ? validation.values.debenturesRatedOrUnrated : '';
      entity.purposeOfIssuingDebentures = productSettingObj.purposeOfIssuingDebentures ? validation.values.purposeOfIssuingDebentures : '';
      entity.purposeOfIssuingCommercial = productSettingObj.purposeOfIssuingCommercial ? validation.values.purposeOfIssuingCommercial : '';
      entity.commercialRatedOrUnrated = productSettingObj.commercialRatedOrUnrated ? validation.values.commercialRatedOrUnrated : '';
      entity.coupon = productSettingObj.coupon ? validation.values.coupon : '';
      entity.poolPSLorNonPSL = productSettingObj.poolPSLorNonPSL ? validation.values.poolPSLorNonPSL : '';
      entity.poolRatedOrUnrated = productSettingObj.poolRatedOrUnrated ? validation.values.poolRatedOrUnrated : '';
      entity.desiredCoupon = productSettingObj.desiredCoupon ? validation.values.desiredCoupon : '';
      entity.poolAgeing = productSettingObj.poolAgeing ? validation.values.poolAgeing : '';

      if (selectedIsSecured == "Yes" && productSettingObj.is_loan_secured) {
        entity.isSecured = true;
      } else if (productSettingObj.is_loan_secured && selectedIsSecured == "No") {
        entity.isSecured = false;
      }

      if (productSettingObj.end_use) {
        const newData = [];
        selectedMulti2.forEach((ele) => {
          newData.push(ele.value);
        });
        entity.endUse = newData.join(",");
      }

      if (productSettingObj.guarantee) {
        const newData2 = [];
        selectedMulti1.forEach((ele) => {
          newData2.push(ele.value);
        });
        entity.guarantee = newData2.join(",");
      }

      if (cashDiscount == "No" && productSettingObj.dealer_cash_discounts) {
        entity.isCashDiscount = false;
      } else if (productSettingObj.dealer_cash_discounts && cashDiscount == "Yes") {
        entity.isCashDiscount = true;
      }

      if (selectedFldg == "Yes" && productSettingObj.default_guarantee_offer_fldg) {
        entity.fldg = validation.values.fldg;
        entity.isFldg = true;
      } else if (productSettingObj.default_guarantee_offer_fldg && selectedFldg == 'No') {
        entity.isFldg = false;
      }

      if (selectedOption == "No" && productSettingObj.dealer_credit_period) {
        entity.isCreditPeriod = false;
        entity.creditPeriod = 0;
      } else if (selectedOption == "Yes" && productSettingObj.dealer_credit_period) {
        entity.isCreditPeriod = true;
        entity.creditPeriod = validation.values.creditPeriod;
      }

      if (dealerfinancingArrangement == "No" && productSettingObj.existing_dealer_financing) {
        entity.isDealerArrangement = false;
      } else if (dealerfinancingArrangement == "Yes" && productSettingObj.existing_dealer_financing) {
        entity.isDealerArrangement = true;
        const newData = [];
        selectedMulti3.forEach((ele) => {
          newData.push(ele.value);
        });
        entity.dealerArrangement = newData.join(",");
        entity.percentageCovered = validation.values.percentageCovered;
      }

      if (vendorfinancingArrangement == "No" && productSettingObj.existing_vendor_financing) {
        entity.isVendorArrangement = false;
      } else if (vendorfinancingArrangement == "Yes" && productSettingObj.existing_vendor_financing) {
        entity.isVendorArrangement = true;
        const newData = [];
        selectedMulti4.forEach((ele) => {
          newData.push(ele.value);
        });
        entity.vendorsArrangement = newData.join(",");
      }

      if (selectedGuarantee == "No" && productSettingObj.guarantee_offer_to_lender) {
        entity.isGuaranteeLender = false;
      } else if (selectedGuarantee == "Yes" && productSettingObj.guarantee_offer_to_lender) {
        entity.isGuaranteeLender = true;
        const newData = [];
        selectedMulti5.forEach((ele) => {
          newData.push(ele.value);
        });
        entity.guaranteeTypesLender = newData.join(",");
      }

      if (isSelectedDpo && productSettingObj.business_requirement) {
        entity.vendorDiscount = validation.values.vendorDiscount;
        entity.extendDpoDays = validation.values.extendDpoDays;
      }

      if (productSettingObj.guarantee) {
        const newData2 = [];
        selectedMulti1.forEach((ele) => {
          newData2.push(ele.value);
        });
        entity.guarantee = newData2.join(",");
      }

      if (productSettingObj.property_list) {
        entity.propertyInfo = validation.values.propertyInfoList;
        entity.bankName = validation.values.bankName;
        entity.bankStatement = validation.values.bankStatement;
        entity.isPasswordBankStatement = validation.values.isPasswordBankStatement;
        entity.isCoBorrower = validation.values.isCoBorrower;
        entity.isSecured = false;
      }

      if (productSettingObj.co_borrower) {
        entity.coBorrowerIncomeType = validation.values.coBorrowerIncomeType;
        entity.coBorrowerName = validation.values.coBorrowerName;
        entity.coBorrowerDob = validation.values.coBorrowerDob;
        entity.coBorrowerRelation = validation.values.coBorrowerRelation;
        entity.coBorrowerPanNumber = validation.values.coBorrowerPanNumber;
        entity.coBorrowerPan = validation.values.coBorrowerPan;
        entity.coBorrowerItr = validation.values.coBorrowerItr;
      }

      if (productSettingObj.statement_password && validation.values.bankStatementPassword == true) {
        entity.bankStatementPassword = validation.values.bankStatementPassword;
      } else if (productSettingObj.statement_password && validation.values.bankStatementPassword !== null) {
        entity.bankStatementPassword = validation.values.bankStatementPassword;
      }

      if (productSettingObj.other_income_source) {
        entity.isOtherIncomeSource = validation.values.isOtherIncomeSource;
        entity.otherIncomeAmount = +validation.values.otherIncomeAmount;
      }

      if (productSettingObj.equipment_category) {
        entity.equipmentCategory = validation.values.equipmentCategory;
        entity.equipmentSubCategory = validation.values.equipmentSubCategory;
        entity.equipmentType = validation.values.equipmentType;
        entity.isSecured = true;
      }
      entity.dealStatus = validation.values.dealStatus;
      entity.dealType = validation.values.dealType;

      if (selectedDealType == "Counterparty") {
        entity.anchorId = validation.values.anchor
        entity.counterpartyId = validation.values.entityId
      } 
      // else {
      //   entity.anchorId = validation.values.entityId
      // }
      entity.dealNotes = validation.values.dealNotes
      entity.assignedTo = validation.values.assignedTo
      entity.assignedToFirm = validation.values.assignedToFirm
      entity.assignedToProgramRm = validation.values.assignedToProgramRm
      entity.expectedClosureDate = validation.values.expectedClosureDate
      Object.keys(entity).forEach(key => {
        if (entity[key] === null || entity[key] === "") {
          delete entity[key];
        }
      });
      if (status !== 'Submit' && status !== 'partner' && status !== 'create') {
        confirmAlert({
          title: "Confirm",
          message: "Are you sure you want to save deal as draft?",
          buttons: [
            {
              label: "Yes",
              onClick: () => {
                setLoaderDraft(true);
                addDealDraft(entity)
                  .then((response) => {
                    if (response.code == "201") {
                      setLoaderDraft(false);
                      if (isfullAccess) {
                        navigate(`/${user.roleName}/listDeal`);
                      } else {
                        window.history.back();
                      }
                    }
                  })
                  .catch((error) => {
                    setLoaderDraft(true);
                  })
                  .finally((f) => {
                    setLoaderDraft(false);
                  });
                setLoaderDraft(false);
              },
            },
            {
              label: "No",
              onClick: () => {
                setLoaderDraft(false);
                // validation.resetForm()
              },
            },
          ],
        });
      } else {
        confirmAlert({
          title: "Confirm",
          message:
            "Please note that once you submit this deal, it cannot be edited. Are you sure you want to proceed with the submission?",
          buttons: [
            {
              label: "Yes",
              onClick: () => {
                setLoader(true);
                addDeal(entity)
                  .then((response) => {
                    if (response.code == "201") {
                      setLoader(false);
                      if (isfullAccess) {
                        const encryptedId = btoa(response.message.id.toString());
                        // navigate(`/${user.roleName}/emandate?id=${encodeURIComponent(encryptedId)}`);
                        navigate(`/${user.roleName}/listDeal`);
                      } else {
                        window.history.back();
                      }
                    }
                  })
                  .catch((error) => {
                    setLoader(false);
                  })
                  .finally((f) => {
                    setLoader(false);
                  });
                validation.resetForm();
              },
            },
            {
              label: "No",
              onClick: () => {
                setLoader(false);
                // validation.resetForm()
              },
            },
          ],
        });
      }
    }
  };

  const handleMulti1 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation.values.guarantee = newData.join(",");
    const isNoSelected = selectedOptions.some(
      (option) => option.value == "No Guarantee"
    );

    if (isNoSelected) {
      setSelectedMulti1([{ label: "No Guarantee", value: "No Guarantee" }]);
      validation.values.guarantee = "No Guarantee";
    } else {
      // Update selected options
      setSelectedMulti1(selectedOptions);
    }
  };

  const handleMulti2 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation.values.endUse = newData.join(",");
    setSelectedMulti2(selectedOptions);
  };

  const handleMulti3 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation.values.dealerArrangement = newData.join(",");
    setSelectedMulti3(selectedOptions);
  };

  const handleMulti4 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation.values.vendorsArrangement = newData.join(",");
    setSelectedMulti4(selectedOptions);
  };

  const handleMulti5 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation.values.guaranteeTypesLender = newData.join(",");
    setSelectedMulti5(selectedOptions);
  };

  const handleMulti6 = (selectedOptions) => {
    const newData = selectedOptions.map((ele) => ele.value);
    setSelectedMulti6(selectedOptions);
    setPublicFinancier(newData);
    const aggregatedFinanciers = [
        ...newData,
        ...selectedMulti7.map((ele) => ele.value),
        ...selectedMulti8.map((ele) => ele.value),
    ];
    
    validation.setFieldValue('financier', aggregatedFinanciers); // Update validation
    setErrorSelectedFinancier(''); // Clear error
};


const handleMulti7 = (selectedOptions) => {
  const newData = selectedOptions.map((ele) => ele.value);
  setSelectedMulti7(selectedOptions);
  setPrivateFinancier(newData);

  const aggregatedFinanciers = [
      ...selectedMulti6.map((ele) => ele.value),
      ...newData,
      ...selectedMulti8.map((ele) => ele.value),
  ];

  validation.setFieldValue('financier', aggregatedFinanciers);
  setErrorSelectedFinancier('');
};


const handleMulti8 = (selectedOptions) => {
  const newData = selectedOptions.map((ele) => ele.value);
  setSelectedMulti8(selectedOptions);
  setNbfcFinancier(newData);

  const aggregatedFinanciers = [
      ...selectedMulti6.map((ele) => ele.value),
      ...selectedMulti7.map((ele) => ele.value),
      ...newData,
  ];

  validation.setFieldValue('financier', aggregatedFinanciers);
  setErrorSelectedFinancier('');
};


  const handlePrefMulti1 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation.values.guarantee = newData.join(",");
    const isNoSelected = selectedOptions.some(
      (option) => option.value == "No Guarantee"
    );

    if (isNoSelected) {
      setSelectedPrefFinancierMulti1([{ label: "No Guarantee", value: "No Guarantee" }]);
      validation.values.guarantee = "No Guarantee";
    } else {
      // Update selected options
      setSelectedPrefFinancierMulti1(selectedOptions);
    }
  };

  const handlePrefMulti2 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation.values.endUse = newData.join(",");
    setSelectedPrefFinancierMulti2(selectedOptions);
  };

  const handlePrefMulti3 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation.values.dealerArrangement = newData.join(",");
    setSelectedPrefFinancierMulti3(selectedOptions);
  };

  const handlePrefMulti4 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation.values.vendorsArrangement = newData.join(",");
    setSelectedPrefFinancierMulti4(selectedOptions);
  };

  const handlePrefMulti5 = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation.values.guaranteeTypesLender = newData.join(",");
    setSelectedPrefFinancierMulti5(selectedOptions);
  };

  const handlePrefMulti6 = (selectedOptions) => {
    const newData = selectedOptions.map(ele => ele.value);
    setPreferredPublicFinancier(newData);
    validation.setFieldValue("preferredFinancier", newData); // Update validation state
    setSelectedPrefFinancierMulti6(selectedOptions);
};


const handlePrefMulti7 = (selectedOptions) => {
  const newData = selectedOptions.map(ele => ele.value);
  setPreferredPrivateFinancier(newData);
  validation.setFieldValue("preferredFinancier", newData); // Update validation state
  setSelectedPrefFinancierMulti7(selectedOptions);
};

const handlePrefMulti8 = (selectedOptions) => {
  const newData = selectedOptions.map(ele => ele.value);
  setPreferredNbfcFinancier(newData);
  validation.setFieldValue("preferredFinancier", newData); // Update validation state
  setSelectedPrefFinancierMulti8(selectedOptions);
};
  const handleInputChange = (value) => {
    allEntity({ searchKey: value, nonFinancierType: '',sortingOrder: "asc" })
      .then((response) => {
        if (response?.data) {
          setEntityList(response.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleInputChangeForDealAuthor = (value) => {
    callGetCIUser()
      .then((response) => {
        setDealAuthorList(response.data.rows)
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const handleInputChangeForDealFIRM = (value) => {
    callGetCIUser()
      .then((response) => {
        setDealAuthorList(response.data.rows)
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const handleInputChangeForDealPrgrramRM = (value) => {
    callGetCIUser()
      .then((response) => {
        setDealAuthorList(response.data.rows)
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleCancel = () => {
    window.history.back();
  };

  const handleEntityChange = (option) => {
    setSelectedEntityName(option);
    validation.setFieldValue("entityId", option.value);
  };

  const handleAnchorChange = (option) => {
    setSelectedAnchorName(option);
    validation.setFieldValue("anchor", option.value);
  };

  const handleEntityChangeDealAuthor = (option) => {
    setSelectedDealAuthor(option);
    validation.setFieldValue("assignedTo", option.value);
  };
  const handleEntityChangeDealFIRM = (option) => {
    setSelectedDealFIRM(option);
    validation.setFieldValue("assignedToFirm", option.value);
  };

  const handleEntityChangeDealProgramRM = (option) => {
    setSelectedDealProgramRM(option);
    validation.setFieldValue("assignedToProgramRm", option.value);
  };
  
  const handleBankChange = (option) => {
    setSelectedBankName(option);
    validation.setFieldValue("bankName", option.label);
  };

  const bankValueChange = useAsyncDebounce((value) => {
    loadBankList(value);
  }, 500);

  const checkPermissions = async () => {
    const isAddNew = await isPermission("approve_deal", "approve_permission");
    const isFull = await isPermission("deal_detail", "full_access");
    const isRecommendFin = await isPermission("financier_preference", "view_permission");
    setIsfullAccess(isFull);
    setIsApprovePermission(isAddNew);
    setIsShowRecommendFinancier(isRecommendFin)
  };

  const apiFetchForLAP = (product) => {
    getDropDownList({ dropdownName: product })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == product)
            ?.dropdownValues || [];
        const formattedOptions = dropdownValues.map((option) => ({
          label: option.displayName,
          value: option.dropdownValue,
        }));
        setEndUseList(formattedOptions);
      })
      .catch((error) => {});

    getDropDownList({ dropdownName: "co_borrower_relation" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find(
            (dv) => dv.dropdownName == "co_borrower_relation"
          )?.dropdownValues || [];
        setCoBorrowerOfPropList(dropdownValues);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleDelete = (rowIndex) => {
    validation.values.propertyInfoList.splice(rowIndex, 1);
    validation.validateForm();
  };

  const createOnDropHandler = async (acceptedFiles, cb) => {
    const selectedFile = acceptedFiles[0];
    if (selectedFile) {
      cb({ percentage: 0 });
      let formData = new FormData();
      formData.append("upl", selectedFile);
      const config = {
        onUploadProgress: (progressEvent) => {
          const percentage = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          cb({ percentage });
        },
      };
      try {
        const response = await axios.post(
          `${API_URL}/s3/uploadSystemConfigFiles`,
          formData,
          config
        );
        if (response.status === 200) {
          cb({ file: response.data[0].fileName });
        } else {
          cb({ error: response.data.message });
        }
      } catch (error) {
        cb({ error: error.response.data.message });
      }
    }
  };

  const onDropForInput1 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressBankStat(result.percentage);
      setErrorMessageBankStat(result.error);
      validation.setFieldValue(docType, result.file);
    });
  });

  const onDropForInput2 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressCma(result.percentage);
      setErrorMessageCma(result.error);
      validation.setFieldValue(docType, result.file);
    });
  });

  const onDropForInput3 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressCoBoPan(result.percentage);
      setErrorMessageCoBoPan(result.error);
      validation.setFieldValue(docType, result.file);
    });
  });

  const onDropForInput4 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressCoBoItr(result.percentage);
      setErrorMessageCoBoItr(result.error);
      validation.setFieldValue(docType, result.file);
    });
  });

  const handleDeleteProduct = (rowIndex) => {
    validation.values.productInfoList.splice(rowIndex, 1);
    validation.validateForm();
    let productList = []
    let productTypeList = []
    validation.values.productInfoList.map((ele) => {
      if (ele.product) {
        productList.push(ele.product)
      }
      if (ele.productType) {
        productTypeList.push(ele.productType)
      }
    })
    setSelectedProducts(productList)
    setSelectedProductsType(productTypeList)
  };

  const handleProductChange = (product, productType, subProduct, index) => {
    const updatedProducts = [...selectedProducts];
    updatedProducts[index] = product;
    setSelectedProducts(updatedProducts);
    
  };

  const handleProductTypeChange = (product, productType, subProduct, index) => {
    setIsProductSelected(true);
    const updatedProducts = [...selectedProductsType];
    updatedProducts[index] = productType;
    setSelectedProductsType(updatedProducts);
  };

  useEffect(() => {

    if (selectedProducts.includes("Payable Financing") || selectedProducts.includes("Receivable Financing") || selectedProducts.includes("Inventory funding")) {
      selectedProducts.forEach((type) => {
        if (type === "Payable Financing" || type === "Receivable Financing" || type == "Inventory funding") {
          getDropDownList({
            dropdownName: type,
          })
            .then((response) => {
              const dropdownValues = response.data?.rows?.find(
                (dv) => dv.dropdownName === type
              )?.dropdownValues || [];
              setSubProductList(dropdownValues);
            })
            .catch((error) => {});
        }
      });
    }
    if (selectedProducts.includes("Loan against Property")) {
      apiFetchForLAP("enduse_loan_against_prop");
      const loanObj = {
        id: uId(),
        propertyNature: "",
        propertyOwner: "",
        propertyStatus: "",
        propertyValue: "",
        propertyAge: "",
        address: "",
        city: "",
        pincode: "",
        state: "",
        parentDeed: "",
        saleDeed: "",
        utilityBills: "",
        propertyTax: "",
      };
      validation.setFieldValue("propertyInfoList", [loanObj]);
    }
    if (selectedProducts.includes("End Use")) {
      apiFetchForLAP("End Use");
    }
    if (selectedProducts.includes("Equipment Finance")) {
      validation.values.isSecured = true;
      setSelectedIsSecured("Yes");
    }
    if (selectedProducts.includes("Receivable Financing")) {
      validation.values.facility = "Dealer";
    }
    if (selectedProducts.includes("Inventory funding")) {
      validation.values.facility = "Dealer";
    }
    if (selectedProducts.includes("Payable Financing")) {
      validation.values.facility = "Vendor";
    }
    let newObj = {}
    Object.keys(productSettingObj).forEach(key => {
      newObj[key] = false;
    });
    selectedProducts.forEach(product => {
      if (productSetting[product]) {
        Object.keys(productSetting[product]).forEach(key => {
          if (productSetting[product][key]) {
            newObj[key] = true;
          }
        });
      }
    });
    setProductSettingObj(newObj)
  }, [selectedProducts]);

  useEffect(() => {
    selectedProductsType.forEach((product) => {
      if (product === "Term loan") {
        getDropDownList({ dropdownName: "Security Cover" })
          .then((response) => {
            const dropdownValues =
              response.data?.rows?.find(
                (dv) => dv.dropdownName === "Security Cover"
              )?.dropdownValues || [];
            setSecurityCoverList(dropdownValues);
          })
          .catch((error) => {});

        getDropDownList({ dropdownName: "End Use" })
          .then((response) => {
            const dropdownValues =
              response.data?.rows?.find(
                (dv) => dv.dropdownName === "End Use"
              )?.dropdownValues || [];
            const formattedOptions = dropdownValues.map(
              (option) => ({
                label: option.displayName,
                value: option.dropdownValue,
              })
            );
            setEndUseList(formattedOptions);
          })
          .catch((error) => {});
      }

      if (product === "Working Capital") {
        getDropDownList({ dropdownName: "WC Tenure" })
          .then((response) => {
            const dropdownValues =
              response.data?.rows?.find(
                (dv) => dv.dropdownName === "WC Tenure"
              )?.dropdownValues || [];
            setTenureList(dropdownValues);
          })
          .catch((error) => {});
      } else {
        getDropDownList({ dropdownName: "Tenure" })
          .then((response) => {
            const dropdownValues =
              response.data?.rows?.find(
                (dv) => dv.dropdownName === "Tenure"
              )?.dropdownValues || [];
            setTenureList(dropdownValues);
          })
          .catch((error) => {});
      }
    });
  }, [selectedProductsType])

  const validateProductInfoList = (productInfoList, isShowSubProduct) => {
    const missingFields = [];
    productInfoList.forEach((productInfo, index) => {
      if (!productInfo.productType) missingFields.push(`Product Type in row ${index + 1}`);
      if (!productInfo.product) missingFields.push(`Product in row ${index + 1}`);
      if ((productInfo.product == 'Payable Financing' || productInfo.product == 'Receivable Financing' || productInfo.product == "Inventory funding") && productInfo.subProduct.length == 0) missingFields.push(`Sub Product in row ${index + 1}`);
    });
    return missingFields;
  };

  const handleDeleteShareHolding = (rowIndex) => {
    validation.values.shareholderList.splice(rowIndex, 1);
    setPercentageholdingValue(0);
    validation.validateForm();
  };

  const handleItemSelect = (data, value) => {
    data.type = value;
    validation.setFieldValue("type", value);
  };

  const onChangePercentageValue = (value) => {
    setPercentageholdingValue(percentageholdingValue + value);
  };

  let totalValue = 0;
  for (let value of validation.values.shareholderList) {
    totalValue += +value.percentageHolding;
    totalValue = Math.round(totalValue * 100) / 100;
  }

  const handleSubmitForShareHolding = (values,totalShareholding) => {
    let shareholdingPatternObj = {
      shareholdingAsOf: values.shareholdingAsOf,
      totalShareholding,
      entityId:values.entityId,
      shareholderList: values.shareholderList,
    };
    if (shareholdingList.length == 0) {
      addShareholding(shareholdingPatternObj)
        .then((response) => {
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      shareholdingPatternObj.id = shareholdingList[0].id;
      editShareholding(shareholdingPatternObj)
        .then((response) => {
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  const handleDateChange = (date) => {
    validation.setFieldValue('expectedClosureDate', date);
  };

  const callShareholdingApi = (entityId) => {
    getShareholdingList({ entityId: entityId ||selectedEntityName?.value })
      .then((response) => {
        const allshareholdings = response.data?.data || [];
        if (allshareholdings.length > 0) {
          const formatedDate = formatDateString1(
            allshareholdings[0].shareholdingAsOf
          );
          allshareholdings[0].shareholdingAsOf = formatedDate;
          setShareholdingList(allshareholdings);
          validation.setFieldValue("shareholdingAsOf", formatedDate);
          validation.setFieldValue("shareholderList", allshareholdings[0].shareholderList);
        }else{
          setShareholdingList([]);
          validation.setFieldValue("shareholdingAsOf", '');
          validation.setFieldValue("shareholderList", [{
            shareholderName: "",
            shareholderType: "",
            percentageHolding: "",
          }]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const ReferredFinancierList = () => {
    setRefferedFinModal(true)
    let productType = []
    let product = []
    let subProduct = []
    let entityId = validation.values.entityId
    let loanRequirement = validation.values.loanRequirement ? +validation.values.loanRequirement : ''
    let roi = validation.values.rateOfInterest ? +validation.values.rateOfInterest : ''

    if (validation.values.productInfoList) {
      validation.values.productInfoList?.map((ele) => {
        if (ele.productType) {
          productType.push(ele.productType)
        }
        if (ele.product) {
          product.push(ele.product)
        }
        if (ele.subProduct) {
          subProduct.push(ele.subProduct)
        }
      })
    }

    if (product, productType) {
      let obj = { productType, product, subProduct, loanRequirement, roi, entityId }
      callReferredFinancierList(obj)
        .then((response) => {
          if(response.data && response.data.length>0){
            setReferredFinancierList(response.data)
          }else{
            setReferredFinancierList([])
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  useEffect(() => {
    allEntity({ searchKey: selectedEntityName.label, nonFinancierType: '', sortingOrder: "asc" })
      .then((response) => {
        if (response?.data && response?.data[0] && response?.data[0]?.programOwner) {
          validation.setFieldValue("assignedTo", response?.data[0].programOwner);
          let datafilter = dealAuthorList?.filter((ele) => {
            if (ele.id == response?.data[0].programOwner) {
              return ele
            }
          })
          if (datafilter?.length > 0) {
            let value = { label: datafilter[0].firstName + " " + datafilter[0].lastName, value: datafilter[0].id }
            setSelectedDealAuthor(value);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [selectedEntityName])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="ADD DEAL" />
          <Row className="vertical-scroll">
            <Col xs="12">
              <div>
                <div>
                  <FormikProvider value={validation}>
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        // handleSubmit(e);
                        return false;
                      }}
                      className=""
                    >
                      {/* <div>
                        <h5 style={{ marginTop: "1%" }}>Deal Details</h5>
                      </div> */}

                      <div className="mb-3 row">
                        {isAdmin && (
                          <Col sm="12" md="6">
                            <Label className="form-label grey">
                              Select Entity Type*
                            </Label>
                            <Input
                              name="dealType"
                              type="select"
                              placeholder="Select Entity Type"
                              onChange={(e) => {
                                setDealType(e.target.value)
                                validation.handleChange(e);

                              }}
                              onBlur={validation.handleBlur}
                              value={validation.values.dealType || ""}
                              invalid={!!(validation.touched.dealType && validation.errors.dealType)}
                            >
                              <option
                                value=""
                              >
                                Select Entity Type
                              </option>
                              <option
                                value="Anchor"
                              >
                                Anchor
                              </option>
                              <option
                                value="Counterparty"
                              >
                                Counterparty
                              </option>
                              <option
                                value="Standalone"
                              >
                                Standalone
                              </option>
                            </Input>
                            {validation.touched.dealType &&
                              validation.errors.dealType ? (
                              <FormFeedback type="invalid">
                                {validation.errors.dealType}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {isAdmin && (
                          <Col sm="12" md="6">
                            <Label className="form-label grey mt-mobile">
                              Entity Name*
                            </Label>
                            <Select
                              options={entityList?.map((option, index) => ({
                                label: option.entityName,
                                value: option.id,
                              }))}
                              className={`select-dropdown ${validation.touched.entityId &&
                                validation.errors.entityId
                                ? "is-invalid"
                                : ""
                                }`}
                              isDisabled={!selectedDealType || isDisableEntity}
                              name="entityId"
                              id="entityId"
                              placeholder={"Enter Entity Name"}
                              value={selectedEntityName}
                              onInputChange={(e) => {
                                handleInputChange(e)
                              }}
                              onMenuOpen={(e) => {
                                hasOpenedBefore ? handleInputChange("") : null;
                                setHasOpenedBefore(false);
                              }}
                              onChange={(selectedOption) => {
                                setSelectedEntityName(selectedOption.label)
                                handleEntityChange(selectedOption);
                                callShareholdingApi(selectedOption?.value);
                                selectedDealType == "Counterparty" ?
                                  handleAnchorSelect(selectedOption.value) : null
                              }}
                              onBlur={() => {
                                validation.setFieldTouched('entityId', true);
                              }}
                            />
                            {validation.touched.entityId &&
                              validation.errors.entityId && (
                                <FormFeedback>
                                  {validation.errors.entityId}
                                </FormFeedback>
                              )}
                          </Col>
                        )}

                        {selectedDealType.toLowerCase() == "counterparty" && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Select Anchor*
                            </Label>
                            {/* <Input
                              name="anchor"
                              type="select"
                              onChange={(e) => {
                                validation.handleChange(e);
                              }}
                              onBlur={validation.handleBlur}
                              value={validation.values.anchor || ""}
                              invalid={
                                validation.touched.anchor &&
                                validation.errors.anchor
                              }
                            >
                              <option value="" disabled>
                                Select Anchor
                              </option>
                              {entityList?.map((option, index) => (
                                <option
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option.entityName}
                                </option>
                              ))}
                            </Input> */}
                            <Select
                              options={entityList?.map((option, index) => ({
                                label: option.entityName,
                                value: option.id,
                              }))}
                              className={`select-dropdown ${validation.touched.anchor &&
                                validation.errors.anchor
                                ? "is-invalid"
                                : ""
                                }`}
                              name="anchor"
                              id="anchor"
                              placeholder={"Enter Anchor Name"}
                              value={selectedAnchorName}
                              onInputChange={(e) => {
                                handleInputChange(e)
                              }}
                              onMenuOpen={(e) => {
                                hasOpenedBefore ? handleInputChange("") : null;
                                setHasOpenedBefore(false);
                              }}
                              onChange={(selectedOption) => {
                                setSelectedAnchorName(selectedOption.label)
                                handleAnchorChange(selectedOption);
                              }}
                              onBlur={() => {
                                validation.setFieldTouched('anchor', true);
                              }}
                            />
                            {validation.touched.anchor &&
                              validation.errors.anchor ? (
                              <FormFeedback type="invalid">
                                {validation.errors.anchor}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {isAdmin && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Select Prospective Product*
                          </Label>
                          <Input
                            name="prospectiveProduct"
                            type="select"
                            placeholder="Select Prospective Product"
                            onChange={(e) => {
                              validation.handleChange(e);
                              const selectedProduct = e.target.value;
                               // Reset Partner Program if Prospective Product is not "TradEasy"
                               if (selectedProduct !== "TradEasy") {
                               validation.setFieldValue("partnerProgram", "");  // Reset Partner Program
                               }
                              getDropDownList({ dropdownName: "Proposal Type" })
                                .then((response) => {
                                  const dropdownValues =
                                    response.data?.rows?.find((dv) => dv.dropdownName == "Proposal Type")
                                      ?.dropdownValues || [];
                                  setProsposalTypeList(dropdownValues);
                                })
                                .catch((error) => { });
                                if (selectedProduct === 'TradEasy') {
                                  validation.setFieldValue('productInfoList[0].platformChargesType', 'Flat');
                                  validation.setFieldValue('productInfoList[0].platformChargesFrequency', 'One time');
                                  validation.setFieldValue('productInfoList[0].integrationFeesType', 'Flat');
                                  validation.setFieldValue('productInfoList[0].integrationFeesFrequency', 'One time');
                                  validation.setFieldValue('productInfoList[0].syndicationFeesType', 'Flat');
                                  validation.setFieldValue('productInfoList[0].syndicationFeesFrequency', 'One time');
      
                                }
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.prospectiveProduct || ""}
                            invalid={!!(validation.touched.prospectiveProduct && validation.errors.prospectiveProduct)}
                          >
                            <option value="" disabled> Select Prospective Product</option>
                            {prospectiveProductList?.map((option, index) => (
                              <option
                                key={option.id}
                                value={option.dropdownValue}
                              >
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.prospectiveProduct &&
                            validation.errors.prospectiveProduct ? (
                            <FormFeedback type="invalid">
                              {validation.errors.prospectiveProduct}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {isAdmin && validation.values.prospectiveProduct && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                          Select Proposal Type*
                          </Label>
                          <Input
                            name="proposalType"
                            type="select"
                            placeholder="Select Proposal Type"
                            onChange={(e) => {
                              validation.handleChange(e);
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.proposalType || ""}
                            invalid={!!(validation.touched.proposalType && validation.errors.proposalType)}
                          >
                            <option value="" disabled> Select Proposal Type</option>
                            {prosposalTypeList?.map((option, index) => (
                              <option
                                key={option.id}
                                value={option.dropdownValue}
                              >
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.proposalType &&
                            validation.errors.proposalType ? (
                            <FormFeedback type="invalid">
                              {validation.errors.proposalType}
                            </FormFeedback>
                          ) : null}
                        </Col>)}
   
                        {isAdmin && validation.values.prospectiveProduct === "TradEasy" && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">Partner Program</Label>
                            <Select
                              name="partnerProgram"
                              placeholder="Select Partner Program"
                              options={partnerProgramList?.map(option => ({
                                value: option.dropdownValue,
                                label: option.displayName
                              }))}
                              onChange={(selectedOption) => {
                                validation.setFieldValue("partnerProgram", selectedOption ? selectedOption.value : "");
                              }}
                              onBlur={() => validation.setFieldTouched("partnerProgram", true)}
                              value={
                                partnerProgramList.find(
                                  option => option.dropdownValue === validation.values.partnerProgram
                                )
                                  ? {
                                    value: validation.values.partnerProgram,
                                    label: partnerProgramList.find(
                                      option => option.dropdownValue === validation.values.partnerProgram
                                    )?.displayName
                                  }
                                  : null
                              }
                              isClearable
                            />
                            {validation.touched.partnerProgram && validation.errors.partnerProgram ? (
                              <FormFeedback type="invalid">
                                {validation.errors.partnerProgram}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        )}
                        {selectedEntityName != '' && (
                          <Col lg="12" sm="12">
                            <FieldArray
                              name="productInfoList"
                              render={(arrayHelpers) => (
                                <>
                                  {validation.values.productInfoList.map(
                                    (file, index) => (
                                      <ProductRow
                                        key={file.id}
                                        onDelete={handleDeleteProduct}
                                        index={index}
                                        validation={validation}
                                        change={handleProductChange}
                                        changeType={handleProductTypeChange}
                                        commercialFieldsData={commercialFieldsData}
                                        callShareholdingApi = {callShareholdingApi}
                                        isAdmin = {isAdmin}
                                      />
                                    )
                                  )}
                                  <span
                                    className="text-success"
                                    style={{ cursor: "pointer" }}
                                    onKeyUp={() => {}}
                                    onClick={() => {
                                      arrayHelpers.push({
                                        id: uId(),
                                        product: '',
                                        productType: '',
                                        subProduct: [],
                                        integrationFeesType: '',
                                        integrationFeesFrequency: '',
                                        integrationFeesOccurrence: '',
                                        integrationFeesValue: '',
                                        syndicationFeesType: '',
                                        syndicationFeesFrequency: '',
                                        syndicationFeesOccurrence: '',
                                        syndicationFeesValue: '',
                                      });
                                    }}
                                  >
                                    <i className="mdi mdi-plus me-1" /> Add
                                    Product
                                  </span>
                                </>
                              )}
                            />
                          </Col>
                        )}

                        {productSettingObj.requested_loan_amount && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Requested Loan Amount
                            </Label>
                            <Input
                              name="loanRequirement"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.loanRequirement || ""}
                              invalid={
                                validation.touched.loanRequirement &&
                                validation.errors.loanRequirement
                              }
                            />
                            {validation.touched.loanRequirement &&
                              validation.errors.loanRequirement ? (
                              <FormFeedback type="invalid">
                                {validation.errors.loanRequirement}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        )}


                        {productSettingObj.interest_rate && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Expected Rate of Interest (%)
                          </Label>
                          <Input
                            name="rateOfInterest"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.rateOfInterest || ""}
                            invalid={
                              validation.touched.rateOfInterest &&
                              validation.errors.rateOfInterest
                            }
                          />
                          {validation.touched.rateOfInterest &&
                            validation.errors.rateOfInterest ? (
                            <FormFeedback type="invalid">
                              {validation.errors.rateOfInterest}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.loan_tenure && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">Tenure</Label>
                          <Input
                            name="tenure"
                            type="select"
                            placeholder="Enter Entity constitution"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.tenure || ""}
                            invalid={
                              validation.touched.tenure &&
                              validation.errors.tenure
                            }
                          >
                            <option value="" disabled>
                              Select Tenure
                            </option>
                            {tenureList.map((option, index) => (
                              <option
                                key={option.id}
                                value={option.dropdownValue}
                              >
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.tenure &&
                            validation.errors.tenure ? (
                            <FormFeedback type="invalid">
                              {validation.errors.tenure}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.percentageOfEquityDiluted && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What % of equity to be diluted?
                          </Label>
                          <Input
                            name="percentageOfEquityDiluted"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.percentageOfEquityDiluted || ""}
                            invalid={
                              validation.touched.percentageOfEquityDiluted &&
                              validation.errors.percentageOfEquityDiluted
                            }
                          />
                          {validation.touched.percentageOfEquityDiluted &&
                            validation.errors.percentageOfEquityDiluted ? (
                            <FormFeedback type="invalid">
                              {validation.errors.percentageOfEquityDiluted}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.shareHoldingPattern && (
                          <Col sm="12" md="12" className="mt-4">
                            <div>
                              <Card className="p-3 mt-3">
                                <Row className="mb-4">
                                  <Col lg={3} className="me-5">
                                    <Label
                                      htmlFor="horizontal-email-Input"
                                      className="col-sm-12 col-form-label"
                                    >
                                      Shareholding as of
                                    </Label>
                                    <Input
                                      type="date"
                                      className="form-control"
                                      name="shareholdingAsOf"
                                      id="shareholdingAsOf"
                                      max={currentDate}
                                      value={validation.values.shareholdingAsOf || ""}
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      invalid={
                                        !!(
                                          validation.touched.shareholdingAsOf &&
                                          validation.errors.shareholdingAsOf
                                        )
                                      }
                                    />
                                    {validation.touched.shareholdingAsOf &&
                                      validation.errors.shareholdingAsOf ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.shareholdingAsOf}
                                      </FormFeedback>
                                    ) : null}
                                  </Col>
                                  <Col lg={2} sm={4}>
                                    <Label
                                      htmlFor="horizontal-email-Input"
                                      className="col-sm-12 mt-2"
                                    >
                                      Total shareholding %
                                    </Label>
                                    <div className="shareholdingPercent">{totalValue}</div>
                                  </Col>
                                  <Col lg={2}></Col>
                                </Row>
                                <Row>
                                  <Col sm="12">
                                    <div className="mb-3">
                                      <Table
                                        Table
                                        striped
                                        bordered
                                        hover
                                        style={{ width: "100%", backgroundColor: "white" }}
                                      >
                                        <thead>
                                          <tr>
                                            <th>Shareholder Name</th>
                                            <th>Shareholder Type</th>
                                            <th>% Holding</th>
                                            <th></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <FieldArray
                                            name="shareholderList"
                                            render={(arrayHelpers) => (
                                              <>
                                                {validation.values.shareholderList.map(
                                                  (shareholder, index) => (
                                                    <TableRowShareHolding
                                                      key={shareholder.id}
                                                      onDelete={handleDeleteShareHolding}
                                                      onItemSelect={handleItemSelect}
                                                      index={index}
                                                      validation={validation}
                                                      percentageholdingValue={
                                                        onChangePercentageValue
                                                      }
                                                    />
                                                  )
                                                )}
                                                <tr>
                                                  <td colSpan={5}>
                                                    <span
                                                      className="text-success"
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => {
                                                        arrayHelpers.push({
                                                          shareholderName: "",
                                                          shareholderType: "",
                                                          percentageHolding: "",
                                                        });
                                                      }}
                                                    >
                                                      <i className="mdi mdi-plus me-1" /> Add
                                                      Shareholder
                                                    </span>
                                                  </td>
                                                </tr>
                                              </>
                                            )}
                                          />
                                        </tbody>
                                      </Table>
                                    </div>
                                  </Col>
                                </Row>
                              </Card>
                            </div>
                          </Col>
                        )}

                        {productSettingObj.isValuationDone && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Has the valuation being done?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="isValuationDone1"
                                  value="Yes"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={valuationDone == "Yes"}
                                  onClick={(event) => {
                                    if (event.target.value == "Yes") {
                                      validation.setFieldValue("isValuationDone", true);
                                    } else {
                                      validation.setFieldValue("isValuationDone", false);
                                    }
                                    setValuationDone(event.target.value);
                                    setValuationDoneError("");
                                  }}
                                />
                                <Label
                                  htmlFor="isValuationDone1"
                                  className="ms-2"
                                >
                                  Yes
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="isValuationDone2"
                                  onChange={() => { }}
                                  value="No"
                                  style={{ border: "1px solid black" }}
                                  checked={valuationDone == "No"}
                                  onClick={(event) => {
                                    if (event.target.value == "Yes") {
                                      validation.setFieldValue("isValuationDone", true);
                                    } else {
                                      validation.setFieldValue("isValuationDone", false);
                                    }
                                    setValuationDone(event.target.value);
                                    setValuationDoneError("");
                                  }}
                                />
                                <Label
                                  htmlFor="isValuationDone2"
                                  className="ms-2"
                                >
                                  No
                                </Label>
                              </div>
                            </div>
                            {valuationDoneError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {valuationDoneError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.investorsType && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What kind of investors accepted to the company?
                          </Label>
                          <Input
                            name="investorsType"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.investorsType || ""}
                            invalid={
                              validation.touched.investorsType &&
                              validation.errors.investorsType
                            }
                          />
                          {validation.touched.investorsType &&
                            validation.errors.investorsType ? (
                            <FormFeedback type="invalid">
                              {validation.errors.investorsType}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.equityType && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Whether it is preference share equity or normal equity?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="equityType1"
                                  value="Preference share equity"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={selectEquityType == "Preference share equity"}
                                  onClick={(event) => {
                                    validation.setFieldValue("equityType", event.target.value);
                                    setSelectEquityType(event.target.value);
                                    setSelectEquityTypeError("");
                                  }}
                                />
                                <Label
                                  htmlFor="equityType1"
                                  className="ms-2"
                                >
                                  Preference share equity
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="equityType2"
                                  onChange={() => { }}
                                  value="Normal equity"
                                  style={{ border: "1px solid black" }}
                                  checked={selectEquityType == "Normal equity"}
                                  onClick={(event) => {
                                    validation.setFieldValue("equityType", event.target.value);
                                    setSelectEquityType(event.target.value);
                                    setSelectEquityTypeError("");
                                  }}
                                />
                                <Label
                                  htmlFor="equityType2"
                                  className="ms-2"
                                >
                                  Normal equity
                                </Label>
                              </div>
                            </div>
                            {selectEquityTypeError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {selectEquityTypeError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.purposeOfRaisingEquity && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What is the purpose of raising Equity?
                          </Label>
                          <Input
                            name="purposeOfRaisingEquity"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.purposeOfRaisingEquity || ""}
                            invalid={
                              validation.touched.purposeOfRaisingEquity &&
                              validation.errors.purposeOfRaisingEquity
                            }
                          />
                          {validation.touched.purposeOfRaisingEquity &&
                            validation.errors.purposeOfRaisingEquity ? (
                            <FormFeedback type="invalid">
                              {validation.errors.purposeOfRaisingEquity}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.freshOrDiluted && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Is it fresh equity or diluted equity?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="freshOrDiluted1"
                                  value="Fresh equity"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={selectFreshOrDiluted == "Fresh equity"}
                                  onClick={(event) => {
                                    validation.setFieldValue("freshOrDiluted", event.target.value);
                                    setSelectFreshOrDiluted(event.target.value);
                                    setSelectFreshOrDilutedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="freshOrDiluted1"
                                  className="ms-2"
                                >
                                  Fresh equity
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="freshOrDiluted2"
                                  onChange={() => { }}
                                  value="Diluted equity"
                                  style={{ border: "1px solid black" }}
                                  checked={selectFreshOrDiluted == "Diluted equity"}
                                  onClick={(event) => {
                                    validation.setFieldValue("freshOrDiluted", event.target.value);
                                    setSelectFreshOrDiluted(event.target.value);
                                    setSelectFreshOrDilutedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="freshOrDiluted2"
                                  className="ms-2"
                                >
                                  Diluted equity
                                </Label>
                              </div>
                            </div>
                            {selectFreshOrDilutedError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {selectFreshOrDilutedError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.dilutedEquityHolder && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Whose equity is being diluted?
                          </Label>
                          <Input
                            name="dilutedEquityHolder"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.dilutedEquityHolder || ""}
                            invalid={
                              validation.touched.dilutedEquityHolder &&
                              validation.errors.dilutedEquityHolder
                            }
                          />
                          {validation.touched.dilutedEquityHolder &&
                            validation.errors.dilutedEquityHolder ? (
                            <FormFeedback type="invalid">
                              {validation.errors.dilutedEquityHolder}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.capexEquipmentImported && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What is the capex equipment being imported?
                          </Label>
                          <Input
                            name="capexEquipmentImported"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.capexEquipmentImported || ""}
                            invalid={
                              validation.touched.capexEquipmentImported &&
                              validation.errors.capexEquipmentImported
                            }
                          />
                          {validation.touched.capexEquipmentImported &&
                            validation.errors.capexEquipmentImported ? (
                            <FormFeedback type="invalid">
                              {validation.errors.capexEquipmentImported}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.bankAvalizingBill && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Which bank will abalize or co-accept the bill of exchange?
                          </Label>
                          <Input
                            name="bankAvalizingBill"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.bankAvalizingBill || ""}
                            invalid={
                              validation.touched.bankAvalizingBill &&
                              validation.errors.bankAvalizingBill
                            }
                          />
                          {validation.touched.bankAvalizingBill &&
                            validation.errors.bankAvalizingBill ? (
                            <FormFeedback type="invalid">
                              {validation.errors.bankAvalizingBill}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.debenturesSecuredOrUnsecured && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Whether the debentures are secured or unsecured?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="debenturesSecuredOrUnsecured1"
                                  value="Secured"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={selectdebenturesSecuredOrUnsecured == "Secured"}
                                  onClick={(event) => {
                                    validation.setFieldValue("debenturesSecuredOrUnsecured", event.target.value);
                                    setSelectdebenturesSecuredOrUnsecured(event.target.value);
                                    setSelectdebenturesSecuredOrUnsecuredError("");
                                  }}
                                />
                                <Label
                                  htmlFor="debenturesSecuredOrUnsecured1"
                                  className="ms-2"
                                >
                                  Secured
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="debenturesSecuredOrUnsecured2"
                                  onChange={() => { }}
                                  value="Unsecured"
                                  style={{ border: "1px solid black" }}
                                  checked={selectdebenturesSecuredOrUnsecured == "Unsecured"}
                                  onClick={(event) => {
                                    validation.setFieldValue("debenturesSecuredOrUnsecured", event.target.value);
                                    setSelectdebenturesSecuredOrUnsecured(event.target.value);
                                    setSelectdebenturesSecuredOrUnsecuredError("");
                                  }}
                                />
                                <Label
                                  htmlFor="debenturesSecuredOrUnsecured2"
                                  className="ms-2"
                                >
                                  Unsecured
                                </Label>
                              </div>
                            </div>
                            {selectdebenturesSecuredOrUnsecuredError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {selectdebenturesSecuredOrUnsecuredError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.debenturesRatedOrUnrated && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Whether the Debentures are rated or unrated?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="debenturesRatedOrUnrated1"
                                  value="Rated"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={selectdebenturesRatedOrUnrated == "Rated"}
                                  onClick={(event) => {
                                    validation.setFieldValue("debenturesRatedOrUnrated", event.target.value);
                                    setSelectdebenturesRatedOrUnrated(event.target.value);
                                    setSelectdebenturesRatedOrUnratedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="debenturesRatedOrUnrated1"
                                  className="ms-2"
                                >
                                  Rated
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="debenturesRatedOrUnrated2"
                                  onChange={() => { }}
                                  value="Unrated"
                                  style={{ border: "1px solid black" }}
                                  checked={selectdebenturesRatedOrUnrated == "Unrated"}
                                  onClick={(event) => {
                                    validation.setFieldValue("debenturesRatedOrUnrated", event.target.value);
                                    setSelectdebenturesRatedOrUnrated(event.target.value);
                                    setSelectdebenturesRatedOrUnratedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="debenturesRatedOrUnrated2"
                                  className="ms-2"
                                >
                                  Unrated
                                </Label>
                              </div>
                            </div>
                            {selectdebenturesRatedOrUnratedError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {selectdebenturesRatedOrUnratedError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.purposeOfIssuingDebentures && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Purpose of issuing Debentures?
                          </Label>
                          <Input
                            name="purposeOfIssuingDebentures"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.purposeOfIssuingDebentures || ""}
                            invalid={
                              validation.touched.purposeOfIssuingDebentures &&
                              validation.errors.purposeOfIssuingDebentures
                            }
                          />
                          {validation.touched.purposeOfIssuingDebentures &&
                            validation.errors.purposeOfIssuingDebentures ? (
                            <FormFeedback type="invalid">
                              {validation.errors.purposeOfIssuingDebentures}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.purposeOfIssuingCommercial && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Purpose of issuing Commercial Paper?
                          </Label>
                          <Input
                            name="purposeOfIssuingCommercial"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.purposeOfIssuingCommercial || ""}
                            invalid={
                              validation.touched.purposeOfIssuingCommercial &&
                              validation.errors.purposeOfIssuingCommercial
                            }
                          />
                          {validation.touched.purposeOfIssuingCommercial &&
                            validation.errors.purposeOfIssuingCommercial ? (
                            <FormFeedback type="invalid">
                              {validation.errors.purposeOfIssuingCommercial}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.commercialRatedOrUnrated && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Whether the Commercial Papers are rated or unrated?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="commercialRatedOrUnrated1"
                                  value="Rated"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={selectCommercialRatedOrUnrated == "Rated"}
                                  onClick={(event) => {
                                    validation.setFieldValue("commercialRatedOrUnrated", event.target.value);
                                    setSelectCommercialRatedOrUnrated(event.target.value);
                                    setSelectCommercialRatedOrUnratedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="commercialRatedOrUnrated1"
                                  className="ms-2"
                                >
                                  Rated
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="commercialRatedOrUnrated2"
                                  onChange={() => { }}
                                  value="Unrated"
                                  style={{ border: "1px solid black" }}
                                  checked={selectCommercialRatedOrUnrated == "Unrated"}
                                  onClick={(event) => {
                                    validation.setFieldValue("commercialRatedOrUnrated", event.target.value);
                                    setSelectCommercialRatedOrUnrated(event.target.value);
                                    setSelectCommercialRatedOrUnratedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="commercialRatedOrUnrated2"
                                  className="ms-2"
                                >
                                  Unrated
                                </Label>
                              </div>
                            </div>
                            {selectCommercialRatedOrUnratedError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {selectCommercialRatedOrUnratedError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.coupon && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What is the coupon?
                          </Label>
                          <Input
                            name="coupon"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.coupon || ""}
                            invalid={
                              validation.touched.coupon &&
                              validation.errors.coupon
                            }
                          />
                          {validation.touched.coupon &&
                            validation.errors.coupon ? (
                            <FormFeedback type="invalid">
                              {validation.errors.coupon}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.poolPSLorNonPSL && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Whether the pool is securitise as PSL or non PSL?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="poolPSLorNonPS1"
                                  value="PSL"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={selectPoolPSLorNonPSL == "PSL"}
                                  onClick={(event) => {
                                    validation.setFieldValue("poolPSLorNonPSL", event.target.value);
                                    setSelectpoolPSLorNonPSL(event.target.value);
                                    setSelectpoolPSLorNonPSLError("");
                                  }}
                                />
                                <Label
                                  htmlFor="poolPSLorNonPS1"
                                  className="ms-2"
                                >
                                  PSL
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="poolPSLorNonPSL2"
                                  onChange={() => { }}
                                  value="Non PSL"
                                  style={{ border: "1px solid black" }}
                                  checked={selectPoolPSLorNonPSL == "Non PSL"}
                                  onClick={(event) => {
                                    validation.setFieldValue("poolPSLorNonPSL", event.target.value);
                                    setSelectpoolPSLorNonPSL(event.target.value);
                                    setSelectpoolPSLorNonPSLError("");
                                  }}
                                />
                                <Label
                                  htmlFor="poolPSLorNonPSL2"
                                  className="ms-2"
                                >
                                  Non PSL
                                </Label>
                              </div>
                            </div>
                            {selectPoolPSLorNonPSLError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {selectPoolPSLorNonPSLError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.poolRatedOrUnrated && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Whether the pool is rated or unrated?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="poolRatedOrUnrated1"
                                  value="Rated"
                                  onChange={() => { }}
                                  style={{ border: "1px solid black" }}
                                  checked={selectPoolRatedOrUnrated == "Rated"}
                                  onClick={(event) => {
                                    validation.setFieldValue("poolRatedOrUnrated", event.target.value);
                                    setSelectpoolRatedOrUnrated(event.target.value);
                                    setSelectpoolRatedOrUnratedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="poolRatedOrUnrated1"
                                  className="ms-2"
                                >
                                  Rated
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="poolRatedOrUnrated2"
                                  onChange={() => { }}
                                  value="Unrated"
                                  style={{ border: "1px solid black" }}
                                  checked={selectPoolRatedOrUnrated == "Unrated"}
                                  onClick={(event) => {
                                    validation.setFieldValue("poolRatedOrUnrated", event.target.value);
                                    setSelectpoolRatedOrUnrated(event.target.value);
                                    setSelectpoolRatedOrUnratedError("");
                                  }}
                                />
                                <Label
                                  htmlFor="poolRatedOrUnrated2"
                                  className="ms-2"
                                >
                                  Unrated
                                </Label>
                              </div>
                            </div>
                            {selectPoolRatedOrUnratedError && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {selectPoolRatedOrUnratedError}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.desiredCoupon && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What is the coupon which are looking for?
                          </Label>
                          <Input
                            name="desiredCoupon"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.desiredCoupon || ""}
                            invalid={
                              validation.touched.desiredCoupon &&
                              validation.errors.desiredCoupon
                            }
                          />
                          {validation.touched.desiredCoupon &&
                            validation.errors.desiredCoupon ? (
                            <FormFeedback type="invalid">
                              {validation.errors.desiredCoupon}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.poolAgeing && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What is the ageing of the pool(Month/Year)?
                          </Label>
                          <Input
                            name="poolAgeing"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.poolAgeing || ""}
                            invalid={
                              validation.touched.poolAgeing &&
                              validation.errors.poolAgeing
                            }
                          />
                          {validation.touched.poolAgeing &&
                            validation.errors.poolAgeing ? (
                            <FormFeedback type="invalid">
                              {validation.errors.poolAgeing}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {(productSettingObj.loan_type && <Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Loan Type
                          </Label>
                          <Input
                            name="loanType"
                            type="select"
                            placeholder="Enter Entity constitution"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.loanType || ""}
                            invalid={
                              validation.touched.loanType &&
                              validation.errors.loanType
                            }
                          >
                            <option value="" disabled>
                              Select Loan Type
                            </option>
                            {loanTypeList.map((option, index) => (
                              <option
                                key={option.id}
                                value={option.dropdownValue}
                              >
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.loanType &&
                            validation.errors.loanType ? (
                            <FormFeedback type="invalid">
                              {validation.errors.loanType}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.guarantee && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Guarantee
                          </Label>
                          <Select
                            name="guarantee"
                            value={selectedMulti1}
                            isMulti={true}
                            onChange={handleMulti1}
                            options={guaranteeList}
                            onBlur={validation.handleBlur}
                            className="select2-selection"
                          // isDisabled={true}
                          />
                          {validation.touched.guarantee &&
                            validation.values.guarantee == "" && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                              >
                                {validation.errors.guarantee}
                              </p>
                            )}
                        </Col>)}

                        {productSettingObj.is_loan_secured && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Is Loan Secured?
                            </Label>
                            <div className="d-flex ms-4">
                              <div>
                                <Input
                                  type="radio"
                                  id="isSecured1"
                                  value="Yes"
                                  onChange={() => {}}
                                  style={{ border: "1px solid black" }}
                                  checked={selectedIsSecured == "Yes"}
                                  onClick={handleSecureChange}
                                />
                                <Label
                                  htmlFor="isSecured1"
                                  className="ms-2"
                                >
                                  Yes
                                </Label>
                              </div>
                              <div className="ms-4">
                                <Input
                                  type="radio"
                                  id="isSecured2"
                                  onChange={() => {}}
                                  value="No"
                                  style={{ border: "1px solid black" }}
                                  checked={selectedIsSecured == "No"}
                                  onClick={handleSecureChange}
                                />
                                <Label
                                  htmlFor="isSecured2"
                                  className="ms-2"
                                >
                                  No
                                </Label>
                              </div>
                            </div>
                            {errorSecured && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                                className="ms-4"
                              >
                                {errorSecured}
                              </p>
                            )}
                          </Col>
                        )}

                        {selectedIsSecured == "Yes" && isProductSelected && productSettingObj.is_loan_secured && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Security Cover
                            </Label>
                            <Input
                              name="securityCover"
                              type="select"
                              placeholder="Enter Entity constitution"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.securityCover || ""}
                              invalid={
                                validation.touched.securityCover &&
                                validation.errors.securityCover
                              }
                            >
                              <option value="" disabled>
                                Select Security Cover
                              </option>
                              {securityCoverList.map((option, index) => (
                                <option
                                  key={option.id}
                                  value={option.dropdownValue}
                                >
                                  {option.displayName}
                                </option>
                              ))}
                            </Input>
                            {validation.touched.securityCover &&
                              validation.errors.securityCover ? (
                              <FormFeedback type="invalid">
                                {validation.errors.securityCover}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {productSettingObj.end_use && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Select End Use
                          </Label>
                          <Select
                            name="endUse"
                            value={selectedMulti2}
                            isMulti={true}
                            onChange={handleMulti2}
                            options={endUseList}
                            className="select2-selection"
                          // isDisabled={true}
                          />
                          {validation.touched.endUse &&
                            validation.values.endUse == "" && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                              >
                                {validation.errors.endUse}
                              </p>
                            )}
                        </Col>)}

                        {productSettingObj.primary_security && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Select Primary Security Type
                          </Label>
                          <Input
                            name="primarySecurity"
                            type="select"
                            onChange={(e) => {
                              validation.handleChange(e);
                            }}
                            onBlur={validation.handleBlur}
                            value={
                              validation.values.primarySecurity || ""
                            }
                            invalid={
                              validation.touched.primarySecurity &&
                              validation.errors.primarySecurity
                            }
                          >
                            <option value="" disabled>
                              Select Primary Security Type
                            </option>
                            {primarySecurityList.map(
                              (option, index) => (
                                <option
                                  key={option.id}
                                  value={option.dropdownValue}
                                >
                                  {option.displayName}
                                </option>
                              )
                            )}
                          </Input>
                          {validation.touched.primarySecurity &&
                            validation.errors.primarySecurity ? (
                            <FormFeedback type="invalid">
                              {validation.errors.primarySecurity}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.charge_type && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What Is The Type of Charge?
                          </Label>
                          <Input
                            name="typeOfCharge"
                            type="select"
                            onChange={(e) => {
                              validation.handleChange(e);
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.typeOfCharge || ""}
                            invalid={
                              validation.touched.typeOfCharge &&
                              validation.errors.typeOfCharge
                            }
                          >
                            <option value="" disabled>
                              Select type of charge
                            </option>
                            {typeOfChargeList.map((option, index) => (
                              <option
                                key={option.id}
                                value={option.dropdownValue}
                              >
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.typeOfCharge &&
                            validation.errors.typeOfCharge ? (
                            <FormFeedback type="invalid">
                              {validation.errors.typeOfCharge}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.cma_documents && (<Col sm="12" md="6">
                          <DynamicFileUploadInput
                            label={"Upload CMA Documents"}
                            inputName={"cmaDoc"}
                            onDropHandler={(acceptedFiles) =>
                              onDropForInput2("cmaDoc", acceptedFiles)
                            }
                            isDragActive={true}
                            validation={validation}
                            uploadProgress={uploadProgressCma}
                            errorMessage={errorMessageCma}
                          />
                        </Col>)}

                        {productSettingObj.equipment_category && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Equipment Category
                          </Label>
                          <div className="d-flex ms-4">
                            <div className="d-flex">
                              <Input
                                type="radio"
                                id="equipmentCategory1"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="Construction Equipment"
                                checked={
                                  selectedEquipment ==
                                  "Construction Equipment"
                                }
                                onClick={handleEquipmetChange}
                              />
                              <Label
                                htmlFor="equipmentCategory1"
                                className="ms-2"
                              >
                                Construction Equipment
                              </Label>
                            </div>
                            <div className="ms-4 d-flex">
                              <Input
                                type="radio"
                                id="equipmentCategory2"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="Industrial Equipment"
                                checked={
                                  selectedEquipment ==
                                  "Industrial Equipment"
                                }
                                onClick={handleEquipmetChange}
                              />
                              <Label
                                htmlFor="equipmentCategory2"
                                className="ms-2"
                              >
                                Industrial Equipment
                              </Label>
                            </div>
                            <div className="ms-4 d-flex">
                              <Input
                                type="radio"
                                id="equipmentCategory3"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="Medical Equipment"
                                checked={
                                  selectedEquipment ==
                                  "Medical Equipment"
                                }
                                onClick={handleEquipmetChange}
                              />
                              <Label
                                htmlFor="equipmentCategory3"
                                className="ms-2"
                              >
                                Medical Equipment
                              </Label>
                            </div>
                          </div>
                          {equipmentError && (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                              className="ms-4"
                            >
                              {equipmentError}
                            </p>
                          )}
                        </Col>)}

                        {productSettingObj.equipment_sub_category && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Equipment Sub-category
                          </Label>
                          <div className="ms-4">
                            <div className="d-flex">
                              <Input
                                type="radio"
                                id="equipmentSubCategory1"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="Very Strong/ Deep secondary market/ Very good resale value/ Market"
                                checked={
                                  selectedSubEquipment ==
                                  "Very Strong/ Deep secondary market/ Very good resale value/ Market"
                                }
                                onClick={handleSubEquipmetChange}
                              />
                              <Label
                                htmlFor="equipmentSubCategory1"
                                className="ms-2"
                              >
                                Category A{" "}
                                <span>
                                  <p
                                    style={{
                                      fontSize: "11px",
                                      color: "grey",
                                    }}
                                  >
                                    Very Strong/ Deep secondary market/
                                    Very good resale value/ Market
                                  </p>
                                </span>
                              </Label>
                            </div>
                            <div className="d-flex">
                              <Input
                                type="radio"
                                id="equipmentSubCategory2"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="Strong/ Deep secondary market/ Good resale value"
                                checked={
                                  selectedSubEquipment ==
                                  "Strong/ Deep secondary market/ Good resale value"
                                }
                                onClick={handleSubEquipmetChange}
                              />
                              <Label
                                htmlFor="equipmentSubCategory2"
                                className="ms-2"
                              >
                                Category B{" "}
                                <span>
                                  <p
                                    style={{
                                      fontSize: "11px",
                                      color: "grey",
                                    }}
                                  >
                                    Strong/ Deep secondary market/ Good
                                    resale value
                                  </p>
                                </span>
                              </Label>
                            </div>
                            <div className="d-flex">
                              <Input
                                type="radio"
                                id="equipmentSubCategory3"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="Reasonably good secondary market but lower resale values as compared to Category B asset"
                                checked={
                                  selectedSubEquipment ==
                                  "Reasonably good secondary market but lower resale values as compared to Category B asset"
                                }
                                onClick={handleSubEquipmetChange}
                              />
                              <Label
                                htmlFor="equipmentSubCategory3"
                                className="ms-2"
                              >
                                Category C{" "}
                                <span>
                                  <p
                                    style={{
                                      fontSize: "11px",
                                      color: "grey",
                                    }}
                                  >
                                    Reasonably good secondary market but
                                    lower resale values as compared to
                                    Category B asset
                                  </p>
                                </span>
                              </Label>
                            </div>
                          </div>
                          {subEquipmentError && (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                              className="ms-4"
                            >
                              {subEquipmentError}
                            </p>
                          )}
                        </Col>)}

                        {productSettingObj.equipment_type && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Equipment Type
                          </Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="equipmentType1"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="New"
                                checked={selectedEquipmentType == "New"}
                                onClick={handleEquipmetTypeChange}
                              />
                              <Label
                                htmlFor="equipmentType1"
                                className="ms-2"
                              >
                                New
                              </Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="equipmentType2"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="Used"
                                checked={
                                  selectedEquipmentType == "Used"
                                }
                                onClick={handleEquipmetTypeChange}
                              />
                              <Label
                                htmlFor="equipmentType2"
                                className="ms-2"
                              >
                                Used
                              </Label>
                            </div>
                          </div>
                          {equipmentTypeError && (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                              className="ms-4"
                            >
                              {equipmentTypeError}
                            </p>
                          )}
                        </Col>)}

                        {productSettingObj.bank_name && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Select Bank Name
                          </Label>
                          <Select
                            options={bankList}
                            className={`select-dropdown ${validation.touched.bankName &&
                              validation.errors.bankName
                              ? "is-invalid"
                              : ""
                              }`}
                            name="bankName"
                            id="bankName"
                            placeholder={"Select Bank Name"}
                            value={selectedBankName}
                            onChange={(selectedOption) => {
                              handleBankChange(selectedOption);
                            }}
                          />
                          {validation.touched.bankName &&
                            validation.errors.bankName && (
                              <FormFeedback>
                                {validation.errors.bankName}
                              </FormFeedback>
                            )}
                        </Col>)}

                        {productSettingObj.bank_statement && (<Col lg="6" sm="12">
                          <DynamicFileUploadInput
                            label={"Upload Bank Statement"}
                            inputName={"bankStatement"}
                            onDropHandler={(acceptedFiles) =>
                              onDropForInput1(
                                "bankStatement",
                                acceptedFiles
                              )
                            }
                            isDragActive={true}
                            validation={validation}
                            uploadProgress={uploadProgressBankStat}
                            errorMessage={errorMessageBankStat}
                          />
                        </Col>)}

                        {productSettingObj.statement_password && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Is Bank Statement Password Protected?
                          </Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="pass1"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="Yes"
                                checked={isPasswordBankStatement == "Yes"}
                                onClick={handlePasswordChange}
                              />
                              <Label htmlFor="pass1" className="ms-2">
                                Yes
                              </Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="pass2"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="No"
                                checked={isPasswordBankStatement == "No"}
                                onClick={handlePasswordChange}
                              />
                              <Label htmlFor="pass2" className="ms-2">
                                No
                              </Label>
                            </div>
                          </div>
                          {isPasswordError && (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                              className="ms-4"
                            >
                              {isPasswordError}
                            </p>
                          )}
                        </Col>)}

                        {isPasswordBankStatement == "Yes" && productSettingObj.statement_password && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Enter Bank Statement Password
                            </Label>
                            <Input
                              name="bankStatementPassword"
                              type="text"
                              placeholder={"Enter Bank Statement Password"}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={
                                validation.values.bankStatementPassword ||
                                ""
                              }
                              invalid={
                                validation.touched.bankStatementPassword &&
                                validation.errors.bankStatementPassword
                              }
                            />
                            {validation.touched.bankStatementPassword &&
                              validation.errors.bankStatementPassword ? (
                              <FormFeedback type="invalid">
                                {validation.errors.bankStatementPassword}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {productSettingObj.property_list && (<Col lg="12" sm="12">
                          <FieldArray
                            name="propertyInfoList"
                            render={(arrayHelpers) => (
                              <>
                                {validation.values.propertyInfoList.map(
                                  (file, index) => (
                                    <TableRow
                                      key={file.id}
                                      onDelete={handleDelete}
                                      index={index}
                                      validation={validation}
                                    />
                                  )
                                )}
                                <span
                                  className="text-success"
                                  style={{ cursor: "pointer" }}
                                  onKeyUp={() => {}}
                                  onClick={() => {
                                    arrayHelpers.push({
                                      id: uId(),
                                      propertyNature: "",
                                      propertyOwner: "",
                                      propertyStatus: "",
                                      propertyValue: "",
                                      propertyAge: "",
                                      address: "",
                                      city: "",
                                      pincode: "",
                                      state: "",
                                      parentDeed: "",
                                      saleDeed: "",
                                      utilityBills: "",
                                      propertyTax: "",
                                    });
                                  }}
                                >
                                  <i className="mdi mdi-plus me-1" /> Add
                                  Property
                                </span>
                              </>
                            )}
                          />
                        </Col>)}

                        {productSettingObj.other_income_source && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Is there An Income source other Than that declared In the income tax returns that may contribute to the repayment of this loan?
                          </Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="pass3"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="Yes"
                                checked={isOtherIncomeSource == "Yes"}
                                onClick={handleIncomeChange}
                              />
                              <Label htmlFor="pass3" className="ms-2">
                                Yes
                              </Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="pass4"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="No"
                                checked={isOtherIncomeSource == "No"}
                                onClick={handleIncomeChange}
                              />
                              <Label htmlFor="pass4" className="ms-2">
                                No
                              </Label>
                            </div>
                          </div>
                          {isIncomeError && (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                              className="ms-4"
                            >
                              {isIncomeError}
                            </p>
                          )}
                        </Col>)}

                        {isOtherIncomeSource == "Yes" && productSettingObj.other_income_source && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              If Yes Income Amount
                            </Label>
                            <Input
                              name="otherIncomeAmount"
                              type="text"
                              placeholder={"Enter Income Amount"}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={
                                validation.values.otherIncomeAmount || ""
                              }
                              invalid={
                                validation.touched.otherIncomeAmount &&
                                validation.errors.otherIncomeAmount
                              }
                            />
                            {validation.touched.otherIncomeAmount &&
                              validation.errors.otherIncomeAmount ? (
                              <FormFeedback type="invalid">
                                {validation.errors.otherIncomeAmount}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {productSettingObj.co_borrower && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Is There Co-borrower For This Loan?
                          </Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="coBorrower1"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="Yes"
                                checked={isCoBorrower == "Yes"}
                                onClick={handleCoBorrowerChange}
                              />
                              <Label htmlFor="coBorrower1" className="ms-2">
                                Yes
                              </Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="coBorrower2"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="No"
                                checked={isCoBorrower == "No"}
                                onClick={handleCoBorrowerChange}
                              />
                              <Label htmlFor="coBorrower2" className="ms-2">
                                No
                              </Label>
                            </div>
                          </div>
                          {isCoBorrowerError && (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                              className="ms-4"
                            >
                              {isCoBorrowerError}
                            </p>
                          )}
                        </Col>)}

                        {isCoBorrower == "Yes" && productSettingObj.co_borrower && (
                          <>
                            <Col sm="12" md="6">
                              <Label className="form-label mt-4 grey">
                                Enter Name of The Co-borrower
                              </Label>
                              <Input
                                name="coBorrowerName"
                                type="text"
                                placeholder={
                                  "Enter Name of The Co-borrower"
                                }
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={
                                  validation.values.coBorrowerName || ""
                                }
                                invalid={
                                  validation.touched.coBorrowerName &&
                                  validation.errors.coBorrowerName
                                }
                              />
                              {validation.touched.coBorrowerName &&
                                validation.errors.coBorrowerName ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.coBorrowerName}
                                </FormFeedback>
                              ) : null}
                            </Col>

                            <Col sm="12" md="6">
                              <Label className="form-label mt-4 grey">
                                D.O.B of The Co-borrower
                              </Label>
                              <Input
                                name="coBorrowerDob"
                                type="date"
                                placeholder={
                                  "Enter Name of The Co-borrower"
                                }
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={
                                  validation.values.coBorrowerDob || ""
                                }
                                invalid={
                                  validation.touched.coBorrowerDob &&
                                  validation.errors.coBorrowerDob
                                }
                              />
                              {validation.touched.coBorrowerDob &&
                                validation.errors.coBorrowerDob ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.coBorrowerDob}
                                </FormFeedback>
                              ) : null}
                            </Col>

                            <Col>
                              <Label className="form-label mt-4 grey">
                                Select the relationship with the co-borrower
                              </Label>
                              <Input
                                type="select"
                                placeholder="Select Relationship With The Co-borrower"
                                name={"coBorrowerRelation"}
                                id={"coBorrowerRelation"}
                                value={validation.values.coBorrowerRelation}
                                onChange={(e) => validation.handleChange(e)}
                                invalid={
                                  !!(
                                    validation.touched.coBorrowerRelation &&
                                    validation.errors.coBorrowerRelation
                                  )
                                }
                              >
                                <option value="" disabled>
                                  Select Relationship With The Co-borrower
                                </option>
                                {coBorrowerOfPropList.map(
                                  (option, index) => (
                                    <option
                                      key={option.id}
                                      value={option.dropdownValue}
                                    >
                                      {option.displayName}
                                    </option>
                                  )
                                )}
                              </Input>

                              {validation.touched.coBorrowerRelation &&
                                validation.errors.coBorrowerRelation && (
                                  <FormFeedback>
                                    {validation.errocoBorrowerRelation}
                                  </FormFeedback>
                                )}
                            </Col>

                            <Col sm="12" md="6">
                              <Label className="form-label mt-4 grey">
                                Enter PAN No. of The Co-borrower
                              </Label>
                              <Input
                                name="coBorrowerPanNumber"
                                type="text"
                                placeholder={
                                  "Enter PAN No. of The Co-borrower"
                                }
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={
                                  validation.values.coBorrowerPanNumber ||
                                  ""
                                }
                                invalid={
                                  validation.touched.coBorrowerPanNumber &&
                                  validation.errors.coBorrowerPanNumber
                                }
                              />
                              {validation.touched.coBorrowerPanNumber &&
                                validation.errors.coBorrowerPanNumber ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.coBorrowerPanNumber}
                                </FormFeedback>
                              ) : null}
                            </Col>

                            <Col sm="12" md="6">
                              <Label className="form-label mt-4 grey">
                                Income Type of The Co-borrower
                              </Label>
                              <div className="d-flex ms-4">
                                <div>
                                  <Input
                                    type="radio"
                                    id="incomeType1"
                                    onChange={() => {}}
                                    style={{ border: "1px solid black" }}
                                    value="Salary"
                                    checked={
                                      coBorrowerIncomeType == "Salary"
                                    }
                                    onClick={handleIncomeTypeChange}
                                  />
                                  <Label
                                    htmlFor="incomeType1"
                                    className="ms-2"
                                  >
                                    Salary
                                  </Label>
                                </div>
                                <div className="ms-4">
                                  <Input
                                    type="radio"
                                    id="incomeType2"
                                    onChange={() => {}}
                                    style={{ border: "1px solid black" }}
                                    value="Business"
                                    checked={
                                      coBorrowerIncomeType == "Business"
                                    }
                                    onClick={handleIncomeTypeChange}
                                  />
                                  <Label
                                    htmlFor="incomeType2"
                                    className="ms-2"
                                  >
                                    Business
                                  </Label>
                                </div>
                                <div className="ms-4">
                                  <Input
                                    type="radio"
                                    id="incomeType2"
                                    onChange={() => {}}
                                    style={{ border: "1px solid black" }}
                                    value="Other"
                                    checked={
                                      coBorrowerIncomeType == "Other"
                                    }
                                    onClick={handleIncomeTypeChange}
                                  />
                                  <Label
                                    htmlFor="incomeType2"
                                    className="ms-2"
                                  >
                                    Other
                                  </Label>
                                </div>
                              </div>
                              {incomeCoBorrowerError && (
                                <p
                                  style={{
                                    color: "rgb(245,116,116)",
                                    fontSize: "11px",
                                  }}
                                  className="ms-4"
                                >
                                  {incomeCoBorrowerError}
                                </p>
                              )}
                            </Col>

                            <Col lg="6" sm="12">
                              <DynamicFileUploadInput
                                label={"Attach PAN"}
                                inputName={"coBorrowerPan"}
                                onDropHandler={(acceptedFiles) =>
                                  onDropForInput3(
                                    "coBorrowerPan",
                                    acceptedFiles
                                  )
                                }
                                isDragActive={true}
                                validation={validation}
                                uploadProgress={uploadProgressCoBoPan}
                                errorMessage={errorMessageCoBoPan}
                              />
                            </Col>

                            <Col lg="6" sm="12">
                              <DynamicFileUploadInput
                                label={
                                  "Income Tax Returns of The Co-borrower"
                                }
                                inputName={"coBorrowerItr"}
                                onDropHandler={(acceptedFiles) =>
                                  onDropForInput4(
                                    "coBorrowerItr",
                                    acceptedFiles
                                  )
                                }
                                isDragActive={true}
                                validation={validation}
                                uploadProgress={uploadProgressCoBoItr}
                                errorMessage={errorMessageCoBoItr}
                              />
                            </Col>
                          </>
                        )}

                        {productSettingObj.dealer_credit_period && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Is there a credit period being offered to dealers and distributors?
                          </Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="option1"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="Yes"
                                checked={selectedOption == "Yes"}
                                onClick={handleOptionChange}
                              />
                              <Label htmlFor="option1" className="ms-2">
                                Yes
                              </Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="option2"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                value="No"
                                checked={selectedOption == "No"}
                                onClick={handleOptionChange}
                              />
                              <Label htmlFor="option2" className="ms-2">
                                No
                              </Label>
                            </div>
                          </div>
                          {error && (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                              className="ms-4"
                            >
                              {error}
                            </p>
                          )}
                        </Col>)}

                        {selectedOption == "Yes" && productSettingObj.dealer_credit_period && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              What is the average credit period currently offered? (in days)
                            </Label>
                            <Input
                              name="creditPeriod"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.creditPeriod || ""}
                              invalid={
                                validation.touched.creditPeriod &&
                                validation.errors.creditPeriod
                              }
                            />
                            {validation.touched.creditPeriod &&
                              validation.errors.creditPeriod ? (
                              <FormFeedback type="invalid">
                                {validation.errors.creditPeriod}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {productSettingObj.business_requirement2 && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What is the Business Requirement?
                          </Label>
                          <div className="ms-4">
                            <div>
                              <Input
                                type="radio"
                                onChange={() => {}}
                                id="BusinessRequirement1"
                                value="Greater channel coverage"
                                checked={
                                  selectedBusinessRequirement ==
                                  "Greater channel coverage"
                                }
                                onClick={handleBusinessRequirement}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  border: "1px solid black",
                                }}
                              />
                              <Label
                                htmlFor="BusinessRequirement1"
                                className="ms-2"
                              >
                                Greater channel coverage{" "}
                                <span>
                                  <p
                                    style={{
                                      fontSize: "11px",
                                      color: "grey",
                                    }}
                                  >
                                    to increase sales
                                  </p>
                                </span>
                              </Label>
                            </div>
                            <div>
                              <Input
                                type="radio"
                                id="BusinessRequirement2"
                                onChange={() => {}}
                                value="Reduce my Days Sales Outstanding (DSO)"
                                checked={
                                  selectedBusinessRequirement ==
                                  "Reduce my Days Sales Outstanding (DSO)"
                                }
                                onClick={handleBusinessRequirement}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  border: "1px solid black",
                                }}
                              />
                              <Label
                                htmlFor="BusinessRequirement2"
                                className="ms-2"
                              >
                                Reduce my Days Sales Outstanding (DSO){" "}
                                <span>
                                  <p
                                    style={{
                                      fontSize: "11px",
                                      color: "grey",
                                    }}
                                  >
                                    to meet working capital needs
                                  </p>
                                </span>
                              </Label>
                            </div>
                            <div>
                              <Input
                                type="radio"
                                id="BusinessRequirement3"
                                onChange={() => {}}
                                value="Reduce my credit risk"
                                checked={
                                  selectedBusinessRequirement ==
                                  "Reduce my credit risk"
                                }
                                onClick={handleBusinessRequirement}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  border: "1px solid black",
                                }}
                              />
                              <Label
                                htmlFor="BusinessRequirement3"
                                className="ms-2"
                              >
                                Reduce my credit risk{" "}
                                <span>
                                  <p
                                    style={{
                                      fontSize: "11px",
                                      color: "grey",
                                    }}
                                  >
                                    by receiving early payment for my sales
                                    proceeds
                                  </p>
                                </span>
                              </Label>
                            </div>
                            <div>
                              <Input
                                type="radio"
                                id="BusinessRequirement4"
                                onChange={() => {}}
                                value="Deleverage my balance sheet"
                                checked={
                                  selectedBusinessRequirement ==
                                  "Deleverage my balance sheet"
                                }
                                onClick={handleBusinessRequirement}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  border: "1px solid black",
                                }}
                              />
                              <Label
                                htmlFor="BusinessRequirement4"
                                className="ms-2"
                              >
                                Deleverage my balance sheet{" "}
                                <span>
                                  <p
                                    style={{
                                      fontSize: "11px",
                                      color: "grey",
                                    }}
                                  >
                                    and reduce my working capital
                                    requirement
                                  </p>
                                </span>
                              </Label>
                            </div>
                          </div>
                          {errorBusiness && (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                              className="ms-4"
                            >
                              {errorBusiness}
                            </p>
                          )}
                        </Col>)}

                        {(productSettingObj.existing_dealer_financing && <Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Is there an existing dealer financing arrangement?
                          </Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="dealerfinancingArrangement1"
                                value="Yes"
                                onChange={() => {}}
                                checked={
                                  dealerfinancingArrangement == "Yes"
                                }
                                onClick={handledealerfinancingArrangement}
                                style={{ border: "1px solid black" }}
                              />
                              <Label
                                htmlFor="financingArrangement1"
                                className="ms-2"
                              >
                                Yes
                              </Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="financingArrangement2"
                                value="No"
                                onChange={() => {}}
                                checked={dealerfinancingArrangement == "No"}
                                onClick={handledealerfinancingArrangement}
                                style={{ border: "1px solid black" }}
                              />
                              <Label
                                htmlFor="financingArrangemen2"
                                className="ms-2"
                              >
                                No
                              </Label>
                            </div>
                          </div>
                          {errorfinancing && (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                              className="ms-4"
                            >
                              {errorfinancing}
                            </p>
                          )}
                        </Col>)}

                        {dealerfinancingArrangement == "Yes" && productSettingObj.existing_dealer_financing && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Select the entity types with which arrangements have been made
                            </Label>
                            <Select
                              name="dealerArrangement"
                              value={selectedMulti3}
                              isMulti={true}
                              onChange={handleMulti3}
                              onBlur={() => validation.handleBlur('dealerArrangement')}
                              options={entityArrangeList}
                              className="select2-selection"
                            // isDisabled={true}
                            />
                            {validation.values.dealerArrangement == "" && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                              >
                                {validation.errors.dealerArrangement}
                              </p>
                            )}
                          </Col>
                        )}

                        {dealerfinancingArrangement == "Yes" && productSettingObj.existing_dealer_financing && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              What Percentage Of Dealers Are Covered By The
                              Existing Arrangement?
                            </Label>
                            <Input
                              name="percentageCovered"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={
                                validation.values.percentageCovered || ""
                              }
                              invalid={
                                validation.touched.percentageCovered &&
                                validation.errors.percentageCovered
                              }
                            />
                            {validation.touched.percentageCovered &&
                              validation.errors.percentageCovered ? (
                              <FormFeedback type="invalid">
                                {validation.errors.percentageCovered}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {productSettingObj.geographical_sales_distribution && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            How Is Sale Distributed Geographically?
                          </Label>
                          {validation.errors.total ? (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                            >
                              {validation.errors.total}
                            </p>
                          ) : null}
                          <div style={{ width: "50%" }}>
                            <div className="mt-2">
                              <Input
                                name="north"
                                type="text"
                                onChange={validation.handleChange}
                                placeholder="North"
                                onBlur={validation.handleBlur}
                                value={validation.values.north || ""}
                                invalid={
                                  validation.touched.north &&
                                  validation.errors.north
                                }
                              />
                              {validation.touched.north &&
                                validation.errors.north ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.north}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mt-2">
                              <Input
                                name="south"
                                type="text"
                                placeholder="South"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.south || ""}
                                invalid={
                                  validation.touched.south &&
                                  validation.errors.south
                                }
                              />
                              {validation.touched.south &&
                                validation.errors.south ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.south}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mt-2">
                              <Input
                                name="east"
                                type="text"
                                placeholder="East"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.east || ""}
                                invalid={
                                  validation.touched.east &&
                                  validation.errors.east
                                }
                              />
                              {validation.touched.east &&
                                validation.errors.east ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.east}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mt-2">
                              <Input
                                name="west"
                                type="text"
                                placeholder="West"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.west || ""}
                                invalid={
                                  validation.touched.west &&
                                  validation.errors.west
                                }
                              />
                              {validation.touched.west &&
                                validation.errors.west ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.west}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </div>
                        </Col>)}

                        {productSettingObj.dealer_cash_discounts && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Is cash discount provided to dealers and distributors?
                          </Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="cashDiscount1"
                                value="Yes"
                                onChange={() => {}}
                                checked={cashDiscount == "Yes"}
                                onClick={handleCashDiscount}
                                style={{ border: "1px solid black" }}
                              />
                              <Label
                                htmlFor="cashDiscount1"
                                className="ms-2"
                              >
                                Yes
                              </Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="cashDiscount2"
                                value="No"
                                onChange={() => {}}
                                checked={cashDiscount == "No"}
                                onClick={handleCashDiscount}
                                style={{ border: "1px solid black" }}
                              />
                              <Label
                                htmlFor="cashDiscount2"
                                className="ms-2"
                              >
                                No
                              </Label>
                            </div>
                          </div>
                          {errorCashDiscount && (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                              className="ms-4"
                            >
                              {errorCashDiscount}
                            </p>
                          )}
                        </Col>)}

                        {productSettingObj.default_guarantee_offer_fldg && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Would a first loss default guarantee (FLDG) be offered to the lender?
                          </Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="fldg1"
                                value="Yes"
                                onChange={() => {}}
                                checked={selectedFldg == "Yes"}
                                onClick={handleFldgChange}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="fldg1" className="ms-2">
                                Yes
                              </Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="fldg2"
                                value="No"
                                onChange={() => {}}
                                checked={selectedFldg == "No"}
                                onClick={handleFldgChange}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="fldg2" className="ms-2">
                                No
                              </Label>
                            </div>
                          </div>
                          {errorFldg && (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                              className="ms-4"
                            >
                              {errorFldg}
                            </p>
                          )}
                        </Col>)}

                        {selectedFldg == "Yes" && productSettingObj.default_guarantee_offer_fldg && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Please mention the maximum percentage of FLDG willing to be provided
                            </Label>
                            <Input
                              name="fldg"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.fldg || ""}
                              invalid={
                                validation.touched.fldg &&
                                validation.errors.fldg
                              }
                            />
                            {validation.touched.fldg &&
                              validation.errors.fldg ? (
                              <FormFeedback type="invalid">
                                {validation.errors.fldg}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {productSettingObj.monthly_sales && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What Is The Value of Monthly Sales?
                          </Label>
                          <Input
                            name="monthlySales"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.monthlySales || ""}
                            invalid={
                              validation.touched.monthlySales &&
                              validation.errors.monthlySales
                            }
                          />
                          {validation.touched.monthlySales &&
                            validation.errors.monthlySales ? (
                            <FormFeedback type="invalid">
                              {validation.errors.monthlySales}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {productSettingObj.vendor_payment_schedule && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            When are the vendors currently paid?
                          </Label>
                          <div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="vendorPays1"
                                onChange={() => {}}
                                value="On/before the receipt of goods and services"
                                checked={
                                  vendorPays ==
                                  "On/before the receipt of goods and services"
                                }
                                onClick={handlevendorPays}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="vendorPays1" className="ms-2">
                                On/before the receipt of goods and services
                              </Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="vendorPays2"
                                onChange={() => {}}
                                value="After the receipt of goods and services"
                                checked={
                                  vendorPays ==
                                  "After the receipt of goods and services"
                                }
                                onClick={handlevendorPays}
                                style={{ border: "1px solid black" }}
                              />
                              <Label htmlFor="vendorPays2" className="ms-2">
                                After the receipt of goods and services
                              </Label>
                            </div>
                          </div>
                          {errorvendorPays && (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                              className="ms-4"
                            >
                              {errorvendorPays}
                            </p>
                          )}
                        </Col>)}

                        {productSettingObj.business_requirement && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What is the Business Requirement?
                          </Label>
                          <div className="ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="BusinessRequirement5"
                                onChange={() => {}}
                                value="Deleverage my balance sheet"
                                checked={
                                  selectedBusinessRequirement ==
                                  "Deleverage my balance sheet"
                                }
                                onClick={handleBusinessRequirement}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  border: "1px solid black",
                                }}
                              />
                              <Label
                                htmlFor="BusinessRequirement5"
                                className="ms-2"
                              >
                                Deleverage my balance sheet{" "}
                                <span>
                                  <p
                                    style={{
                                      fontSize: "11px",
                                      color: "grey",
                                    }}
                                  >
                                    and reduce my working capital
                                    requirement
                                  </p>
                                </span>
                              </Label>
                            </div>
                            <div>
                              <Input
                                type="radio"
                                id="BusinessRequirement6"
                                onChange={() => {}}
                                value="Extend Days Payable Outstanding(DPO)"
                                checked={
                                  selectedBusinessRequirement ==
                                  "Extend Days Payable Outstanding(DPO)"
                                }
                                onClick={handleBusinessRequirement}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  border: "1px solid black",
                                }}
                              />
                              <Label
                                htmlFor="BusinessRequirement6"
                                className="ms-2"
                              >
                                Extend Days Payable Outstanding(DPO){" "}
                                <span>
                                  <p
                                    style={{
                                      fontSize: "11px",
                                      color: "grey",
                                    }}
                                  >
                                    to reduce my working capital cycle
                                  </p>
                                </span>
                              </Label>
                            </div>
                            <div>
                              <Input
                                type="radio"
                                id="BusinessRequirement7"
                                onChange={() => {}}
                                value="Improve profit margins"
                                checked={
                                  selectedBusinessRequirement ==
                                  "Improve profit margins"
                                }
                                onClick={handleBusinessRequirement}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  border: "1px solid black",
                                }}
                              />
                              <Label
                                htmlFor="BusinessRequirement7"
                                className="ms-2"
                              >
                                Improve profit margins{" "}
                                <span>
                                  <p
                                    style={{
                                      fontSize: "11px",
                                      color: "grey",
                                    }}
                                  >
                                    by getting a cash discount from vendors
                                    for early payments
                                  </p>
                                </span>
                              </Label>
                            </div>
                            <div>
                              <Input
                                type="radio"
                                id="BusinessRequirement8"
                                onChange={() => {}}
                                value="Offer lucrative payment terms"
                                checked={
                                  selectedBusinessRequirement ==
                                  "Offer lucrative payment terms"
                                }
                                onClick={handleBusinessRequirement}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  border: "1px solid black",
                                }}
                              />
                              <Label
                                htmlFor="BusinessRequirement8"
                                className="ms-2"
                              >
                                Offer lucrative payment terms{" "}
                                <span>
                                  <p
                                    style={{
                                      fontSize: "11px",
                                      color: "grey",
                                    }}
                                  >
                                    to attract vendors by making early
                                    payments
                                  </p>
                                </span>
                              </Label>
                            </div>
                          </div>
                          {errorBusiness && (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                              className="ms-4"
                            >
                              {errorBusiness}
                            </p>
                          )}
                        </Col>)}

                        {isSelectedDpo && productSettingObj.business_requirement && (
                          <>
                            <Col sm="12" md="6">
                              <Label className="form-label mt-4 grey">
                                If the lender disburses on Day 1, what cash discount would be received from vendors?
                              </Label>
                              <Input
                                name="vendorDiscount"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={
                                  validation.values.vendorDiscount || ""
                                }
                                invalid={
                                  validation.touched.vendorDiscount &&
                                  validation.errors.vendorDiscount
                                }
                              />
                              {validation.touched.vendorDiscount &&
                                validation.errors.vendorDiscount ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.vendorDiscount}
                                </FormFeedback>
                              ) : null}
                            </Col>

                            <Col sm="12" md="6">
                              <Label className="form-label mt-4 grey">
                                {" "}
                                By how many days would the DPO be extended?
                              </Label>
                              <Input
                                name="extendDpoDays"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={
                                  validation.values.extendDpoDays || ""
                                }
                                invalid={
                                  validation.touched.extendDpoDays &&
                                  validation.errors.extendDpoDays
                                }
                              />
                              {validation.touched.extendDpoDays &&
                                validation.errors.extendDpoDays ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.extendDpoDays}
                                </FormFeedback>
                              ) : null}
                            </Col>
                          </>
                        )}

                        {productSettingObj.existing_vendor_financing && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Is there an existing vendor financing arrangement?
                          </Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="financingArrangement3"
                                onChange={() => {}}
                                value="Yes"
                                checked={
                                  vendorfinancingArrangement == "Yes"
                                }
                                onClick={handlevendorfinancingArrangement}
                                style={{ border: "1px solid black" }}
                              />
                              <Label
                                htmlFor="financingArrangement3"
                                className="ms-2"
                              >
                                Yes
                              </Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="financingArrangement4"
                                value="No"
                                onChange={() => {}}
                                checked={vendorfinancingArrangement == "No"}
                                onClick={handlevendorfinancingArrangement}
                                style={{ border: "1px solid black" }}
                              />
                              <Label
                                htmlFor="financingArrangemen4"
                                className="ms-2"
                              >
                                No
                              </Label>
                            </div>
                          </div>
                          {errorfinancingVendor && (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                              className="ms-4"
                            >
                              {errorfinancingVendor}
                            </p>
                          )}
                        </Col>)}

                        {vendorfinancingArrangement == "Yes" && productSettingObj.existing_vendor_financing && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Select the entity types with which arrangements have been made
                            </Label>
                            <Select
                              name="vendorsArrangement"
                              value={selectedMulti4}
                              isMulti={true}
                              onChange={handleMulti4}
                              options={entityArrangeListForVendor}
                              className="select2-selection"
                            // isDisabled={true}
                            />
                            {validation.values.vendorsArrangement == "" && (
                              <p
                                style={{
                                  color: "rgb(245,116,116)",
                                  fontSize: "11px",
                                }}
                              >
                                {validation.errors.vendorsArrangement}
                              </p>
                            )}
                          </Col>
                        )}

                        {productSettingObj.guarantee_offer_to_lender && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Willing to provide any guarantee to the lender?
                          </Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="isGuaranteeLender1"
                                value="Yes"
                                onChange={() => {}}
                                checked={selectedGuarantee == "Yes"}
                                onClick={handleGuaranteeChange}
                                style={{ border: "1px solid black" }}
                              />
                              <Label
                                htmlFor="isGuaranteeLender1"
                                className="ms-2"
                              >
                                Yes
                              </Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="isGuaranteeLender2"
                                value="No"
                                onChange={() => {}}
                                checked={selectedGuarantee == "No"}
                                onClick={handleGuaranteeChange}
                                style={{ border: "1px solid black" }}
                              />
                              <Label
                                htmlFor="isGuaranteeLender2"
                                className="ms-2"
                              >
                                No
                              </Label>
                            </div>
                          </div>
                          {errorGuarantee && (
                            <p
                              style={{
                                color: "rgb(245,116,116)",
                                fontSize: "11px",
                              }}
                              className="ms-4"
                            >
                              {errorGuarantee}
                            </p>
                          )}
                        </Col>)}

                        {selectedGuarantee == "Yes" && productSettingObj.guarantee_offer_to_lender && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Select The Guarantee Type(s)
                            </Label>
                            <Select
                              name="guaranteeTypesLender"
                              value={selectedMulti5}
                              isMulti={true}
                              onChange={handleMulti5}
                              options={entityGuaranteeList}
                              className="select2-selection"
                            // isDisabled={true}
                            />
                            {validation.values.guaranteeTypesLender ==
                              "" && (
                                <p
                                  style={{
                                    color: "rgb(245,116,116)",
                                    fontSize: "11px",
                                  }}
                                >
                                  {validation.errors.guaranteeTypesLender}
                                </p>
                              )}
                          </Col>
                        )}

                        {productSettingObj.monthly_purchases_value && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            What Is The Value Of Monthly Purchases?
                          </Label>
                          <Input
                            name="monthlyPurchases"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.monthlyPurchases || ""}
                            invalid={
                              validation.touched.monthlyPurchases &&
                              validation.errors.monthlyPurchases
                            }
                          />
                          {validation.touched.monthlyPurchases &&
                            validation.errors.monthlyPurchases ? (
                            <FormFeedback type="invalid">
                              {validation.errors.monthlyPurchases}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                        {isProductSelected && isAdmin && (
                          <>
                            {selectedProducts.includes("Inventory funding") ? null : (
                            <Col sm="12" md="6">
                              <Label className="form-label mt-4 grey">
                                Select Deal Status Bucket
                              </Label>
                              <Input
                                name="dealStatus"
                                type="select"
                                placeholder="Select Deal Status Bucket"
                                onChange={(e) => {
                                  if (e.target.value == "Referred") {
                                    setIsDealStatusBucketSelected(true)
                                  } else {
                                    setIsDealStatusBucketSelected(false)
                                  }
                                  validation.handleChange(e);
                                }}
                                onBlur={validation.handleBlur}
                                value={
                                  validation.values.dealStatus
                                }
                                invalid={
                                  validation.touched.dealStatus &&
                                  validation.errors.dealStatus
                                }
                              >
                                <option value="" disabled>
                                  Select Deal Status Bucket
                                </option>
                                {dealStatusBucket.map(
                                  (option, index) => (
                                    <option
                                      key={option.id}
                                      value={option.displayName}
                                    >
                                      {option.displayName}
                                    </option>
                                  )
                                )}
                              </Input>
                              {validation.touched.dealStatus &&
                                validation.errors.dealStatus ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.dealStatus}
                                </FormFeedback>
                              ) : null}
                            </Col>
                             )}
                          </>
                        )}

                        {isProductSelected && isAdmin &&(
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey">
                              Add Notes
                            </Label>
                            <Input
                              type="textarea"
                              className="form-control"
                              name="dealNotes"
                              placeholder="Enter Notes "
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.dealNotes || ""}
                              invalid={
                                validation.touched.dealNotes &&
                                validation.errors.dealNotes
                              }
                            />
                            {validation.touched.dealNotes &&
                              validation.errors.dealNotes ? (
                              <FormFeedback type="invalid">
                                {validation.errors.dealNotes}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        )}

                        {isProductSelected && isAdmin && (
                          <Col sm="12" md="6">
                            <Label className="form-label mt-4 grey" htmlFor="expectedClosureDate">
                              Expected Closure Date * 
                            </Label>

                            <input
                              type="month"
                              value={validation.values.expectedClosureDate || ""}
                              onChange={(e) => handleDateChange(e.target.value)}
                              className={`form-control ${validation.touched.expectedClosureDate && validation.errors.expectedClosureDate ? 'is-invalid' : ''}`}
                              id="expectedClosureDate"
                              placeholder="MM/YYYY"
                            />

                            {validation.touched.expectedClosureDate &&
                             validation.errors.expectedClosureDate ? (
                              <FormFeedback type="is-invalid">
                                {validation.errors.expectedClosureDate}
                              </FormFeedback>
                            ) : null }
                          </Col>
                        )}


 

                        {isProductSelected && isApprovePermission && (
                          <>
                            <Col sm="12" md="6">
                              <Label className="form-label mt-4">
                                RM
                              </Label>
                              <Select
                                options={dealAuthorList.map((option, index) => ({
                                  label: `${option.firstName + " " + option.lastName}`,
                                  value: option.id,
                                }))}
                                className={`select-dropdown ${validation.touched.assignedTo &&
                                  validation.errors.assignedTo
                                  ? "is-invalid"
                                  : ""
                                  }`}
                                // isDisabled={!selectedDealType || isDisableEntity}
                                name="assignedTo"
                                id="assignedTo"
                                placeholder={"Enter Deal RM"}
                                value={selectedDealAuthor}
                                onInputChange={(e) => {
                                  handleInputChangeForDealAuthor
                                }}
                                onMenuOpen={(e) => {
                                  hasOpenedBefore ? handleInputChangeForDealAuthor("") : null;
                                  setHasOpenedBeforeDealAuthor(false);
                                }}
                                onChange={(selectedOption) => {
                                  setSelectedDealAuthor(selectedOption.label)
                                  handleEntityChangeDealAuthor(selectedOption);
                                }}
                                onBlur={validation.handleBlur}
                              />
                              {validation.touched.assignedTo &&
                                validation.errors.assignedTo && (
                                  <FormFeedback>
                                    {validation.errors.assignedTo}
                                  </FormFeedback>
                                )}
                            </Col>

                          </>
                        )}

                        {isProductSelected && isApprovePermission && (
                          <>
                            <Col sm="12" md="6">
                              <Label className="form-label mt-4">
                                FI RM
                              </Label>
                              <Select
                                options={dealAuthorList.map((option, index) => ({
                                  label: `${option.firstName + " " + option.lastName}`,
                                  value: option.id,
                                }))}
                                className={`select-dropdown ${validation.touched.assignedToFirm &&
                                  validation.errors.assignedToFirm
                                  ? "is-invalid"
                                  : ""
                                  }`}
                                name="assignedToFirm"
                                id="assignedToFirm"
                                placeholder={"Enter Deal FIRM"}
                                value={selectedDealFIRM}
                                onInputChange={(e) => {
                                  handleInputChangeForDealFIRM
                                }}
                                onMenuOpen={(e) => {
                                  hasOpenedBefore ? handleInputChangeForDealFIRM("") : null;
                                  setHasOpenedBeforeDealAuthor(false);
                                }}
                                onChange={(selectedOption) => {
                                  setSelectedDealFIRM(selectedOption.label)
                                  handleEntityChangeDealFIRM(selectedOption);
                                }}
                                onBlur={validation.handleBlur}
                              />
                              {validation.touched.assignedToFirm &&
                                validation.errors.assignedToFirm && (
                                  <FormFeedback>
                                    {validation.errors.assignedToFirm}
                                  </FormFeedback>
                                )}
                            </Col>

                          </>
                        )}

                        {isProductSelected && isApprovePermission && (
                          <>
                            <Col sm="12" md="6">
                              <Label className="form-label mt-4">
                                Program Manager
                              </Label>
                              <Select
                                options={dealAuthorList.map((option, index) => ({
                                  label: `${option.firstName + " " + option.lastName}`,
                                  value: option.id,
                                }))}
                                className={`select-dropdown ${validation.touched.assignedToProgramRm &&
                                  validation.errors.assignedToProgramRm
                                  ? "is-invalid"
                                  : ""
                                  }`}
                                // isDisabled={!selectedDealType || isDisableEntity}
                                name="assignedToProgramRm"
                                id="assignedToProgramRm"
                                placeholder={"Enter Deal Program RM"}
                                value={selectedDealProgramRM}
                                onInputChange={(e) => {
                                  handleInputChangeForDealPrgrramRM
                                }}
                                onMenuOpen={(e) => {
                                  hasOpenedBefore ? handleInputChangeForDealPrgrramRM("") : null;
                                  setHasOpenedBeforeDealAuthor(false);
                                }}
                                onChange={(selectedOption) => {
                                  setSelectedDealProgramRM(selectedOption.label)
                                  handleEntityChangeDealProgramRM(selectedOption);
                                }}
                                onBlur={validation.handleBlur}
                              />
                              {validation.touched.assignedToProgramRm &&
                                validation.errors.assignedToProgramRm && (
                                  <FormFeedback>
                                    {validation.errors.assignedToProgramRm}
                                  </FormFeedback>
                                )}
                            </Col>

                          </>
                        )}

                        {isProductSelected &&  isAdmin &&(<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Select Referred Financier
                          </Label>
                          {isShowRecommendFinancier && (<Col sm="6" >
                            <div className="d-flex gap-2 justify-content-start mb-2 ms-4">
                              <Button
                                type="button"
                                color='primary'
                                className="btn-rounded"
                                style={{ padding: '4px 10px 4px 10px' }}
                                outline
                                onClick={() => {
                                  ReferredFinancierList()
                                }}
                              >
                                Show Recommended Financiers
                              </Button>
                            </div>
                          </Col>)}   
                           {/* {validation.touched.financier &&
                                selectedMulti6.length == 0 &&
                                selectedMulti7.length == 0 &&
                                selectedMulti8.length == 0 ? (
                                <p
                                  style={{
                                    color: "rgb(245,116,116)",
                                    fontSize: "11px",
                                  }}
                                >
                                  {validation.errors.financier}
                                </p>
                              ) : null} */}
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="selectAllFin1"
                                value="All"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                checked={selectedFinType == "All"}
                                onClick={handleFinancierSelect}
                              />
                              <Label htmlFor="selectAllFin1" className="ms-2">
                                Select All
                              </Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="Select1"
                                onChange={() => {}}
                                value="Select"
                                style={{ border: "1px solid black" }}
                                checked={selectedFinType == "Select"}
                                onClick={handleFinancierSelect}
                              />
                              <Label htmlFor="Select1" className="ms-2">
                                Select Referred Financier
                              </Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="SelectExFin1"
                                onChange={() => {}}
                                value="AllExcept"
                                style={{ border: "1px solid black" }}
                                checked={selectedFinType == "AllExcept"}
                                onClick={handleFinancierSelect}
                              />
                              <Label htmlFor="SelectExFin1" className="ms-2">
                                Select Except
                              </Label>
                            </div>
                          </div>
                          {selectedFinType !== "" && (
                            <div>
                              <span style={{ fontWeight: "500" }}>
                                Public Sector Bank
                              </span>
                              <Select
                                name="financier"
                                value={selectedMulti6}
                                isMulti={true}
                                onChange={handleMulti6}
                                onKeyDown={(e) => {
                                  bankValueChange(e.target.value);
                                }}
                                options={publicSectorBankList}
                                className="select2-selection mb-2"
                              // isDisabled={true}
                              />
                              <span style={{ fontWeight: "500" }}>
                                Private Sector Bank
                              </span>
                              <Select
                                name="financier"
                                value={selectedMulti7}
                                isMulti={true}
                                onChange={handleMulti7}
                                onKeyDown={(e) => {
                                  bankValueChange(e.target.value);
                                }}
                                options={privateSectorBankList}
                                className="select2-selection mb-2"
                              // isDisabled={true}
                              />
                              <span style={{ fontWeight: "500" }}>NBFCs</span>
                              <Select
                                name="financier"
                                value={selectedMulti8}
                                isMulti={true}
                                onChange={handleMulti8}
                                onKeyDown={(e) => {
                                  bankValueChange(e.target.value);
                                }}
                                options={NBFCList}
                                className="select2-selection"
                              // isDisabled={true}
                              />
                            </div>
                          )}
                        </Col>)}
                        {isProductSelected && (<Col sm="12" md="6">
                          <Label className="form-label mt-4 grey">
                            Select Preferred Financier
                          </Label>
                          <div className="d-flex ms-4">
                            <div>
                              <Input
                                type="radio"
                                id="selectAllPrefFinancier"
                                value="All"
                                onChange={() => {}}
                                style={{ border: "1px solid black" }}
                                checked={selectedPrefFinType == "All"}
                                onClick={handlePrefFinancierSelect}
                              />
                              <Label htmlFor="selectAllFin1" className="ms-2">
                                Select All
                              </Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="selectPrefFinancier"
                                onChange={() => {}}
                                value="Select"
                                style={{ border: "1px solid black" }}
                                checked={selectedPrefFinType == "Select"}
                                onClick={handlePrefFinancierSelect}
                              />
                              <Label htmlFor="Select1" className="ms-2">
                                Select Preferred Financier
                              </Label>
                            </div>
                            <div className="ms-4">
                              <Input
                                type="radio"
                                id="selectExceptPrefFinancier"
                                onChange={() => {}}
                                value="AllExcept"
                                style={{ border: "1px solid black" }}
                                checked={selectedPrefFinType == "AllExcept"}
                                onClick={handlePrefFinancierSelect}
                              />
                              <Label htmlFor="SelectExFin1" className="ms-2">
                                Select Except
                              </Label>
                            </div>
                          </div>
                          {selectedPrefFinType !== "" && (
                            <div>
                              <span style={{ fontWeight: "500" }}>
                                Public Sector Bank
                              </span>
                              <Select
                                name="financier"
                                value={selectedPrefFinancierMulti6}
                                isMulti={true}
                                onChange={handlePrefMulti6}
                                onKeyDown={(e) => {
                                  bankValueChange(e.target.value);
                                }}
                                options={publicSectorBankList}
                                className="select2-selection mb-2"
                              // isDisabled={true}
                              />
                              <span style={{ fontWeight: "500" }}>
                                Private Sector Bank
                              </span>
                              <Select
                                name="financier"
                                value={selectedPrefFinancierMulti7}
                                isMulti={true}
                                onChange={handlePrefMulti7}
                                onKeyDown={(e) => {
                                  bankValueChange(e.target.value);
                                }}
                                options={privateSectorBankList}
                                className="select2-selection mb-2"
                              // isDisabled={true}
                              />
                              <span style={{ fontWeight: "500" }}>NBFCs</span>
                              <Select
                                name="financier"
                                value={selectedPrefFinancierMulti8}
                                isMulti={true}
                                onChange={handlePrefMulti8}
                                onKeyDown={(e) => {
                                  bankValueChange(e.target.value);
                                }}
                                options={NBFCList}
                                className="select2-selection"
                              // isDisabled={true}
                              />
                            </div>
                          )}
                        </Col>)}
                      </div>

                      <Row>
                        <Col sm="12">
                          <div className="d-flex flex-column flex-md-row gap-1 justify-content-end">
                            <button
                              className="btn btn-outline-secondary"
                              type="button"
                              onClick={handleCancel}
                            >
                              Cancel
                            </button>

                            {/* {for customer} */}
                            {!isApprovePermission && (
                              <button
                                type="button"
                                className="btn btn-warning save-customer"
                                onClick={() => {
                                  let status = "draftCustomer";
                                  onHandleSaveAsDraft(status);
                                }}
                              >
                                Save As Draft
                              </button>
                            )}

                            {/* {for admin} */}
                            {isApprovePermission && (
                              <button
                                type="button"
                                className="btn btn-warning save-customer"
                                onClick={() => {
                                  let status = "draftCustomer";
                                  onHandleSaveAsDraft(status);
                                }}
                              >
                                Save As Draft
                              </button>
                            )}

                            {/* {for Customer} */}
                            {!isApprovePermission && (
                              <button
                                type="button"
                                className="btn btn-success save-customer"
                                 onClick={() => {
                                  onHandleSaveAsDraft('create');
                                }}
                              >
                                Submit
                              </button>
                            )}

                            {/* {for admin} */}
                            {isApprovePermission && (
                              <button
                                type="button"
                                className="btn btn-success save-customer"
                                 onClick={() => {
                                  let status = user?.roleName == 'partner' ? 'partner': 'Submit'
                                  onHandleSaveAsDraft(status);
                                }}
                              >
                                Submit
                              </button>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Loader show={loader} type="box" message="Creating deal" />
      <Loader show={loaderDraft} type="box" message="Saving as draft" />
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      <Modal
        isOpen={refferedFinModal}
        role="<dialog>"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          setRefferedFinModal(!refferedFinModal);
        }}
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => {
              setRefferedFinModal(!refferedFinModal);
            }}
          ></ModalHeader>
        </div>
        <div className="modal-body vertical-scroll" style={{ height: "550px" }}>
          {referredFinancierList.length > 0 && (<div>
            <div className="text-success font-size-18" style={{ marginBottom: '-12px', marginTop: '-10px' }}>Recommended Financiers</div>
            <ul>
              {referredFinancierList?.map((ele, index) => (
                <li className={`font-size-16 ${index == 0 ? 'mt-3' : 'mt-2'}`} key={uId()}>{ele?.entityName}
                </li>
              ))}
            </ul>
          </div>)}
          {(referredFinancierList.length == 0) && (
            <div className="text-success font-size-18 text-center">No data found</div>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(AddDeal);

AddDeal.propTypes = {
  history: PropTypes.object,
};

const DynamicFileUploadInput = ({
  label,
  inputName,
  onDropHandler,
  validation,
  uploadProgress,
  errorMessage,
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onDropHandler,
  });

  const fileName = (filename) => {
    return filename?.substring(filename.lastIndexOf("/") + 1);
  };

  const handleLabelClick = (event) => {
    event.stopPropagation();
    document.getElementById(inputName).click();
  };

  return (
    <div>
      <Label className="col-sm-6 col-form-label mt-3 grey">{label}</Label>
      <div
        style={{
          display: "table",
          width: "100%",
          backgroundColor: "#fff",
          border: "dotted 2px #21aa47",
          borderRadius: "5px",
        }}
      >
        <div
          {...getRootProps()}
          className="text-wrapper"
          style={{ height: "70px" }}
        >
          <div className="centered">
            <Input
              type="file"
              name={inputName}
              id={inputName}
              accept=".jpg, .png, .jpeg, .pdf, .xlsx, .xls"
              {...getInputProps({
                onClick: (event) => {
                  event.stopPropagation();
                },
              })}
              style={{ display: "none" }} // Hide the actual file input
            />
            <label
              style={{
                marginBottom: 0,
                fontSize: "14px",
                cursor: "pointer",
              }}
              onClick={handleLabelClick}
            >
              <img
                src="https://scfuat.cashinvoice.in/frontend/assets/themes/image/icon/cloud.png"
                className="img-fluid"
                alt="Upload"
              />
              {isDragActive && <p className="textLink">Drop here</p>}
              <span className="textLink" style={{ padding: "5px" }}>
                Browse files to attach
              </span>
              or Drop
            </label>
          </div>
        </div>
      </div>
      {validation.touched[inputName] && validation.errors[inputName] && (
        <p className="text-danger font-size-11">
          {validation.errors[inputName]}
        </p>
      )}
      <span className="mt-2">{fileName(validation.values[inputName])}</span>
      {uploadProgress > 0 && !errorMessage && (
        <div className="progress mt-4">
          <div
            className="progress-bar bg-success"
            style={{ width: `${uploadProgress}%` }}
            aria-valuenow={uploadProgress}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {`${uploadProgress}%`}
          </div>
        </div>
      )}
      {errorMessage && (
        <div className="alert alert-danger mt-4">{errorMessage}</div>
      )}
    </div>
  );
};

const TableRow = ({ onDelete, index, validation }) => {
  const handleInputChange = (index, field, value) => {
    validation.setFieldValue(`propertyInfoList.${index}.${field}`, value);
    if (field == "state") {
      validation.setFieldValue(`propertyInfoList.${index}.city`, "");
      getCityList(value);
    }
  };

  const [natureOfPropList, setNatureOfPropList] = useState([]);
  const [statusOfPropList, setStatusOfPropList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const [uploadProgressParentDeed, setUploadProgressParentDeed] = useState(0);
  const [uploadProgressSaleDeed, setUploadProgressSaleDeed] = useState(0);
  const [uploadProgressUtilityBills, setUploadProgressUtilityBills] =
    useState(0);
  const [uploadProgressPropertyTax, setUploadProgressPropertyTax] = useState(0);

  const [errorMessageParentDeed, setErrorMessageParentDeed] = useState(null);
  const [errorMessageSaleDeed, setErrorMessageSaleDeed] = useState(null);
  const [errorMessageUtilityBills, setErrorMessageUtilityBills] =
    useState(null);
  const [errorMessagePropertyTax, setErrorMessagePropertyTax] = useState(null);

  useEffect(() => {
    getDropDownList({ dropdownName: "nature_of_property" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find(
            (dv) => dv.dropdownName == "nature_of_property"
          )?.dropdownValues || [];
        setNatureOfPropList(dropdownValues);
      })
      .catch((error) => {
        console.log(error);
      });
    getDropDownList({ dropdownName: "status_of_property" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find(
            (dv) => dv.dropdownName == "status_of_property"
          )?.dropdownValues || [];
        setStatusOfPropList(dropdownValues);
      })
      .catch((error) => {
        console.log(error);
      });
    callGetState()
      .then((response) => {
        if (response.code == "200") {
          setStateList(response.data);
        }
      })
      .catch((error) => {});
  }, []);

  const createOnDropHandler = async (acceptedFiles, cb) => {
    if (acceptedFiles[0]) {
      cb({ percentage: 0 });
      let formData = new FormData();
      formData.append("upl", acceptedFiles[0]);
      const config = {
        onUploadProgress: (progressEvent) => {
          const percentage = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          cb({ percentage });
        },
      };
      try {
        const response = await axios.post(
          `${API_URL}/s3/uploadSystemConfigFiles`,
          formData,
          config
        );
        if (response.status === 200) {
          cb({ file: response.data[0].fileName });
        } else {
          cb({ error: response.data.message });
        }
      } catch (error) {
        cb({ error: error.response.data.message });
      }
    }
  };

  const onDropForInput1 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressParentDeed(result.percentage);
      setErrorMessageParentDeed(result.error);
      validation.setFieldValue(
        `propertyInfoList.${index}.${docType}`,
        result.file
      );
    });
  });

  const onDropForInput2 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressSaleDeed(result.percentage);
      setErrorMessageSaleDeed(result.error);
      validation.setFieldValue(
        `propertyInfoList.${index}.${docType}`,
        result.file
      );
    });
  });

  const onDropForInput3 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressUtilityBills(result.percentage);
      setErrorMessageUtilityBills(result.error);
      validation.setFieldValue(
        `propertyInfoList.${index}.${docType}`,
        result.file
      );
    });
  });

  const onDropForInput4 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgressPropertyTax(result.percentage);
      setErrorMessagePropertyTax(result.error);
      validation.setFieldValue(
        `propertyInfoList.${index}.${docType}`,
        result.file
      );
    });
  });

  const getCityList = (value) => {
    callGetCity({ state: value })
      .then((response) => {
        if (response.status) {
          setCityList(response?.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Card className="mt-4">
      <CardBody>
        {validation.values?.propertyInfoList?.length > 1 && (
          <div className="text-end">
            <i
              className="bx bx-x-circle text-danger"
              onKeyUp={() => {}}
              onClick={() => onDelete(index)}
              style={{ cursor: "pointer", fontSize: "17px" }}
            />
          </div>
        )}
        <Row>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">Select Nature Of Property</Label>
            <Input
              type="select"
              placeholder="Select Nature Of Property"
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.propertyInfoList[index].propertyNature}
              onChange={(e) =>
                handleInputChange(index, "propertyNature", e.target.value)
              }
              onBlur={() => validation.setFieldTouched(`propertyInfoList[${index}].propertyNature`, true)}
              invalid={
                !!(
                  validation.touched.propertyInfoList?.[index]?.propertyNature &&
                  validation.errors.propertyInfoList?.[index]?.propertyNature
                )
              }
            >
              <option value="" disabled>
                Select Nature Of Property
              </option>
              {natureOfPropList.map((option, index) => (
                <option key={option.id} value={option.dropdownValue}>
                  {option.displayName}
                </option>
              ))}
            </Input>

            {validation.touched.propertyInfoList?.[index]?.propertyNature &&
              validation.errors.propertyInfoList?.[index]?.propertyNature && (
                <FormFeedback>
                  {validation.errors.propertyInfoList[index].propertyNature}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">
              Enter Owner of the property
            </Label>
            <Input
              type="text"
              placeholder="Enter Owner of the property"
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.propertyInfoList[index].propertyOwner}
              onChange={(e) =>
                handleInputChange(index, "propertyOwner", e.target.value)
              }
              onBlur={() => validation.setFieldTouched(`propertyInfoList[${index}].propertyOwner`, true)}
              invalid={
                !!(
                  validation.touched.propertyInfoList?.[index]?.propertyOwner &&
                  validation.errors.propertyInfoList?.[index]?.propertyOwner
                )
              }
            />
            {validation.touched.propertyInfoList?.[index]?.propertyOwner &&
              validation.errors.propertyInfoList?.[index]?.propertyOwner && (
                <FormFeedback>
                  {validation.errors.propertyInfoList[index].propertyOwner}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">
              Select Status of the property
            </Label>
            <Input
              type="select"
              placeholder="Select Status of the property"
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.propertyInfoList[index].propertyStatus}
              onChange={(e) =>
                handleInputChange(index, "propertyStatus", e.target.value)
              }
              onBlur={() => validation.setFieldTouched(`propertyInfoList[${index}].propertyStatus`, true)}
              invalid={
                !!(
                  validation.touched.propertyInfoList?.[index]?.propertyStatus &&
                  validation.errors.propertyInfoList?.[index]?.propertyStatus
                )
              }
            >
              <option value="" disabled>
                Select Nature Of Property
              </option>
              {statusOfPropList.map((option, index) => (
                <option key={option.id} value={option.dropdownValue}>
                  {option.displayName}
                </option>
              ))}
            </Input>

            {validation.touched.propertyInfoList?.[index]?.propertyStatus &&
              validation.errors.propertyInfoList?.[index]?.propertyStatus && (
                <FormFeedback>
                  {validation.errors.propertyInfoList[index].propertyStatus}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">
              Approximate value of the property
            </Label>
            <Input
              type="text"
              placeholder="Enter Approximate value of the property"
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.propertyInfoList[index].propertyValue}
              onChange={(e) =>
                handleInputChange(index, "propertyValue", e.target.value)
              }
              onBlur={(e) => {
                validation.handleBlur(e); 
              }}
              invalid={
                !!(
                  validation.touched.propertyInfoList?.[index]?.propertyValue &&
                  validation.errors.propertyInfoList?.[index]?.propertyValue
                )
              }
            />
            {validation.touched.propertyInfoList?.[index]?.propertyValue &&
              validation.errors.propertyInfoList?.[index]?.propertyValue && (
                <FormFeedback>
                  {validation.errors.propertyInfoList[index].propertyValue}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">Age of the property(Year)</Label>
            <Input
              type="text"
              placeholder="Enter Age of the property (Year)"
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.propertyInfoList[index].propertyAge}
              onChange={(e) =>
                handleInputChange(index, "propertyAge", e.target.value)
              }
              onBlur={() => validation.setFieldTouched(`propertyInfoList[${index}].propertyAge`, true)}
              invalid={
                !!(
                  validation.touched.propertyInfoList?.[index]?.propertyAge &&
                  validation.errors.propertyInfoList?.[index]?.propertyAge
                )
              }
            />
            {validation.touched.propertyInfoList?.[index]?.propertyAge &&
              validation.errors.propertyInfoList?.[index]?.propertyAge && (
                <FormFeedback>
                  {validation.errors.propertyInfoList[index].propertyAge}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">Enter Property Address</Label>
            <Input
              type="text"
              placeholder="Enter Property Address"
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.propertyInfoList[index].address}
              onChange={(e) =>
                handleInputChange(index, "address", e.target.value)
              }
              onBlur={() => validation.setFieldTouched(`propertyInfoList[${index}].address`, true)}
              invalid={
                !!(
                  validation.touched.propertyInfoList?.[index]?.address &&
                  validation.errors.propertyInfoList?.[index]?.address
                )
              }
            />
            {validation.touched.propertyInfoList?.[index]?.address &&
              validation.errors.propertyInfoList?.[index]?.address && (
                <FormFeedback>
                  {validation.errors.propertyInfoList[index].address}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">Enter Property Pincode</Label>
            <Input
              type="text"
              placeholder="Enter Property Pincode"
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.propertyInfoList[index].pincode}
              onChange={(e) =>
                handleInputChange(index, "pincode", e.target.value)
              }
              onBlur={() => validation.setFieldTouched(`propertyInfoList[${index}].pincode`, true)}
              invalid={
                !!(
                  validation.touched.propertyInfoList?.[index]?.pincode &&
                  validation.errors.propertyInfoList?.[index]?.pincode
                )
              }
            />
            {validation.touched.propertyInfoList?.[index]?.pincode &&
              validation.errors.propertyInfoList?.[index]?.pincode && (
                <FormFeedback>
                  {validation.errors.propertyInfoList[index].pincode}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-3 grey">Select State</Label>
            <Select
              options={stateList.map((option, index) => ({
                label: option.name,
                value: option.name,
              }))}
              className={`select-dropdown ${validation.touched.propertyInfoList?.[index]?.state &&
                validation.errors.propertyInfoList?.[index]?.state
                ? "is-invalid"
                : ""
                }`}
              name="state"
              id="state"
              placeholder={"Select State"}
              value={
                validation.values.propertyInfoList[index].state
                  ? {
                    label: validation.values.propertyInfoList[index].state,
                    value: validation.values.propertyInfoList[index].state,
                  }
                  : ""
              }
              onBlur={() => validation.setFieldTouched(`propertyInfoList[${index}].state`, true)}
              onChange={(e) => handleInputChange(index, "state", e.value)}
            />
            {validation.touched.propertyInfoList?.[index]?.state &&
              validation.errors.propertyInfoList?.[index]?.state && (
                <FormFeedback>
                  {validation.errors.propertyInfoList?.[index]?.state}
                </FormFeedback>
              )}
          </Col>
          <Col sm="12" md="6">
            <Label className="form-label mt-4 grey">Select City</Label>
            <Select
              options={cityList.map((option) => ({
                label: option.cityName,
                value: option.cityName,
              }))}
              className={`select-dropdown ${validation.touched.propertyInfoList?.[index]?.city &&
                validation.errors.propertyInfoList?.[index]?.city
                ? "is-invalid"
                : ""
                }`}
              name="city"
              id="city"
              onChange={(e) => handleInputChange(index, "city", e.value)}
              onBlur={() => validation.setFieldTouched(`propertyInfoList[${index}].city`, true)}
              value={
                validation.values.propertyInfoList?.[index].city
                  ? {
                    label: validation.values.propertyInfoList[index]?.city,
                    value: validation.values.propertyInfoList[index]?.city,
                  }
                  : ""
              }
            />
            {validation.touched.propertyInfoList?.[index]?.city &&
              validation.errors.propertyInfoList?.[index]?.city ? (
              <FormFeedback type="invalid">
                {validation.errors.propertyInfoList?.[index]?.city}
              </FormFeedback>
            ) : null}
          </Col>

          <Col sm="12" md="6">
            <DynamicFileUploadInputForTableRow
              label={"Parent Deed"}
              inputName={"parentDeed"}
              onDropHandler={(acceptedFiles) =>
                onDropForInput1("parentDeed", acceptedFiles)
              }
              isDragActive={true}
              validation={validation}
              uploadProgress={uploadProgressParentDeed}
              errorMessage={errorMessageParentDeed}
              index={index}
            />
          </Col>
          <Col sm="12" md="6">
            <DynamicFileUploadInputForTableRow
              label={"Sale Deed"}
              inputName={"saleDeed"}
              onDropHandler={(acceptedFiles) =>
                onDropForInput2("saleDeed", acceptedFiles)
              }
              isDragActive={true}
              validation={validation}
              uploadProgress={uploadProgressSaleDeed}
              errorMessage={errorMessageSaleDeed}
              index={index}
            />
          </Col>
          <Col sm="12" md="6">
            <DynamicFileUploadInputForTableRow
              label={"Utility Bills"}
              inputName={"utilityBills"}
              onDropHandler={(acceptedFiles) =>
                onDropForInput3("utilityBills", acceptedFiles)
              }
              isDragActive={true}
              validation={validation}
              uploadProgress={uploadProgressUtilityBills}
              errorMessage={errorMessageUtilityBills}
              index={index}
            />
          </Col>
          <Col sm="12" md="6">
            <DynamicFileUploadInputForTableRow
              label={"Property Tax"}
              inputName={"propertyTax"}
              onDropHandler={(acceptedFiles) =>
                onDropForInput4("propertyTax", acceptedFiles)
              }
              isDragActive={true}
              validation={validation}
              uploadProgress={uploadProgressPropertyTax}
              errorMessage={errorMessagePropertyTax}
              index={index}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

const DynamicFileUploadInputForTableRow = ({
  label,
  inputName,
  onDropHandler,
  validation,
  uploadProgress,
  errorMessage,
  index,
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onDropHandler,
  });

  const fileName = (filename) => {
    return filename?.substring(filename.lastIndexOf("/") + 1);
  };

  const handleLabelClick = (event) => {
    event.stopPropagation();
    document.getElementById(`${inputName}-${index}`).click();
  };

  return (
    <div>
      <Label className="col-sm-6 col-form-label mt-3 grey">{label}</Label>
      <div
        style={{
          display: "table",
          width: "100%",
          backgroundColor: "#fff",
          border: "dotted 2px #21aa47",
          borderRadius: "5px",
        }}
      >
        <div {...getRootProps()} className="text-wrapper">
          <div className="centered">
            <Input
              type="file"
              name={`${inputName}-${index}`}
              id={`${inputName}-${index}`}
              accept=".jpg, .png, .jpeg, .pdf, .xlsx, .xls"
              {...getInputProps({
                onClick: (event) => {
                  event.stopPropagation();
                },
              })}
              style={{ display: "none" }} // Hide the actual file input
            />
            <label
              style={{
                marginBottom: 0,
                fontSize: "14px",
                cursor: "pointer",
              }}
              onClick={handleLabelClick} // Custom click handler for label
            >
              <img
                src="https://scfuat.cashinvoice.in/frontend/assets/themes/image/icon/cloud.png"
                className="img-fluid"
                style={{ width: "30px" }}
                alt="Upload"
              />
              {isDragActive && <p className="textLink">Drop here</p>}
              <span className="textLink" style={{ padding: "5px" }}>
                Browse files to attach
              </span>{" "}
              or Drop
            </label>
          </div>
        </div>
      </div>
      {validation.touched.propertyInfoList?.[index]?.[inputName] &&
        validation.errors.propertyInfoList?.[index]?.[inputName] && (
          <p className="text-danger font-size-11">
            {validation.errors.propertyInfoList[index]?.[inputName]}
          </p>
        )}
      <span className="mt-2">
        {fileName(validation.values.propertyInfoList[index]?.[inputName])}{" "}
      </span>
      {uploadProgress > 0 && !errorMessage && (
        <div className="progress mt-4">
          <div
            className="progress-bar bg-success"
            style={{ width: `${uploadProgress}%` }}
            aria-valuenow={uploadProgress}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {`${uploadProgress}%`}
          </div>
        </div>
      )}
      {errorMessage && (
        <div className="alert alert-danger mt-4">{errorMessage}</div>
      )}
    </div>
  );
};

const ProductRow = ({ onDelete, index, validation, change, changeType, commercialFieldsData,callShareholdingApi,isAdmin }) => {
  const handleInputChange = (index, field, value) => {
    validation.setFieldValue(`productInfoList.${index}.${field}`, value);
  };

  const handleInputChangeSetNull = (index, field, value) => {
    validation.setFieldValue(`productInfoList.${index}.${field}`, '');
  };

  const [productTypeList, setProductTypeList] = useState([]);
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [productList, setProductList] = useState([]);
  const [isProductType, setIsProductType] = useState(false);
  const [subProductList, setSubProductList] = useState([]);
  const [isShowSubProduct, setIsShowSubProduct] = useState(false);
  const [showCommercials, setShowCommercials] = useState(false);
  const [isNVGSelected, setIsNVGSelected] = useState(false);
  const [selectedMultiSubProduct, setSelectedMultiSubProduct] = useState(
    validation.values.productInfoList?.[index]?.subProduct || []
  );

  let commonDropdown = ['Flat', 'Percentage']

  let platformDropdown = ['NVG', 'Throughput', 'Flat', 'Sanctioned Limit']

  const handleMultiSubProductChange = (selectedOptions) => {
    setSelectedMultiSubProduct(selectedOptions);
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    handleInputChange(index, "subProduct", newData);
  };

  useEffect(() => {
    getDropDownList({ dropdownName: "Product type" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Product type")
            ?.dropdownValues || [];
        setProductTypeList(dropdownValues);
      })
      .catch((error) => {});
  }, [])
  
  return (
    <Card className="mt-4">
      <CardBody>
        {validation.values?.productInfoList?.length > 1 && (
          <div className="text-end">
            <i
              className="bx bx-x-circle text-danger"
              onKeyUp={() => {}}
              onClick={() => onDelete(index)}
              style={{ cursor: "pointer", fontSize: "17px" }}
            />
          </div>
        )}

        <Row>
          <Col sm="12" md="6">
            <Label className="form-label mt-0 grey">
              Product Type*
            </Label>
            <Input
              name={`file[${index}].name`}
              id={`file[${index}].name`}
              value={validation.values.productInfoList[index].productType}
              type="select"
              onChange={(e) => {
                handleInputChange(index, "productType", e.target.value)
                setIsProductSelected(false);
                getDropDownList({ dropdownName: e.target.value })
                  .then((response) => {
                    const dropdownValues =
                      response.data?.rows?.find(
                        (dv) => dv.dropdownName == e.target.value
                      )?.dropdownValues || [];
                    setProductList(dropdownValues);
                    setIsProductType(true);
                  })
                  .catch((error) => {});
                changeType(null, e.target.value, null, index)
                handleInputChangeSetNull(index, "product", e.target.value)
                handleInputChangeSetNull(index, "subProduct", e.target.value)
              }}
              onBlur={() => validation.setFieldTouched(`productInfoList[${index}].productType`, true)}
              invalid={
                validation.touched.productInfoList?.[index]?.productType &&
                validation.errors.productInfoList?.[index]?.productType
              }
            >
              <option value="" disabled>
                Select Product type
              </option>
              {productTypeList.map((option, index) => (
                <option
                  key={option.id}
                  value={option.dropdownValue}
                >
                  {option.displayName}
                </option>
              ))}
            </Input>
            {validation.touched.productInfoList?.[index]?.productType &&
              validation.errors.productInfoList?.[index]?.productType ? (
              <FormFeedback type="invalid">
                {validation.errors.productInfoList?.[index]?.productType}
              </FormFeedback>
            ) : null}
          </Col>

          {isProductType && (
            <Col sm="12" md="6">
              <Label className="form-label mt-mobile grey">
                Select Product*
              </Label>
              <Input
                name={`file[${index}].name`}
                id={`file[${index}].name`}
                type="select"
                onChange={(e) => {
                  handleInputChange(index, "product", e.target.value);
                  setShowCommercials(true);
                  setSelectedMultiSubProduct([]);
                  if (
                    e.target.value == "Payable Financing" ||
                    e.target.value == "Receivable Financing" ||
                    e.target.value == "Inventory funding" ||
                    e.target.value == "CC/OD" ||
                    e.target.value == "Debentures"
                  ) {
                    getDropDownList({
                      dropdownName: e.target.value,
                    })
                      .then((response) => {
                        const dropdownValues =
                          response.data?.rows?.find(
                            (dv) => dv.dropdownName == e.target.value
                          )?.dropdownValues || [];
                        const formattedDropdownValues = dropdownValues.map((dv) => ({
                          label: dv.displayName,
                          value: dv.dropdownValue,
                        }));
                        setSubProductList(formattedDropdownValues);
                      })
                      .catch((error) => { });
                    setIsProductSelected(true);
                    setIsShowSubProduct(true);
                  } else {
                    setIsProductSelected(false);
                    setIsShowSubProduct(false);
                  }

                  if (e.target.value == "Equity") {
                    callShareholdingApi();
                  }

                  change(e.target.value, null, null, index);
                  handleInputChangeSetNull(index, "subProduct", e.target.value);
                }}
                value={validation.values.productInfoList[index].product}
                onBlur={() => validation.setFieldTouched(`productInfoList[${index}].product`, true)}
                invalid={
                  validation.touched.productInfoList?.[index]?.product &&
                  validation.errors.productInfoList?.[index]?.product
                }
              >
                <option value="" disabled>
                  Select Product
                </option>
                {productList.map((option, index) => (
                  <option key={option.id} value={option.dropdownValue}>
                    {option.displayName}
                  </option>
                ))}
              </Input>

              {validation.touched.productInfoList?.[index]?.product &&
                validation.errors.productInfoList?.[index]?.product ? (
                <FormFeedback type="invalid">
                  {validation.errors.productInfoList?.[index]?.product}
                </FormFeedback>
              ) : null}
            </Col>
          )}

          {isProductSelected && isShowSubProduct && (
            <Col sm="12" md="6">
              <Label className="form-label mt-3 grey">
                Select Sub Product*
              </Label>
              <Select
                name={`file[${index}].subProduct`}
                id={`file[${index}].subProduct`}
                value={selectedMultiSubProduct}
                isMulti={true}
                onChange={handleMultiSubProductChange}
                options={subProductList}
                className="select2-selection mb-2"
                onBlur={() => validation.setFieldTouched(`productInfoList[${index}].subProduct`, true)}
              />
              {validation.touched.productInfoList?.[index]?.subProduct &&
                validation.errors.productInfoList?.[index]?.subProduct ? (
                <p style={{ color: "rgb(245,116,116)", fontSize: "11px" }}>
                  {validation.errors.productInfoList?.[index]?.subProduct}
                </p>
              ) : null}
            </Col>
          )}

          <hr></hr>
          {showCommercials && isAdmin && (<Col sm="12" md="6">
            <Label className="form-label mt-2 font-size-16">
              Commercials
            </Label>
          </Col>
          )}
          {showCommercials && isAdmin && commercialFieldsData?.map((field, i) => (
            <>
              {i == 0 && (<Label className="form-label font-size-14 text-success">
                {`${(field.fieldName === "syndicationFees" && validation.values.productInfoList[index].product === "Inventory funding") ? "Gross PF" :
           (field.fieldName === "integrationFees" && validation.values.productInfoList[index].product === "Inventory funding") ? "Net PF" :
           field.fieldLabel}`}
              </Label>)}

              {i !== 0 && (<Label className="form-label mt-4 font-size-14 text-success">
                {`${(field.fieldName === "syndicationFees" && validation.values.productInfoList[index].product === "Inventory funding") ? "Gross PF" :
           (field.fieldName === "integrationFees" && validation.values.productInfoList[index].product === "Inventory funding") ? "Net PF" :
           field.fieldLabel}`}
              </Label>)}

              <Col key={field.id} sm="12" md="3">
                <Label className="form-label mt-2 font-size-12 grey">
                  Type{validation.values.productInfoList?.[index]?.product === "Inventory funding" && field.fieldName !== 'platformCharges' && (
                    <span>*</span>
                  )}
                </Label>
                <Input
                  name={`${field.fieldName}Type`}
                  type="select"
                  placeholder={`Select ${field.fieldLabel} Type`}
                  onChange={(e) => {
                    handleInputChange(index, `${field.fieldName}Type`, e.target.value)
                    if (e.target.value == 'NVG') {
                      setIsNVGSelected(true)
                    } else if (field.fieldName == 'platformCharges') {
                      setIsNVGSelected(false)
                    }
                  }} // Let Formik handle the change
                  // onBlur={validation.handleBlur}
                  onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Type`, true)}
                  value={
                    validation.values.productInfoList?.[index]?.[`${field.fieldName}Type`] ||
                    ""
                  }
                  invalid={
                    !!(validation.touched.productInfoList?.[index]?.[
                      `${field.fieldName}Type`
                    ] &&
                      validation.errors.productInfoList?.[index]?.[`${field.fieldName}Type`])
                  }
                  disabled={validation.values.prospectiveProduct === 'TradEasy' && validation.values.productInfoList?.[index]?.[`${field.fieldName}Type`] === 'Percentage'}
                >
                  <option value="" disabled>Select</option>
                  {field.fieldName == 'platformCharges' ? platformDropdown.map(option => (
                    <option key={option} value={option} disabled={validation.values.prospectiveProduct === 'TradEasy' && option !== 'Flat'}>
                    {option}</option>
                  )) : commonDropdown.map(option => (
                    <option key={option} value={option} disabled={validation.values.prospectiveProduct === 'TradEasy' && option === 'Percentage'}
                    >{option}</option>
                  ))}
                </Input>
                {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Type`] &&
                  validation.errors.productInfoList?.[index]?.[`${field.fieldName}Type`] ? (
                  <FormFeedback type="invalid">
                    {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Type`]}
                  </FormFeedback>
                ) : null}
              </Col>

              {field.fieldName == 'platformCharges' && (<>
                {isNVGSelected && (
                  <>
                    <Col sm="12" md="3">
                      <Label className="form-label mt-2 grey">
                        Benchmark
                      </Label>
                      <Input
                        name={`${field.fieldName}Benchmark`}
                        type="text"
                        placeholder={`Enter Benchmark`}
                        onChange={(e) => { handleInputChange(index, `${field.fieldName}Benchmark`, e.target.value) }}
                        // onBlur={validation.handleBlur}
                        onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Benchmark`, true)}
                        value={
                          validation.values.productInfoList?.[index]?.[
                          `${field.fieldName}Benchmark`
                          ] || ""
                        }
                        invalid={
                          !!(validation.touched.productInfoList?.[index]?.[
                            `${field.fieldName}Benchmark`
                          ] &&
                            validation.errors.productInfoList?.[index]?.[`${field.fieldName}Benchmark`])
                        }
                      />
                      {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Benchmark`] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}Benchmark`] ? (
                        <FormFeedback type="invalid">
                          {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Benchmark`]}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col sm="12" md="3">
                      <Label className="form-label mt-2 grey">
                        Benchmark Rate (%)
                      </Label>
                      <Input
                        name={`${field.fieldName}BenchmarkRate`}
                        type="text"
                        placeholder={`Enter Benchmark Rate`}
                        onChange={(e) => { handleInputChange(index, `${field.fieldName}BenchmarkRate`, e.target.value) }}
                        // onBlur={validation.handleBlur}
                        onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}BenchmarkRate`, true)}
                        value={
                          validation.values.productInfoList?.[index]?.[
                          `${field.fieldName}BenchmarkRate`
                          ] || ""
                        }
                        invalid={
                          !!(validation.touched.productInfoList?.[index]?.[
                            `${field.fieldName}BenchmarkRate`
                          ] &&
                            validation.errors.productInfoList?.[index]?.[`${field.fieldName}BenchmarkRate`])
                        }
                      />
                      {validation.touched.productInfoList?.[index]?.[`${field.fieldName}BenchmarkRate`] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}BenchmarkRate`] ? (
                        <FormFeedback type="invalid">
                          {validation.errors.productInfoList?.[index]?.[`${field.fieldName}BenchmarkRate`]}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col sm="12" md="3">
                      <Label className="form-label mt-2 grey">
                        Markup over benchmark (%)
                      </Label>
                      <Input
                        name={`${field.fieldName}MarkupOverBenchmark`}
                        type="text"
                        placeholder={`Enter Markup over benchmak`}
                        onChange={(e) => { handleInputChange(index, `${field.fieldName}MarkupOverBenchmark`, e.target.value) }}
                        // onBlur={validation.handleBlur}
                        onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}MarkupOverBenchmark`, true)}
                        value={
                          validation.values.productInfoList?.[index]?.[
                          `${field.fieldName}MarkupOverBenchmark`
                          ] || ""
                        }
                        invalid={
                          !!(validation.touched.productInfoList?.[index]?.[
                            `${field.fieldName}MarkupOverBenchmark`
                          ] &&
                            validation.errors.productInfoList?.[index]?.[`${field.fieldName}MarkupOverBenchmark`])
                        }
                      />
                      {validation.touched.productInfoList?.[index]?.[`${field.fieldName}MarkupOverBenchmark`] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}MarkupOverBenchmark`] ? (
                        <FormFeedback type="invalid">
                          {validation.errors.productInfoList?.[index]?.[`${field.fieldName}MarkupOverBenchmark`]}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </>
                )}

                <Col sm="12" md="3">
                  <Label className="form-label mt-2 grey">
                    Frequency
                  </Label>
                  <Input
                    name={`${field.fieldName}Frequency`}
                    id={`${field.fieldName}Type_${index}`}
                    type="select"
                    placeholder={`Select ${field.fieldLabel} Frequency`}
                    onChange={(e) => { handleInputChange(index, `${field.fieldName}Frequency`, e.target.value) }} // Let Formik handle the change
                    // onBlur={validation.handleBlur}
                    onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Frequency`, true)}
                    value={
                      validation.values.productInfoList?.[index]?.[`${field.fieldName}Frequency`] ||
                      ""
                    }
                    invalid={
                      !!(validation.touched.productInfoList?.[index]?.[
                        `${field.fieldName}Frequency`
                      ] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}Frequency`])
                    }
                  >
                    <option value="" disabled>Select</option>
                    <option value="Recurring" disabled={validation.values.prospectiveProduct === 'TradEasy'}>Recurring</option>
                    {/* <option value="One time">One time</option> */}
                    <option value="One time">One time</option>
                  </Input>
                  {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Frequency`] &&
                    validation.errors.productInfoList?.[index]?.[`${field.fieldName}Frequency`] ? (
                    <FormFeedback type="invalid">
                      {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Frequency`]}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="3">
                  <Label className="form-label mt-2 grey">
                    Occurrence
                  </Label>
                  <Input
                    name={`${field.fieldName}Occurrence`}
                    id={`${field.fieldName}Type_${index}`}
                    type="select"
                    placeholder={
                      validation.values.productInfoList?.[index]?.[`${field.fieldName}Time`] === "One Time"
                        ? "Not Applicable"
                        : `Select ${field.fieldLabel} Occurrence`
                    }
                    onChange={(e) => { handleInputChange(index, `${field.fieldName}Occurrence`, e.target.value) }}
                    // onBlur={validation.handleBlur}
                    onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Occurrence`, true)}
                    value={
                      validation.values.productInfoList?.[index]?.[`${field.fieldName}Frequency`] === "One time"
                        ? ""
                        : validation.values.productInfoList?.[index]?.[`${field.fieldName}Occurrence`] || ""
                    }
                    invalid={
                      !!(validation.touched.productInfoList?.[index]?.[
                        `${field.fieldName}Occurrence`
                      ] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}Occurrence`])
                    }
                    disabled={validation.values.productInfoList?.[index]?.[`${field.fieldName}Frequency`] === "One time"}
                  >
                    <option value="" disabled>{
                      validation.values[`${field.fieldName}Frequency`] === "One time"
                        ? "Not Applicable"
                        : `Select`
                    }</option>
                    <option value="Per Annum">Per Annum</option>
                    <option value="Per Month">Per Month</option>
                    <option value="At Invoice">At Invoice</option>
                    <option value="AUM">AUM</option>
                    <option value="Quarterly">Quarterly</option>
                  </Input>
                  {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Occurrence`] &&
                    validation.errors.productInfoList?.[index]?.[`${field.fieldName}Occurrence`] ? (
                    <FormFeedback type="invalid">
                      {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Occurrence`]}
                    </FormFeedback>
                  ) : null}
                </Col>

                {isNVGSelected && (<Col sm="12" md="3">
                  <Label className="form-label mt-2 grey">
                    % of NVG
                  </Label>
                  <Input
                    name={`${field.fieldName}NVG`}
                    type="text"
                    // step="0.01"
                    placeholder={`Enter ${field.fieldLabel}`}
                    onChange={(e) => { handleInputChange(index, `${field.fieldName}NVG`, e.target.value) }}
                    // onBlur={validation.handleBlur}
                    onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}NVG`, true)}
                    value={
                      validation.values.productInfoList?.[index]?.[
                      `${field.fieldName}NVG`
                      ] || ""
                    }
                    invalid={
                      !!(validation.touched.productInfoList?.[index]?.[
                        `${field.fieldName}NVG`
                      ] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}NVG`])
                    }
                  />
                  {validation.touched.productInfoList?.[index]?.[`${field.fieldName}NVG`] &&
                    validation.errors.productInfoList?.[index]?.[`${field.fieldName}NVG`] ? (
                    <FormFeedback type="invalid">
                      {validation.errors.productInfoList?.[index]?.[`${field.fieldName}NVG`]}
                    </FormFeedback>
                  ) : null}
                </Col>)}

                {!isNVGSelected && (<Col sm="12" md="3">
                  <Label className="form-label mt-2 grey">
                    Value
                    {(validation.values.productInfoList?.[index]?.[`${field.fieldName}Type`] === 'Throughput') && ' (%)'}
                  </Label>
                  <Input
                    name={`${field.fieldName}Value`}
                    type="text"
                    id={`${field.fieldName}Type_${index}`}
                    placeholder={`Enter ${field.fieldLabel}`}
                    onChange={(e) => { handleInputChange(index, `${field.fieldName}Value`, e.target.value) }}
                    // onBlur={validation.handleBlur}
                    onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Value`, true)}
                    value={
                      validation.values.productInfoList?.[index]?.[
                      `${field.fieldName}Value`
                      ] || ""
                    }
                    invalid={
                      !!(validation.touched.productInfoList?.[index]?.[
                        `${field.fieldName}Value`
                      ] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}Value`])
                    }
                  />
                  {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Value`] &&
                    validation.errors.productInfoList?.[index]?.[`${field.fieldName}Value`] ? (
                    <FormFeedback type="invalid">
                      {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Value`]}
                    </FormFeedback>
                  ) : null}
                </Col>)}
              </>)}

              {field.fieldName !== 'platformCharges' && (<>
                <Col sm="12" md="3">
                  <Label className="form-label mt-2 grey">
                    Frequency {validation.values.productInfoList?.[index]?.product === "Inventory funding" && (
                      <span>*</span>
                    )}
                  </Label>
                  <Input
                    name={`${field.fieldName}Frequency`}
                    id={`${field.fieldName}Type_${index}`}
                    type="select"
                    placeholder={`Select ${field.fieldLabel} Frequency`}
                    onChange={(e) => { handleInputChange(index, `${field.fieldName}Frequency`, e.target.value) }} // Let Formik handle the change
                    // onBlur={validation.handleBlur}
                    onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Frequency`, true)}
                    value={
                      validation.values.productInfoList?.[index]?.[`${field.fieldName}Frequency`] ||
                      ""
                    }
                    invalid={
                      !!(validation.touched.productInfoList?.[index]?.[
                        `${field.fieldName}Frequency`
                      ] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}Frequency`])
                    }
                  >
                    <option value="" disabled>Select</option>
                    <option value="Recurring" disabled={validation.values.prospectiveProduct === 'TradEasy'}>Recurring</option>
                    <option value="One time">One time</option>
                  </Input>
                  {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Frequency`] &&
                    validation.errors.productInfoList?.[index]?.[`${field.fieldName}Frequency`] ? (
                    <FormFeedback type="invalid">
                      {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Frequency`]}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="3">
                  <Label className="form-label mt-2 grey">
                    Occurrence{validation.values.productInfoList?.[index]?.product === "Inventory funding" && (
                      <span>*</span>
                    )}
                  </Label>
                  <Input
                    name={`${field.fieldName}Occurrence`}
                    id={`${field.fieldName}Type_${index}`}
                    type="select"
                    placeholder={
                      validation.values.productInfoList?.[index]?.[`${field.fieldName}Time`] === "One Time"
                        ? "Not Applicable"
                        : `Select ${field.fieldLabel} Occurrence`
                    }
                    onChange={(e) => { handleInputChange(index, `${field.fieldName}Occurrence`, e.target.value) }}
                    // onBlur={validation.handleBlur}
                    onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Occurrence`, true)}
                    value={
                      validation.values.productInfoList?.[index]?.[`${field.fieldName}Frequency`] === "One time"
                        ? ""
                        : validation.values.productInfoList?.[index]?.[`${field.fieldName}Occurrence`] || ""
                    }
                    invalid={
                      !!(validation.touched.productInfoList?.[index]?.[
                        `${field.fieldName}Occurrence`
                      ] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}Occurrence`])
                    }
                    disabled={validation.values.productInfoList?.[index]?.[`${field.fieldName}Frequency`] === "One time"}
                  >
                    <option value="" disabled>{
                      validation.values[`${field.fieldName}Frequency`] === "One time"
                        ? "Not Applicable"
                        : `Select`
                    }</option>
                    <option value="Per Annum">Per Annum</option>
                    <option value="Per Month">Per Month</option>
                    <option value="At Invoice">At Invoice</option>
                    <option value="AUM">AUM</option>
                    <option value="Quarterly">Quarterly</option>
                  </Input>
                  {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Occurrence`] &&
                    validation.errors.productInfoList?.[index]?.[`${field.fieldName}Occurrence`] ? (
                    <FormFeedback type="invalid">
                      {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Occurrence`]}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm="12" md="3">
                  <Label className="form-label mt-2 grey">
                    Value
                    {(validation.values.productInfoList?.[index]?.[`${field.fieldName}Type`] === 'Percentage') && ' (%)'}
                    {validation.values.productInfoList?.[index]?.product === "Inventory funding" && (
                      <span>*</span>
                    )}
                  </Label>
                  <Input
                    name={`${field.fieldName}Value`}
                    type="text"
                    id={`${field.fieldName}Type_${index}`}
                    placeholder={
                      validation.values.productInfoList[index].product === "Inventory funding" 
                        ? (field.fieldLabel === "Syndication Charges" ? "Enter Gross PF" : 
                           field.fieldLabel === "Integration Fees" ? "Enter Net PF" : `Enter ${field.fieldLabel}`)
                        : `Enter ${field.fieldLabel}`
                    }
                    onChange={(e) => { handleInputChange(index, `${field.fieldName}Value`, e.target.value) }}
                    // onBlur={validation.handleBlur}
                    onBlur={() => validation.setFieldTouched(`productInfoList[${index}].${field.fieldName}Value`, true)}
                    value={
                      validation.values.productInfoList?.[index]?.[
                      `${field.fieldName}Value`
                      ] || ""
                    }
                    invalid={
                      !!(validation.touched.productInfoList?.[index]?.[
                        `${field.fieldName}Value`
                      ] &&
                        validation.errors.productInfoList?.[index]?.[`${field.fieldName}Value`])
                    }
                  />
                  {validation.touched.productInfoList?.[index]?.[`${field.fieldName}Value`] &&
                    validation.errors.productInfoList?.[index]?.[`${field.fieldName}Value`] ? (
                    <FormFeedback type="invalid">
                      {validation.errors.productInfoList?.[index]?.[`${field.fieldName}Value`]}
                    </FormFeedback>
                  ) : null}
                </Col>
              </>)}
            </>
          ))}
        </Row>

      </CardBody>
    </Card>
  );
};

const TableRowShareHolding = ({
  onDelete,
  index,
  validation,
  percentageholdingValue,
}) => {
  const [shareholderType, setShareholderType] = useState([]);

  useEffect(() => {
    getDropDownList({ dropdownName: "shareholder" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "shareholder")
            ?.dropdownValues || [];
        setShareholderType(dropdownValues);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleInputChange = (index, field, value) => {
    validation.setFieldValue(`shareholderList.${index}.${field}`, value);
    if (field == "percentageHolding") {
      percentageholdingValue(+value);
    }
  };

  return (
    <tr>
      <td>
        <Input
          type="text"
          placeholder="Enter Shareholder Name"
          name={`shareholder[${index}].shareholderName`}
          id={`shareholder[${index}].shareholderName`}
          value={validation.values.shareholderList[index].shareholderName}
          onChange={(event) => {
            handleInputChange(index, "shareholderName", event.target.value);
          }}
        />
      </td>
      <td style={{ width: "30%" }}>
        <Select
          options={shareholderType.map((option, index) => ({
            label: option.displayName,
            value: option.dropdownValue,
          }))}
          className={`${
            validation.touched.shareholderList?.[index]?.shareholderType &&
            validation.errors.shareholderList?.[index]?.shareholderType
              ? "is-invalid"
              : ""
          }`}
          name={`shareholder[${index}].shareholderType`}
          id={`shareholder[${index}].shareholderType`}
          onChange={(selectedOption) => {
            handleInputChange(index, "shareholderType", selectedOption.value);
          }}
          onBlur={() => validation.setFieldTouched(`shareholderList[${index}].shareholderType`, true)}
          value={setshareholdingType(
            shareholderType,
            validation.values.shareholderList[index].shareholderType
          )}
        />
        {validation.touched.shareholderList?.[index]?.shareholderType &&
          validation.errors.shareholderList?.[index]?.shareholderType && (
            <FormFeedback>
              {validation.errors.shareholderList?.[index]?.shareholderType}
            </FormFeedback>
          )}
      </td>
      <td>
        <Input
          type="number"
          placeholder="Enter Shareholding Percentage"
          name={`shareholder[${index}].percentageHolding`}
          id={`shareholder[${index}].percentageHolding`}
          value={validation.values.shareholderList[index].percentageHolding}
          onChange={(event) => {
            handleInputChange(index, "percentageHolding", event.target.value);
          }}
          onBlur={() => validation.setFieldTouched(`shareholderList[${index}].percentageHolding`, true)}
          invalid={
            validation.touched?.shareholderList?.[index]?.percentageHolding &&
            validation.errors?.shareholderList?.[index]?.percentageHolding
              ? true
              : false
          }
        />

        {validation.touched.shareholderList?.[index]?.percentageHolding &&
          validation.errors.shareholderList?.[index]?.percentageHolding && (
            <FormFeedback>
              {validation.errors.shareholderList?.[index]?.percentageHolding}
            </FormFeedback>
          )}
      </td>
      <td>
        {validation.values?.shareholderList?.length > 1 && (
          <i
            className="bx bx-x-circle text-danger"
            onClick={() => onDelete(index)}
            style={{ cursor: "pointer", fontSize: "17px", marginTop: "10px" }}
          />
        )}
      </td>
    </tr>
  );

  function setshareholdingType(data, shareholdingType) {
    if (shareholdingType) {
      for (const item of data) {
        if (item.dropdownValue === shareholdingType) {
          const value = {
            label: `${item.displayName}`,
            value: shareholdingType,
          };
          return value;
        }
      }
    }
  }
};

let commercialFieldsData = [
  {
    id: 3,
    fieldName: "platformCharges",
    fieldLabel: "Platform Charges",
  },
  {
    id: 2,
    fieldName: "syndicationFees",
    fieldLabel: "Syndication Charges",
  },
  {
    id: 1,
    fieldName: "integrationFees",
    fieldLabel: "Integration Fees",
  },
 
  // {
  //   id: 4,
  //   fieldName: "financesCharges",
  //   fieldLabel: "Finances Charges",
  // },
  // {
  //   id: 4,
  //   fieldName: "selfFinanaces",
  //   fieldLabel: "Self Finances / Early Payment",
  // },
];
